// ═══════════════════════════════════════════════════════════════
// AGENCIAS - Módulo compartido (shared.js)
// Utilidades, constantes, Firebase helpers, estado global
// TikControl © 2024-2026
// ═══════════════════════════════════════════════════════════════

window.AgenciasShared = (function () {
  'use strict';

  // ─── SVG ICONS (inline, 16×16) ──────────────────────────────
  const ICO = {
    diamond:  '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="6 3 18 3 22 9 12 22 2 9"/><line x1="2" y1="9" x2="22" y2="9"/><line x1="12" y1="22" x2="8" y2="9"/><line x1="12" y1="22" x2="16" y2="9"/><line x1="6" y1="3" x2="10" y2="9"/><line x1="18" y1="3" x2="14" y2="9"/></svg>',
    trophy:   '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"/><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"/><path d="M4 22h16"/><path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20 7 22"/><path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20 17 22"/><path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"/></svg>',
    star:     '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>',
    users:    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>',
    calendar: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>',
    gift:     '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>',
    heart:    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>',
    file:     '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>'
  };

  // ─── CONSTANTES DE PLANES ──────────────────────────────────
  // Catálogo de planes de agencia (fuente única). Cifras de "Ventajas y
  // Servicios Agencias" (hoja 2, fila 12+). Los límites numéricos usan 9999
  // como "ilimitado" (Firestore no guarda Infinity). Cualquier valor puede
  // sobreescribirse por agencia desde el Admin de TikControl
  // (agencies/{id}.planOverrides) — ver agencyPlan().
  const UNLIMITED = 9999;
  const PLAN_ORDER = ['rookie', 'silver', 'gold', 'titanium'];
  // Packs de animaciones de agencia incluidos por plan (regalo).
  const ANIM_PACKS = {
    none:     { id: 'none',     label: 'Sin pack', items: [], changeMonths: 0 },
    basic:    { id: 'basic',    label: 'Básico',   items: ['quiereme'], changeMonths: 0 },
    standard: { id: 'standard', label: 'Standard', items: ['quiereme', 'x2', 'x3', 'guantes'], changeMonths: 12 },
    advanced: { id: 'advanced', label: 'Avanzado', items: ['quiereme', 'x2', 'x3', 'guantes', 'taptap', 'snipe', 'cofre', 'logo_effect'], changeMonths: 6 },
  };
  const ANIM_ITEMS = ['quiereme', 'x2', 'x3', 'guantes', 'taptap', 'snipe', 'cofre', 'logo_effect'];
  // Destacado en el buscador de agencias: de menos a más. Antes era un sí/no
  // (directoryHighlight); ahora el plan da un nivel y el Admin puede subirlo o
  // bajarlo por agencia. directoryHighlight se sigue publicando (= nivel > none)
  // para no romper a quien ya lo consulta.
  const HIGHLIGHT_LEVELS = {
    none:  { id: 'none',  label: 'Sin destacar', rank: 0 },
    basic: { id: 'basic', label: 'Básico',       rank: 1 },
    mid:   { id: 'mid',   label: 'Medio',        rank: 2 },
    top:   { id: 'top',   label: 'Superior',     rank: 3 },
  };
  const HIGHLIGHT_ORDER = ['none', 'basic', 'mid', 'top'];
  function highlightRank(level) {
    const h = HIGHLIGHT_LEVELS[level];
    return h ? h.rank : 0;
  }
  // Claves de features (booleanas) — el orden es el de la tarjeta del plan.
  const PLAN_FEATURE_KEYS = [
    'creatorStats', 'creatorCommunity', 'licenses', 'missionsAuto', 'missionsCustom',
    'tiktokEvents', 'agencyEvents', 'news', 'directoryListing', 'directoryHighlight',
    'fullAnalytics', 'library', 'autoTickets', 'manualTickets', 'onboarding',
    'writtenSupport', 'prioritySupport', 'overlays', 'backstageLink',
  ];
  const PLANS = {
    rookie: {
      id: 'rookie',
      label: 'Rookie',
      color: '#64748b',
      price: 350,
      priceYear: 4200,
      maxCredits: 40,
      maxProfiles: 2,
      maxManagers: 1,
      maxAutoTickets: 0,
      referralUsd: 0,
      animPack: 'none',
      highlightLevel: 'none',
      features: {
        creatorStats: true,
        creatorCommunity: false,
        licenses: true,
        missionsAuto: false,
        missionsCustom: false,
        tiktokEvents: true,
        agencyEvents: false,
        news: true,
        directoryListing: false,
        directoryHighlight: false,
        fullAnalytics: false,
        library: true,
        autoTickets: false,
        manualTickets: false,
        onboarding: true,
        writtenSupport: true,
        prioritySupport: false,
        overlays: false,
        backstageLink: true
      }
    },
    silver: {
      id: 'silver',
      label: 'Silver',
      color: '#94a3b8',
      price: 850,
      priceYear: 10200,
      maxCredits: 100,
      maxProfiles: 10,
      maxManagers: 4,
      maxAutoTickets: 0,
      referralUsd: 1,
      animPack: 'basic',
      highlightLevel: 'basic',
      features: {
        creatorStats: true,
        creatorCommunity: false,
        licenses: true,
        missionsAuto: true,
        missionsCustom: true,
        tiktokEvents: true,
        agencyEvents: true,
        news: true,
        directoryListing: true,
        directoryHighlight: true,
        fullAnalytics: true,
        library: true,
        autoTickets: false,
        manualTickets: false,
        onboarding: true,
        writtenSupport: true,
        prioritySupport: false,
        overlays: true,
        backstageLink: true
      }
    },
    gold: {
      id: 'gold',
      label: 'Gold',
      color: '#f59e0b',
      price: 1500,
      priceYear: 18000,
      maxCredits: 200,
      maxProfiles: 25,
      maxManagers: 10,
      maxAutoTickets: 100,
      referralUsd: 2,
      animPack: 'standard',
      highlightLevel: 'mid',
      features: {
        creatorStats: true,
        creatorCommunity: true,
        licenses: true,
        missionsAuto: true,
        missionsCustom: true,
        tiktokEvents: true,
        agencyEvents: true,
        news: true,
        directoryListing: true,
        directoryHighlight: true,
        fullAnalytics: true,
        library: true,
        autoTickets: true,
        manualTickets: true,
        onboarding: true,
        writtenSupport: true,
        prioritySupport: true,
        overlays: true,
        backstageLink: true
      }
    },
    titanium: {
      id: 'titanium',
      label: 'Titanium',
      color: '#8b5cf6',
      price: 2700,
      priceYear: 32400,
      maxCredits: 400,
      maxProfiles: UNLIMITED,
      maxManagers: UNLIMITED,
      maxAutoTickets: UNLIMITED,
      referralUsd: 3,
      animPack: 'advanced',
      highlightLevel: 'top',
      features: {
        creatorStats: true,
        creatorCommunity: true,
        licenses: true,
        missionsAuto: true,
        missionsCustom: true,
        tiktokEvents: true,
        agencyEvents: true,
        news: true,
        directoryListing: true,
        directoryHighlight: true,
        fullAnalytics: true,
        library: true,
        autoTickets: true,
        manualTickets: true,
        onboarding: true,
        writtenSupport: true,
        prioritySupport: true,
        overlays: true,
        backstageLink: true
      }
    }
  };
  const LIMIT_KEYS = ['maxCredits', 'maxProfiles', 'maxManagers', 'maxAutoTickets'];

  // ¿Un límite numérico es "ilimitado"? (Infinity, null o el centinela 9999).
  function isUnlimited(n) {
    return n == null || !Number.isFinite(Number(n)) || Number(n) >= UNLIMITED;
  }
  function limitLabel(n) { return isUnlimited(n) ? '∞' : String(Number(n)); }

  // Plan EFECTIVO de una agencia: catálogo del plan + overrides por agencia
  // (agencies/{id}.planOverrides = { limits:{maxCredits,...}, features:{key:bool},
  // animPack }). Los campos legacy maxCredits/maxProfiles en la raíz del doc
  // ya NO se leen: el plan manda y el Admin sobreescribe lo que haga falta.
  // ─── Prueba de plan (agencies/{id}.planTrial) ──────────────────
  // TikControl regala X días de un plan superior para que la agencia lo
  // pruebe. Mientras dura, el plan EFECTIVO es el de la prueba (con las
  // condiciones a medida encima). Al terminar vuelve solo al plan contratado.
  // Una prueba nunca puede empeorar el plan: si el contratado es igual o
  // mejor, se ignora.
  const DAY_MS = 86400000;
  function agencyTrial(agency, nowMs) {
    const raw = agency && agency.planTrial;
    if (!raw || typeof raw !== 'object') return null;
    const planId = String(raw.plan || '');
    if (!PLANS[planId]) return null;
    const endsAt = Math.trunc(Number(raw.endsAt) || 0);
    if (!endsAt) return null;
    if (planRank(planId) <= planRank(agency.plan)) return null;
    const now = Number(nowMs) || Date.now();
    const startedAt = Math.trunc(Number(raw.startedAt) || 0);
    const days = Math.max(1, Math.trunc(Number(raw.days) || 0) || Math.ceil((endsAt - (startedAt || now)) / DAY_MS));
    return {
      plan: planId,
      basePlan: String(agency.plan || 'silver'),
      startedAt,
      endsAt,
      days,
      active: endsAt > now,
      daysLeft: Math.max(0, Math.ceil((endsAt - now) / DAY_MS)),
      grantedBy: String(raw.grantedBy || ''),
    };
  }

  // ─── Margen de ajuste (agencies/{id}.planGrace) ────────────────
  // Al bajar de plan (o al quitarle la prueba) NO se bloquea nada: se guarda y
  // la agencia conserva lo que tenía durante unas horas para que el dueño lo
  // ajuste a mano (elegir qué managers deja, cerrar misiones…) o pida otra vez
  // la mejora. Pasado el margen, lo que ya no cubre su plan queda deshabilitado.
  const GRACE_DEFAULT_HOURS = 24;
  const HOUR_MS = 3600000;
  function agencyGrace(agency, nowMs) {
    const raw = agency && agency.planGrace;
    if (!raw || typeof raw !== 'object') return null;
    const from = String(raw.from || '');
    if (!PLANS[from]) return null;
    const until = Math.trunc(Number(raw.until) || 0);
    if (!until) return null;
    const now = Number(nowMs) || Date.now();
    const msLeft = Math.max(0, until - now);
    return {
      from,
      to: String(raw.to || (agency && agency.plan) || ''),
      until,
      startedAt: Math.trunc(Number(raw.startedAt) || 0),
      hours: Math.max(1, Math.trunc(Number(raw.hours) || 0) || GRACE_DEFAULT_HOURS),
      issues: Array.isArray(raw.issues) ? raw.issues : [],
      active: until > now,
      msLeft,
      hoursLeft: Math.floor(msLeft / HOUR_MS),
      minutesLeft: Math.floor((msLeft % HOUR_MS) / 60000),
    };
  }

  // "Quedan 5 h 20 min" / "Quedan 45 min" / "El margen ha terminado".
  function graceLeftLabel(grace) {
    if (!grace || !grace.active) return t('agencies_grace_over', 'El margen de ajuste ha terminado');
    if (grace.hoursLeft >= 1) {
      return t('agencies_grace_left_h', 'Quedan {h} h {m} min')
        .replace('{h}', String(grace.hoursLeft)).replace('{m}', String(grace.minutesLeft));
    }
    return t('agencies_grace_left_m', 'Quedan {m} min').replace('{m}', String(Math.max(1, grace.minutesLeft)));
  }

  function agencyPlan(agency, nowMs) {
    const trial = agencyTrial(agency, nowMs);
    // Durante el margen sigue mandando el plan que tenía: nada se corta de
    // golpe mientras el dueño se organiza.
    const grace = agencyGrace(agency, nowMs);
    const graceBase = grace && grace.active ? PLANS[grace.from] : null;
    const base = (trial && trial.active && PLANS[trial.plan]) || graceBase || PLANS[agency && agency.plan] || PLANS.silver;
    const ov = (agency && agency.planOverrides && typeof agency.planOverrides === 'object') ? agency.planOverrides : {};
    const lim = (ov.limits && typeof ov.limits === 'object') ? ov.limits : {};
    const feats = (ov.features && typeof ov.features === 'object') ? ov.features : {};
    // baseLabel = nombre de catálogo ("Rookie"); label pasa a "Rookie - Custom"
    // en cuanto el Admin fija una condición a medida. El precio NO se toca
    // nunca: sale del plan del catálogo.
    const out = { ...base, baseLabel: base.label, features: { ...base.features }, overrides: ov, hasOverrides: false };
    // Solo cuenta como condición a medida lo que DIFIERE del plan: fijar a
    // mano lo mismo que ya da el plan (p. ej. "Sin pack" en una Rookie, que ya
    // viene sin pack) deja el plan como está, no lo convierte en Custom.
    for (const k of LIMIT_KEYS) {
      const v = lim[k];
      if (v != null && v !== '' && Number.isFinite(Number(v))) {
        out[k] = Number(v);
        if (Number(v) !== Number(base[k])) out.hasOverrides = true;
      }
    }
    for (const k of Object.keys(feats)) {
      if (typeof feats[k] === 'boolean') {
        out.features[k] = feats[k];
        if (feats[k] !== base.features[k]) out.hasOverrides = true;
      }
    }
    if (ov.animPack && ANIM_PACKS[ov.animPack]) {
      out.animPack = ov.animPack;
      if (ov.animPack !== base.animPack) out.hasOverrides = true;
    }
    // Destacado en el buscador: el nivel lo da el plan y el Admin puede
    // subirlo o bajarlo por agencia (condiciones personalizadas).
    out.highlightLevel = HIGHLIGHT_LEVELS[base.highlightLevel] ? base.highlightLevel : 'none';
    if (ov.highlightLevel && HIGHLIGHT_LEVELS[ov.highlightLevel]) {
      out.highlightLevel = ov.highlightLevel;
      if (ov.highlightLevel !== base.highlightLevel) out.hasOverrides = true;
    }
    // El sí/no de siempre se deriva del nivel; si alguien forzó la feature a
    // mano (docs antiguos), manda ella y el nivel se ajusta a lo que diga.
    if (typeof feats.directoryHighlight !== 'boolean') out.features.directoryHighlight = out.highlightLevel !== 'none';
    else if (!feats.directoryHighlight) out.highlightLevel = 'none';
    else if (out.highlightLevel === 'none') out.highlightLevel = 'basic';
    // overlays (recursos del creador) = hay pack de animaciones
    if (typeof feats.overlays !== 'boolean') out.features.overlays = out.animPack !== 'none';
    if (out.hasOverrides) out.label = base.label + ' - ' + t('agencies_plan_custom', 'Custom');
    // La prueba viaja en el plan efectivo: la consola pinta la cuenta atrás y
    // el aviso de que al acabar se vuelve al plan contratado.
    out.trial = trial && trial.active ? trial : null;
    out.trialEnded = !!(trial && !trial.active);
    out.grace = grace && grace.active ? grace : null;
    // Plan al que se cae cuando termine el margen (para avisar con tiempo).
    out.graceTarget = grace && grace.active ? (PLANS[grace.to] || PLANS[agency && agency.plan] || null) : null;
    return out;
  }
  function planHas(agency, key) { return !!agencyPlan(agency).features[key]; }

  // "Te quedan 3 días" / "Te queda 1 día" / "Último día": el plural mal puesto
  // canta mucho en un aviso que el dueño ve todo el rato.
  function trialLeftLabel(daysLeft) {
    const n = Math.max(0, Math.trunc(Number(daysLeft) || 0));
    if (n <= 0) return t('agencies_trial_last_day', 'Último día de prueba');
    if (n === 1) return t('agencies_trial_day_left', 'Te queda 1 día de prueba');
    return t('agencies_trial_days_left', 'Te quedan {n} días de prueba').replace('{n}', String(n));
  }
  // Versión corta para la barra superior: "3 días" / "1 día" / "Último día".
  function trialLeftShort(daysLeft) {
    const n = Math.max(0, Math.trunc(Number(daysLeft) || 0));
    if (n <= 0) return t('agencies_trial_short_last', 'Último día');
    if (n === 1) return t('agencies_trial_short_one', '1 día');
    return t('agencies_trial_short_days', '{n} días').replace('{n}', String(n));
  }

  // ─── Uso real frente a un plan ─────────────────────────────────
  // usage = { creditsUsed, staffCount, profilesCount, activeMissions,
  //           activeAgencyEvents, ticketsAuto }. Devuelve la lista de lo que
  // el plan NO cubre (créditos asignados de más, managers, perfiles, y
  // funciones en uso que el plan no incluye). Sirve para avisar en la consola
  // y para BLOQUEAR un downgrade desde el Admin hasta que la agencia lo ajuste.
  function planUsageIssues(planObj, usage) {
    const u = usage || {};
    const out = [];
    const over = (key, used, max, label, hint) => {
      if (isUnlimited(max) || !(used > max)) return;
      out.push({ key, used, max, label, hint });
    };
    over('maxCredits', u.creditsUsed || 0, planObj.maxCredits, t('agencies_plan_credits', 'Créditos incluidos'), t('agencies_plan_fix_credits', 'Retira licencias hasta quedar dentro del tope'));
    over('maxManagers', u.staffCount || 0, planObj.maxManagers, t('agencies_plan_managers_max', 'Managers (máx.)'), t('agencies_plan_fix_managers', 'Desactiva managers/admins en Licencias › Equipos'));
    over('maxProfiles', u.profilesCount || 0, planObj.maxProfiles, t('agencies_plan_profiles', 'Perfiles LIVE'), t('agencies_plan_fix_profiles', 'Elimina perfiles LIVE hasta quedar dentro del tope'));
    const fx = planObj.features || {};
    if (!fx.missionsAuto && !fx.missionsCustom && (u.activeMissions || 0) > 0) out.push({ key: 'missions', used: u.activeMissions, max: 0, label: t('agencies_nav_missions', 'Misiones'), hint: t('agencies_plan_fix_missions', 'Finaliza o archiva las misiones activas') });
    if (!fx.agencyEvents && (u.activeAgencyEvents || 0) > 0) out.push({ key: 'agencyEvents', used: u.activeAgencyEvents, max: 0, label: t('agencies_feature_agency_events', 'Eventos de la agencia'), hint: t('agencies_plan_fix_events', 'Desactiva los eventos de agencia activos') });
    if (!fx.autoTickets && u.ticketsAuto) out.push({ key: 'autoTickets', used: 1, max: 0, label: t('agencies_plan_auto_tickets', 'Tickets automáticos'), hint: t('agencies_plan_fix_tickets', 'Pasa los tickets al modo "Con revisión"') });
    return out;
  }

  // ─── Tickets: modo de envío ───────────────────────────────────
  // 'auto' (todo sale solo) · 'approval' (todo con revisión) · 'hybrid'
  // (recomendado: automático para la lista blanca — creadores elegidos a
  // mano y/o desde un nivel — y con revisión para el resto). Sin modo
  // guardado, híbrido con la lista vacía (= todo con revisión hasta que la
  // agencia elija a quién). Sin tickets automáticos en el plan, todo va con
  // revisión, se haya guardado lo que se haya guardado.
  const TICKET_MODES = ['auto', 'approval', 'hybrid'];
  // ¿Los creadores de esta agencia pueden abrir tickets (apelaciones)? Solo
  // si su plan los incluye (a mano o automáticos: Gold y Titanium). Sin eso
  // la agencia no podría hacerlos llegar a TikTok: la pestaña Tickets ni
  // sale en la vista del creador.
  function ticketsEnabled(agency) {
    const fx = agencyPlan(agency || {}).features || {};
    return !!(fx.manualTickets || fx.autoTickets);
  }
  function ticketsModeOf(agency) {
    const eff = agencyPlan(agency || {});
    if (!(eff.features && eff.features.autoTickets)) return 'approval';
    const m = agency && agency.ticketsMode;
    return TICKET_MODES.includes(m) ? m : 'hybrid';
  }
  // agencies.ticketsWhitelist = { uids: [...], minLevel: N, quotas: { uid: n } }
  // (minLevel 0 = sin nivel). quotas = tickets automáticos al MES de cada
  // creador (entero ≥ 0); sin entrada = sin límite propio. Se renueva el día 1.
  function ticketsWhitelistOf(agency) {
    const w = (agency && agency.ticketsWhitelist) || {};
    const quotas = {};
    if (w.quotas && typeof w.quotas === 'object') {
      for (const [uid, n] of Object.entries(w.quotas)) {
        if (!uid || n === null || n === '' || !Number.isFinite(Number(n)) || Number(n) < 0) continue;
        quotas[uid] = Math.floor(Number(n));
      }
    }
    return {
      uids: Array.isArray(w.uids) ? w.uids.filter(Boolean) : [],
      minLevel: Number(w.minLevel) > 0 ? Math.floor(Number(w.minLevel)) : 0,
      quotas,
    };
  }
  // Tickets AUTOMÁTICOS (mode 'auto') de un creador abiertos en el mes
  // natural en curso (hora local). Puro: recibe la lista ya cargada.
  function ticketsAutoUsedThisMonth(tickets, uid, now) {
    if (!uid || !Array.isArray(tickets)) return 0;
    const d = now instanceof Date ? now : new Date(now == null ? Date.now() : now);
    const from = new Date(d.getFullYear(), d.getMonth(), 1).getTime();
    const to = new Date(d.getFullYear(), d.getMonth() + 1, 1).getTime();
    return tickets.filter((tk) => tk && tk.creatorUid === uid && tk.mode === 'auto'
      && Number(tk.createdAt) >= from && Number(tk.createdAt) < to).length;
  }
  // ¿El ticket de este creador sale solo? level = su nivel (null si no se sabe).
  // usedThisMonth (opcional) = sus tickets automáticos de este mes
  // (ticketsAutoUsedThisMonth): con cupo propio agotado, va a revisión. Sin
  // ese dato no se aplica el cupo (comportamiento anterior).
  function ticketGoesAuto(agency, uid, level, usedThisMonth) {
    const mode = ticketsModeOf(agency);
    if (mode !== 'hybrid') return mode === 'auto';
    const w = ticketsWhitelistOf(agency);
    const inList = !!(uid && w.uids.includes(uid)) || !!(w.minLevel && Number(level) >= w.minLevel);
    if (!inList) return false;
    if (uid && Object.prototype.hasOwnProperty.call(w.quotas, uid) && usedThisMonth != null
      && Number(usedThisMonth) >= w.quotas[uid]) return false;
    return true;
  }

  // Uso real de una agencia leído de Firestore (Admin / backoffice).
  async function loadPlanUsage(agency) {
    const id = agency && agency.id;
    const usage = { creditsUsed: 0, staffCount: 0, profilesCount: 0, activeMissions: 0, activeAgencyEvents: 0, ticketsAuto: !!agency && (agency.ticketsMode === 'auto' || agency.ticketsMode === 'hybrid') };
    if (!id) return usage;
    const d = db();
    const owner = agency.ownerId || agency.ownerUid || null;
    for (const [uid, st] of Object.entries(agency.licStaff || {})) {
      if (!st || st.active === false || uid === owner) continue;
      usage.staffCount++;
    }
    const q = async (fn) => { try { return await fn(); } catch (e) { console.warn('[Agencias] loadPlanUsage:', e.message); return null; } };
    const members = await q(() => d.collection('agency_members').where('agencyId', '==', id).get());
    if (members) members.forEach(doc => {
      const m = doc.data();
      if (!m.licenseType || m.licenseType === 'none') return;
      usage.creditsUsed += (LICENSE_TYPES[m.licenseType] || LICENSE_TYPES.premium).creditCost || 0;
    });
    const profiles = await q(() => d.collection('agency_profiles').where('agencyId', '==', id).get());
    if (profiles) usage.profilesCount = profiles.size;
    const missions = await q(() => d.collection('agency_challenges').where('agencyId', '==', id).get());
    if (missions) missions.forEach(doc => { if (missionIsOngoing(doc.data())) usage.activeMissions++; });
    const events = await q(() => d.collection('agency_events').where('agencyId', '==', id).where('active', '==', true).get());
    // Los espejos de eventos de TikTok / Backstage destacados (mirrorOf) no
    // son eventos de agencia.
    if (events) events.forEach(doc => { if (!doc.data().mirrorOf) usage.activeAgencyEvents++; });
    return usage;
  }

  // HTML de la lista de incidencias (modal del Admin / aviso en consola).
  function planIssuesHtml(issues) {
    return `<ul class="ag-plan-issues">${issues.map(i => `<li><strong>${i.label}</strong>: ${isUnlimited(i.max) ? i.used : (i.max === 0 ? t('agencies_plan_issue_in_use', 'en uso, no incluido en el plan') : `${i.used} / ${i.max}`)}${i.hint ? `<br><small>${i.hint}</small>` : ''}</li>`).join('')}</ul>`;
  }
  // Plan más bajo del catálogo que incluye la feature (para el muro
  // "Disponible desde Silver"). null si ninguno la incluye.
  function minPlanFor(featureKey) {
    for (const id of PLAN_ORDER) { if (PLANS[id].features[featureKey]) return id; }
    return null;
  }
  function planRank(planId) { const i = PLAN_ORDER.indexOf(planId); return i < 0 ? 1 : i; }

  // ─── TIPOS DE LICENCIA (Créditos) ──────────────────────────
  const LICENSE_TYPES = {
    premium: {
      id: 'premium',
      label: 'Premium (Pro)',
      creditCost: 2,
      plan: 'premium_monthly',
      description: 'Acceso completo: todos los perfiles, acciones, widgets, comunidad, batallas, eventos'
    },
    performance: {
      id: 'performance',
      label: 'Performance',
      creditCost: 1,
      plan: 'performance',
      description: 'Acceso parcial: comunidad, batallas y eventos (con la agencia)'
    }
  };

  const REGIONS = [
    // ── Europa ──
    'EU / España', 'EU / Francia', 'EU / Alemania', 'EU / Italia', 'EU / Portugal',
    'EU / Reino Unido', 'EU / Países Bajos', 'EU / Bélgica', 'EU / Austria', 'EU / Suiza',
    'EU / Polonia', 'EU / Suecia', 'EU / Noruega', 'EU / Dinamarca', 'EU / Finlandia',
    'EU / Irlanda', 'EU / República Checa', 'EU / Rumanía', 'EU / Hungría', 'EU / Grecia',
    'EU / Croacia', 'EU / Bulgaria', 'EU / Eslovaquia', 'EU / Eslovenia',
    'EU / Lituania', 'EU / Letonia', 'EU / Estonia', 'EU / Luxemburgo',
    'EU / Malta', 'EU / Chipre', 'EU / Islandia', 'EU / Serbia', 'EU / Ucrania',
    'EU / Turquía', 'EU / Rusia',
    // ── Estados Unidos y Canadá (los estados se quitaron en oct-2026:
    //    los valores antiguos "US / Texas"… los pasa a "US / Estados
    //    Unidos" AgenciasRegionGeo.normalize) ──
    'US / Estados Unidos', 'US / Canadá',
    // ── Latinoamérica ──
    'LATAM / México', 'LATAM / Argentina', 'LATAM / Colombia', 'LATAM / Chile',
    'LATAM / Perú', 'LATAM / Ecuador', 'LATAM / Venezuela', 'LATAM / Bolivia',
    'LATAM / Paraguay', 'LATAM / Uruguay', 'LATAM / Costa Rica', 'LATAM / Panamá',
    'LATAM / República Dominicana', 'LATAM / Guatemala', 'LATAM / Honduras',
    'LATAM / El Salvador', 'LATAM / Nicaragua', 'LATAM / Cuba',
    // ── Brasil ──
    'BR / Brasil',
    // ── Asia ──
    'ASIA / China', 'ASIA / Japón', 'ASIA / Corea del Sur', 'ASIA / India',
    'ASIA / Tailandia', 'ASIA / Vietnam', 'ASIA / Filipinas', 'ASIA / Indonesia',
    'ASIA / Malasia', 'ASIA / Singapur', 'ASIA / Taiwán', 'ASIA / Pakistán',
    'ASIA / Bangladesh', 'ASIA / Sri Lanka', 'ASIA / Myanmar', 'ASIA / Camboya',
    'ASIA / Nepal', 'ASIA / Mongolia', 'ASIA / Kazajistán', 'ASIA / Uzbekistán',
    'ASIA / Hong Kong', 'ASIA / Macao',
    // ── Oriente Medio ──
    'ME / Emiratos Árabes', 'ME / Arabia Saudita', 'ME / Israel', 'ME / Qatar',
    'ME / Kuwait', 'ME / Bahréin', 'ME / Omán', 'ME / Jordania', 'ME / Líbano',
    // ── África ──
    'AF / Sudáfrica', 'AF / Nigeria', 'AF / Kenia', 'AF / Egipto', 'AF / Marruecos',
    // ── Oceanía ──
    'OC / Australia', 'OC / Nueva Zelanda',
    // ── Otro ──
    'Otro'
  ];

  // ─── BADGES ──────────────────────────────────────────────
  const BADGES = [
    { id: 'verified', icon: '🛡️', label: 'agencies_badge_verified', color: '#22c55e' },
    { id: 'titanium_3m', icon: ICO.diamond, label: 'agencies_badge_titanium_3m', color: '#8b5cf6' },
    { id: 'top_agency', icon: ICO.trophy, label: 'agencies_badge_top', color: '#f59e0b' },
    { id: 'active_30d', icon: '🔥', label: 'agencies_badge_active', color: '#ef4444' },
    { id: 'recruiter', icon: ICO.users, label: 'agencies_badge_recruiter', color: '#3b82f6' },
    { id: 'early_adopter', icon: ICO.star, label: 'agencies_badge_early', color: '#eab308' }
  ];

  // ─── ESTADO GLOBAL (dinámico — todo se carga de Firebase) ──
  const state = {
    currentUser: null,
    userData: null,
    isAdmin: false,
    isAgencyOwner: false,
    isManager: false,
    isTiktokManager: false,
    tiktokManagerApprovedAgencies: [],
    // Un usuario puede llevar VARIAS agencias en cada rol. Las listas tienen
    // todas; los campos *AgencyId apuntan a la ACTIVA (la que se está viendo).
    ownerAgencyIds: [],
    managerAgencyIds: [],
    roleAgencies: {},         // agencyId → { id, name, logoUrl } de sus agencias
    // Rol en la Estructura de Licencias (agencies.licStaff), por agencia:
    // agencyId → { role, customName }. staffOnlyAgencyIds = las que entran en
    // managerAgencyIds SOLO por esa estructura (sin flag users.MANAGER_).
    staffRoles: {},
    staffOnlyAgencyIds: [],
    rolesCheckedAt: 0,        // última detección de roles completada (ms)
    managerAgencyId: null,
    ownerAgencyId: null,
    // Super Owner: rol automático de los ADMIN de TikControl (sin flags por
    // agencia). superOwnerAgencyId = agencia elegida con "Ver como Super
    // Owner" desde la vista Admin (null hasta que entra). El campo *Viewing*
    // solo está relleno mientras la consola está MONTADA en modo Super
    // Owner: lo usan los registros de actividad para firmar "TikControl".
    superOwnerAgencyId: null,
    superOwnerViewingAgencyId: null,
    // Sesión Super Owner (de entrar a salir de la agencia, aunque se cambie
    // de rol simulado) y agencia con «Modo edición» activado. Por defecto
    // ninguna: se entra SIEMPRE en solo lectura (ver superOwnerReadOnly).
    superOwnerSessionAgencyId: null,
    superOwnerEditAgencyId: null,
    userAgency: null,         // datos de la agencia a la que pertenece el usuario
    userMembership: null,     // documento de agency_members del usuario
    allAgencies: [],
    tiktokUsername: null,
    // ─── campos dinámicos ───
    pendingInvitation: null,  // invitación pendiente (status pending/invited)
    whitelistMatch: null,     // match en whitelist (email o tiktok)
    realtimeUnsubs: []        // listeners en tiempo real (Firestore onSnapshot)
  };

  // ─── FIREBASE REFS ─────────────────────────────────────────
  function db() { return window.firebase?.firestore?.(); }
  function auth() { return window.firebaseAuth; }
  function serverTimestamp() { return window.firebase?.firestore?.FieldValue?.serverTimestamp(); }
  function arrayUnion(val) { return window.firebase?.firestore?.FieldValue?.arrayUnion(val); }
  function arrayRemove(val) { return window.firebase?.firestore?.FieldValue?.arrayRemove(val); }
  function deleteField() { return window.firebase?.firestore?.FieldValue?.delete(); }

  // ─── ROLES DE AGENCIA (users/{uid}.agencyRoles) ────────────
  // { <agencyId>: 'owner' | 'manager' }. Es lo único que miran las reglas y
  // el Worker, y está protegido: solo lo escribe un ADMIN (o el Worker).
  // Las marcas legacy OWNER_<id>/MANAGER_<id>, `role` y `roles` NO cuentan
  // (el propio usuario podía escribírselas); el ADMIN las sigue poniendo con
  // agencyRolePatch() solo para que las apps anteriores pinten la consola.
  function agencyRoleOf(userData, agencyId) {
    const map = userData && userData.agencyRoles;
    if (!agencyId || !map || typeof map !== 'object' || Array.isArray(map)) return '';
    if (!Object.prototype.hasOwnProperty.call(map, agencyId)) return '';
    const r = map[agencyId];
    return r === 'owner' || r === 'manager' ? r : '';
  }
  function agencyRoleIds(userData) {
    const ownerIds = [], managerIds = [];
    const map = userData && userData.agencyRoles;
    if (map && typeof map === 'object' && !Array.isArray(map)) {
      for (const [id, r] of Object.entries(map)) {
        if (r === 'owner') ownerIds.push(id);
        else if (r === 'manager') managerIds.push(id);
      }
    }
    return { ownerIds, managerIds };
  }
  // Campos para dar (role 'owner'|'manager') o quitar (role null) el rol de
  // una agencia en un update() del doc de OTRO usuario (solo ADMIN): el mapa
  // protegido + la marca legacy equivalente.
  function agencyRolePatch(agencyId, role) {
    const patch = {};
    if (role === 'owner' || role === 'manager') {
      patch['agencyRoles.' + agencyId] = role;
      patch[(role === 'owner' ? 'OWNER_' : 'MANAGER_') + agencyId] = true;
    } else {
      patch['agencyRoles.' + agencyId] = deleteField();
      patch['OWNER_' + agencyId] = deleteField();
      patch['MANAGER_' + agencyId] = deleteField();
    }
    return patch;
  }

  // Base del Worker (ws.tikcontrol.live salvo que el main diga otra).
  function apiBase() {
    const b = window.tikcontrol?.getApiBase?.() || window.tikcontrol?.apiBase;
    return (b || 'https://ws.tikcontrol.live').replace(/\/+$/, '');
  }

  // ─── Datos de otras personas (Worker) ──────────────────────
  // El doc users/{uid} solo lo leen su dueño y el ADMIN (firestore.rules): lo
  // que Agencias pinta de otros lo da POST /api/agency/people, solo con los
  // campos que se pintan y solo a quien le toca (cf-worker/src/lib/agencyPeople.js):
  //   'roles'  → { owners, managers }: [{ uid, email, displayName }]
  //   'lookup' { usernames?, numericIds? } → { users }: [{ uid, email, tiktokUsername, tiktokNumericId }]
  //   'email'  { emails } → { users }: [{ uid, email, displayName, tiktokUsername }]
  //   'plans'  { uids } → { plans }: { uid: { plan, founders } } (plan de pago propio)
  //   'staff'  { uids } → { people }: [{ uid, displayName, photo, tiktokUsername }]
  // Tope de ids por llamada: AGENCY_PEOPLE_LIMITS (las listas largas se parten).
  // Lanza si falla: cada sitio decide qué enseña sin el dato.
  const AGENCY_PEOPLE_LIMITS = Object.freeze({ handles: 200, emails: 30, uids: 200, staff: 20 });
  async function agencyPeople(agencyId, kind, payload) {
    const user = auth() && auth().currentUser;
    if (!user || typeof user.getIdToken !== 'function') throw new Error('not_signed_in');
    const token = await user.getIdToken();
    const res = await fetch(apiBase() + '/api/agency/people', {
      method: 'POST',
      headers: { Authorization: 'Bearer ' + token, 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...(payload || {}), agencyId, kind }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data.ok === false) throw new Error(data.error || ('HTTP ' + res.status));
    return data;
  }

  // ─── Licencias de agencia (Worker) ─────────────────────────
  // Poner, quitar, proponer y soltar licencias lo hace el Worker
  // (/api/agency/license/{assign,retire,respond,release}): el cliente ya no
  // puede escribirse la licencia ni el plan. Nunca lanza: devuelve
  // { ok, status, code, error, ...respuesta }.
  async function licenseApi(action, body) {
    // Super Owner en solo lectura: los ensayos (dryRun) sí, los cambios no.
    if (!(body && body.dryRun) && superOwnerBlocks()) {
      return { ok: false, status: 0, code: 'super_owner_read_only', error: superOwnerReadOnlyText() };
    }
    try {
      const user = auth() && auth().currentUser;
      if (!user || typeof user.getIdToken !== 'function') return { ok: false, status: 0, code: 'not_signed_in', error: 'not_signed_in' };
      const token = await user.getIdToken();
      const res = await fetch(apiBase() + '/api/agency/license/' + action, {
        method: 'POST',
        headers: { Authorization: 'Bearer ' + token, 'Content-Type': 'application/json' },
        body: JSON.stringify(body || {}),
      });
      const data = await res.json().catch(() => ({}));
      return { ...data, ok: res.ok && data.ok !== false, status: res.status };
    } catch (e) {
      return { ok: false, status: 0, code: 'network', error: e.message };
    }
  }

  // ─── Bienvenida al Owner (vista Admin) ──────────────────────
  // Después de validar una agencia o de ponerle Owner, el Worker manda al
  // Owner «Tu agencia ya está activa en TikControl» (POST
  // /api/agency/owner-welcome, solo ADMIN). Él decide si toca: agencia
  // validada, Owner de verdad y una sola vez por Owner. ownerUid: un Owner
  // puesto por rol, que no figura en el doc de la agencia. Nunca lanza:
  // → { ok, validated, sent, already, skipped } o { ok:false, status, error }.
  async function sendOwnerWelcome(agencyId, ownerUid) {
    try {
      const user = auth() && auth().currentUser;
      if (!agencyId || !user || typeof user.getIdToken !== 'function') return { ok: false, status: 0, error: 'not_signed_in' };
      const res = await fetch(apiBase() + '/api/agency/owner-welcome', {
        method: 'POST',
        headers: { Authorization: 'Bearer ' + await user.getIdToken(), 'Content-Type': 'application/json' },
        body: JSON.stringify(ownerUid ? { agencyId, ownerUid } : { agencyId }),
      });
      const data = await res.json().catch(() => ({}));
      return { ...data, ok: res.ok && data.ok !== false, status: res.status };
    } catch (e) {
      return { ok: false, status: 0, error: e.message };
    }
  }

  // ─── Publicar la agencia (Owner) ────────────────────────────
  // Una agencia nueva nace sin publicar (published:false): mientras su Owner
  // la configura no la ven sus creadores ni el Explorador. Las de antes de
  // oct-2026 no tienen el campo y cuentan como publicadas.
  function agencyIsPublished(agency) {
    return !!agency && agency.published !== false;
  }
  // ¿Esta agencia todavía no existe para este usuario? Sin publicar solo la
  // ven su Owner, su staff y los ADMIN (para configurarla). Es la ÚNICA regla:
  // todo lo que le enseñe a un creador algo de su agencia pasa por aquí
  // (detectUserRole, las invitaciones en tiempo real, la pestaña Eventos).
  // `who`: los roles ya calculados; por defecto, los del estado.
  function agencyHiddenTo(agency, uid, who = state) {
    if (!agency || agencyIsPublished(agency)) return false;
    if (who.isAdmin === true) return false;
    if ((who.ownerAgencyIds || []).includes(agency.id) || (who.managerAgencyIds || []).includes(agency.id)) return false;
    if (uid && (agency.ownerId === uid || agency.ownerUid === uid)) return false;
    const staff = uid && agency.licStaff && agency.licStaff[uid];
    return !(staff && staff.active !== false);
  }
  // POST /api/agency/publish: la publica (una sola vez: no se puede deshacer
  // ni repetir), avisa por correo a sus creadores con cuenta y manda lo que
  // se retuvo mientras no estaba publicada (invitaciones y avisos de
  // licencia). El Worker va por tandas: se repite mientras queden
  // (`remaining`) y avance (`worked`).
  // opts.notifyCreators: false = sin el correo «<agencia> ya está en
  // TikControl» a sus creadores (lo elige el asistente de publicar; sin el
  // campo, el Worker avisa, como siempre). Lo retenido sale igual.
  // onProgress({ sent, remaining, round }) tras cada tanda: con la primera la
  // agencia ya está publicada (quien llama puede cerrar su ventana y dejar
  // que siga sola).
  // Cada petición tiene un tope (PUBLISH_CALL_MS): sin él, una que no
  // contestaba dejaba el botón en «Procesando…» para siempre.
  // → { ok, published, sent, heldSent, failed } (acumulados) o { ok:false,
  // published, status, error } (published: la primera tanda salió bien).
  const PUBLISH_CALL_MS = 120000;
  async function publishAgency(agencyId, onProgress, opts = {}) {
    let sent = 0, failed = 0, heldSent = 0;
    // Con una tanda que salió bien, la agencia ya está publicada aunque falle otra.
    let published = false;
    // Super Owner en solo lectura: publicar es un cambio (y manda correos).
    if (superOwnerBlocks()) return { ok: false, status: 0, code: 'super_owner_read_only', error: superOwnerReadOnlyText(), sent, failed, heldSent };
    try {
      const user = auth() && auth().currentUser;
      if (!user || typeof user.getIdToken !== 'function') return { ok: false, status: 0, error: 'not_signed_in' };
      for (let round = 0; round < 40; round++) {
        const token = await user.getIdToken();
        const body = { agencyId };
        if (typeof opts.notifyCreators === 'boolean') body.notifyCreators = opts.notifyCreators;
        const ctl = typeof AbortController === 'function' ? new AbortController() : null;
        const timer = ctl ? setTimeout(() => ctl.abort(), PUBLISH_CALL_MS) : 0;
        let res;
        try {
          res = await fetch(apiBase() + '/api/agency/publish', {
            method: 'POST',
            headers: { Authorization: 'Bearer ' + token, 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
            ...(ctl ? { signal: ctl.signal } : {}),
          });
        } finally {
          clearTimeout(timer);
        }
        const data = await res.json().catch(() => ({}));
        if (!res.ok || data.ok === false) return { ok: false, published, status: res.status, error: data.error || ('HTTP ' + res.status), sent, failed, heldSent };
        published = true;
        sent += Number(data.sent) || 0;
        failed += Number(data.failed) || 0;
        heldSent += Number(data.heldSent) || 0;
        if (typeof onProgress === 'function') { try { onProgress({ sent, remaining: Number(data.remaining) || 0, round }); } catch (_) { /* no corta el envío */ } }
        // Sin avance (todos fallan) no se insiste: quedarían en bucle. Lo que
        // quede lo retoma la consola del Owner la próxima vez que se abra.
        const worked = data.worked != null ? Number(data.worked) || 0 : Number(data.sent) || 0;
        if (!(Number(data.remaining) > 0) || !(worked > 0)) break;
      }
      return { ok: true, published, sent, failed, heldSent };
    } catch (e) {
      return { ok: false, published, status: 0, error: e.message, sent, failed, heldSent };
    }
  }

  // ─── Perfil público del staff (agency_staff_profiles) ──────
  // El nombre y la imagen con los que el Owner, un Super Admin, un Admin o
  // un Manager aparece ante los creadores de la agencia («Tu manager»,
  // Contactar, remitente de sus mensajes). Cada uno edita el suyo en la
  // consola (avatar de la barra superior › Mi perfil); sin él se ve el
  // nombre de su cuenta y la foto de su TikTok. Un doc por agencia y persona
  // ({agencia}_{uid}), con solo esos datos: lo lee cualquier creador.
  const STAFF_PROFILE_NAME_MAX = 40;
  const staffProfileLoads = new Map();   // id → Promise<perfil | null>
  const staffProfileValues = new Map();  // id → perfil | null (ya resuelto)
  const staffProfileId = (agencyId, uid) => agencyId + '_' + uid;
  function loadStaffProfile(agencyId, uid, opts = {}) {
    if (!agencyId || !uid || !db()) return Promise.resolve(null);
    const id = staffProfileId(agencyId, uid);
    if (!opts.fresh && staffProfileLoads.has(id)) return staffProfileLoads.get(id);
    const load = db().collection('agency_staff_profiles').doc(id).get()
      .then((doc) => {
        const d = doc.exists ? (doc.data() || {}) : null;
        const profile = d ? { name: String(d.name || '').trim(), photoUrl: String(d.photoUrl || ''), photoKey: d.photoKey || null } : null;
        staffProfileValues.set(id, profile);
        return profile;
      })
      .catch(() => { staffProfileLoads.delete(id); return null; });
    staffProfileLoads.set(id, load);
    return load;
  }
  // El mío, ya cargado (o null): para firmar sin esperar. La consola lo
  // carga al montarse.
  function myStaffProfile(agencyId) {
    const uid = state.currentUser && state.currentUser.uid;
    return (uid && staffProfileValues.get(staffProfileId(agencyId, uid))) || null;
  }
  async function saveStaffProfile(agencyId, profile) {
    const uid = state.currentUser && state.currentUser.uid;
    if (!agencyId || !uid) throw new Error('not_signed_in');
    const p = profile || {};
    const data = {
      agencyId, uid,
      name: String(p.name || '').trim().slice(0, STAFF_PROFILE_NAME_MAX),
      photoUrl: String(p.photoUrl || ''),
      photoKey: p.photoKey || null,
    };
    await db().collection('agency_staff_profiles').doc(staffProfileId(agencyId, uid)).set({ ...data, updatedAt: serverTimestamp() });
    const id = staffProfileId(agencyId, uid);
    const value = { name: data.name, photoUrl: data.photoUrl, photoKey: data.photoKey };
    staffProfileValues.set(id, value);
    staffProfileLoads.set(id, Promise.resolve(value));
    return value;
  }

  // Texto para el usuario de un fallo de licenseApi.
  function licenseErrorText(res) {
    const r = res || {};
    switch (r.code) {
      case 'super_owner_read_only': return superOwnerReadOnlyText();
      case 'credits': return t('agencies_no_credits_for', 'No hay créditos suficientes para esa licencia.');
      case 'kind_changed': return t('agencies_lic_err_kind_changed', 'El plan propio de este creador ha cambiado. Revísalo y vuelve a confirmar.');
      case 'busy': return t('agencies_lic_err_busy', 'Hay otro cambio de licencias en curso en la agencia. Inténtalo de nuevo en unos segundos.');
      case 'licensed_by_other_agency': return t('agencies_lic_err_other_agency', 'Este creador ya tiene una licencia de otra agencia.');
      case 'has_agency_license': return t('agencies_lc_offer_has_license', 'Este creador ya tiene una licencia de agencia.');
      case 'no_account': return t('agencies_lic_err_no_account', 'Este creador aún no tiene cuenta en TikControl.');
      case 'no_pending_offer': return t('agencies_lic_err_offer_gone', 'Esta propuesta ya no está disponible.');
      case 'already_licensed': return t('agencies_lic_err_already_licensed', 'Ya tienes una licencia de agencia.');
      case 'billing_failed':
      case 'billing_unavailable': return t('agencies_lic_err_billing', 'No se pudo actualizar el cobro en este momento. No se ha cambiado nada: inténtalo de nuevo en unos minutos.');
      default: break;
    }
    if (r.status === 403) return t('agencies_lic_err_scope', 'No tienes permiso para cambiar la licencia de este creador.');
    return t('agencies_lic_err_generic', 'No se pudo completar el cambio de licencia: {e}').replace('{e}', String(r.error || r.code || r.status || '?'));
  }

  // ─── SUPER OWNER PROTEGIDO ────────────────────────────────
  // Un ADMIN de TikControl dentro de una agencia ajena («Ver como Super
  // Owner») ve datos sensibles de otra empresa (diamantes, creadores…):
  //   · SOLO LECTURA por defecto: ninguna escritura a la agencia ni a otros
  //     usuarios (super-owner-guard.js en Firestore + superOwnerBlocks() en
  //     las llamadas al Worker) hasta pulsar «Modo edición».
  //   · Se puede capturar, pero toda la ventana lleva marca de agua con
  //     «TikControl», su email y la fecha y hora del momento (se actualiza
  //     sola): cualquier captura o foto dice quién la hizo y cuándo.
  //   · Registro de entrada/salida/edición en el Worker (admin_agency_access).
  function superOwnerReadOnly() {
    const id = state.superOwnerViewingAgencyId;
    return !!id && state.superOwnerEditAgencyId !== id;
  }
  function superOwnerReadOnlyText() {
    return t('agencies_so_readonly_blocked', 'Solo lectura: pulsa «Modo edición» arriba para cambiar algo en esta agencia.');
  }
  let superOwnerNoticeAt = 0;
  function notifySuperOwnerReadOnly() {
    if (Date.now() - superOwnerNoticeAt < 2500) return;
    superOwnerNoticeAt = Date.now();
    toast(superOwnerReadOnlyText(), 'warning');
  }
  // Para las llamadas al Worker que cambian datos: true = bloqueada (ya avisa).
  function superOwnerBlocks() {
    if (!superOwnerReadOnly()) return false;
    notifySuperOwnerReadOnly();
    return true;
  }
  function installSuperOwnerGuard() {
    const guard = window.AgenciasSuperOwnerGuard;
    const ns = window.firebase && window.firebase.firestore;
    if (!guard || !ns) return false;
    return guard.install(ns, {
      isReadOnly: superOwnerReadOnly,
      ownUid: () => (state.currentUser && state.currentUser.uid) || '',
      message: superOwnerReadOnlyText,
      onBlocked: notifySuperOwnerReadOnly,
    });
  }

  // Registro de accesos (best effort: si falla no bloquea la consola).
  async function superOwnerLog(action, agencyId, extra) {
    try {
      const user = auth() && auth().currentUser;
      if (!user || !agencyId || typeof user.getIdToken !== 'function') return;
      const token = await user.getIdToken();
      await fetch(apiBase() + '/api/agency/superowner-log', {
        method: 'POST',
        headers: { Authorization: 'Bearer ' + token, 'Content-Type': 'application/json' },
        body: JSON.stringify({ agencyId, action, ...(extra || {}) }),
      });
    } catch (_) { /* */ }
  }

  // Marca de agua sobre toda la ventana (también encima de los modales) por
  // motivos: 'superowner' (consola, solo a pantalla completa), 'adminView'
  // (modal «Ver», también fuera de ella) y 'creatorPreview' («Ver como
  // creador», que no va a pantalla completa). La fecha y la hora son las del
  // momento: se repintan cada 20 s mientras está puesta.
  const watermarkReasons = new Set();
  let watermarkTimer = null;
  function watermarkLabel() {
    const who = (state.currentUser && (state.currentUser.email || state.currentUser.uid)) || 'TikControl';
    const now = new Date();
    // En el idioma de TikControl (locale() está más abajo, en «IDIOMA DE FECHAS Y CIFRAS»).
    const loc = typeof locale === 'function' ? locale() : undefined;
    const stamp = now.toLocaleDateString(loc, { day: '2-digit', month: '2-digit', year: 'numeric' }) + ' ' + now.toLocaleTimeString(loc, { hour: '2-digit', minute: '2-digit' });
    return 'TikControl · ' + who + ' · ' + stamp;
  }
  function paintWatermark(el) {
    const label = watermarkLabel();
    el.querySelectorAll('span').forEach((span) => { if (span.textContent !== label) span.textContent = label; });
  }
  function showSuperOwnerWatermark(on, reason = 'superowner') {
    if (on) watermarkReasons.add(reason); else watermarkReasons.delete(reason);
    let el = document.getElementById('agc-so-watermark');
    if (!watermarkReasons.size) {
      if (el) el.remove();
      if (watermarkTimer) { clearInterval(watermarkTimer); watermarkTimer = null; }
      return;
    }
    if (!el) {
      el = document.createElement('div');
      el.id = 'agc-so-watermark';
      el.className = 'agc-so-watermark';
      el.setAttribute('aria-hidden', 'true');
      for (let i = 0; i < 60; i++) el.appendChild(document.createElement('span'));
      document.body.appendChild(el);
    }
    el.classList.toggle('is-always', watermarkReasons.has('adminView') || watermarkReasons.has('creatorPreview'));
    paintWatermark(el);
    if (!watermarkTimer) {
      watermarkTimer = setInterval(() => {
        const cur = document.getElementById('agc-so-watermark');
        if (cur) paintWatermark(cur);
      }, 20000);
    }
  }

  // Sesión: empieza al montar la consola de una agencia como Super Owner y
  // acaba al salir, cambiar de vista, cerrar sesión o perder el ADMIN. Los
  // cambios de rol simulado («Ver como») repintan la consola pero NO cortan
  // la sesión (ni el registro, ni el modo edición).
  function startSuperOwnerSession(agencyId) {
    if (!agencyId) return;
    installSuperOwnerGuard();
    showSuperOwnerWatermark(true);
    if (state.superOwnerSessionAgencyId === agencyId) return;
    if (state.superOwnerSessionAgencyId) superOwnerLog('exit', state.superOwnerSessionAgencyId);
    state.superOwnerSessionAgencyId = agencyId;
    state.superOwnerEditAgencyId = null;
    superOwnerLog('enter', agencyId);
  }
  function endSuperOwnerSession() {
    const id = state.superOwnerSessionAgencyId;
    showSuperOwnerWatermark(false);
    state.superOwnerEditAgencyId = null;
    state.superOwnerSessionAgencyId = null;
    if (id) superOwnerLog('exit', id);
  }
  function setSuperOwnerEdit(on) {
    const id = state.superOwnerSessionAgencyId;
    if (!id) return false;
    const next = on ? id : null;
    if (state.superOwnerEditAgencyId === next) return false;
    state.superOwnerEditAgencyId = next;
    superOwnerLog(on ? 'edit_on' : 'edit_off', id);
    return true;
  }

  // ─── i18n ──────────────────────────────────────────────────
  function t(key, fallback) {
    const val = window.i18n?.t(key);
    // Si i18n devuelve la propia key (no encontrada), usar el fallback
    if (val && val !== key) return val;
    return fallback || key;
  }

  // ─── TOAST ─────────────────────────────────────────────────
  function toast(message, type = 'info') {
    if (window.showToast) return window.showToast(message, type);
    if (window.ToastManager?.show) return window.ToastManager.show(message, type);
    // fallback
    const root = document.getElementById('toast-root');
    if (root) {
      const el = document.createElement('div');
      el.className = `toast toast-${type}`;
      el.style.cssText = 'padding:12px 20px;margin:8px;border-radius:8px;background:rgba(0,0,0,0.9);color:white;';
      el.textContent = message;
      root.appendChild(el);
      setTimeout(() => el.remove(), 4000);
    }
  }

  // ─── URL HELPERS ───────────────────────────────────────────
  //
  // Agency R2 keys can contain spaces and other reserved characters
  // (e.g. "agencies/BADGER ES/logo_xxx.jpeg"). Legacy uploads stored the
  // public URL with a literal space because the Worker's publicUrlFor() did
  // not URL-encode the key. The Worker has been fixed, but existing Firestore
  // docs still hold the unencoded form, so we normalise on the client before
  // rendering. encodeURI() is idempotent for already-encoded characters, so
  // this is safe for new properly-encoded URLs too.
  function isCloudUrl(url) {
    if (typeof url !== 'string') return false;
    const t = url.trim();
    return !!t && (t.startsWith('https://') || t.startsWith('http://'));
  }

  // ─── Formas de contacto de la agencia (para sus creadores) ─────────────
  // Modelo: agency.contactMethods = [{ type, value, label? }] (orden = orden
  // de la lista). Si la agencia aún no lo tiene, se deriva de los campos
  // sueltos de siempre (contactEmail, contactPhone, discord, website,
  // tiktokUrl/externalTiktok, instagramUrl). Aquí NO se escapa nada: lo
  // hace quien pinta. Los href solo salen como https?:, mailto: o tel:.
  const AGENCY_CONTACT_TYPES = ['whatsapp', 'telegram', 'email', 'phone', 'discord', 'tiktok', 'instagram', 'website', 'other'];
  function _contactSafeHref(h) { return /^(https?:\/\/|mailto:|tel:)/i.test(String(h || '')) ? String(h) : ''; }
  // URL http(s) válida (añade https:// si falta) o '' si no lo es.
  function _contactHttpUrl(v) {
    let s = String(v || '').trim();
    if (!s || /\s/.test(s)) return '';
    if (s.startsWith('//')) s = 'https:' + s;
    if (!/^https?:\/\//i.test(s)) {
      if (/^[a-z][a-z0-9+.-]*:/i.test(s) && !/^[^:/]+\.[^:/]+:\d/.test(s)) return ''; // otro esquema (javascript:, ftp:…)
      if (!/^[^/?#]+\.[a-z0-9-]{2,}(?:[:/?#]|$)/i.test(s)) return '';
      s = 'https://' + s;
    }
    try {
      const u = new URL(s);
      if ((u.protocol !== 'http:' && u.protocol !== 'https:') || !u.hostname.includes('.')) return '';
      return u.href;
    } catch (_) { return ''; }
  }
  function _contactLooksUrl(v) { return /^(https?:)?\/\//i.test(v) || /^[^\s@/]+\.[a-z]{2,}\//i.test(v); }
  function _contactShortUrl(href) { return String(href || '').replace(/^https?:\/\/(www\.)?/i, '').replace(/\/$/, ''); }
  // "@usuario" si la URL es de perfil (un único segmento de ruta), si no ''.
  function _contactHandleFromUrl(href) {
    try {
      const seg = new URL(href).pathname.split('/').filter(Boolean);
      return seg.length === 1 && /^@?[A-Za-z0-9._]+$/.test(seg[0]) ? '@' + seg[0].replace(/^@/, '') : '';
    } catch (_) { return ''; }
  }
  // Normaliza UNA forma de contacto → { type, value, label, display, href } o
  // null si viene vacía. display = el dato legible (número, @usuario, email,
  // dominio…); label = etiqueta propia de la agencia si la puso, si no display.
  function normalizeAgencyContact(item) {
    if (!item || typeof item !== 'object') return null;
    const type = AGENCY_CONTACT_TYPES.includes(item.type) ? item.type : 'other';
    const value = String(item.value == null ? '' : item.value).trim();
    if (!value) return null;
    const custom = String(item.label == null ? '' : item.label).trim();
    let href = '';
    let display = value;
    const social = (host, re) => {
      if (_contactLooksUrl(value) || new RegExp(host.replace('.', '\\.'), 'i').test(value)) {
        href = _contactHttpUrl(value);
        display = _contactHandleFromUrl(href) || _contactShortUrl(href || value);
      } else {
        const user = value.replace(/^@/, '');
        if (re.test(user)) { href = 'https://www.' + host + '/' + (host === 'tiktok.com' ? '@' : '') + user; display = '@' + user; }
      }
    };
    switch (type) {
      case 'whatsapp': {
        if (_contactLooksUrl(value) || /wa\.me|whatsapp\.com/i.test(value)) { href = _contactHttpUrl(value); display = _contactShortUrl(href || value); break; }
        const digits = value.replace(/\D/g, '');
        if (digits.length >= 6 && digits.length <= 15) href = 'https://wa.me/' + digits;
        break;
      }
      case 'telegram': {
        if (_contactLooksUrl(value) || /t\.me\/|telegram\.me/i.test(value)) {
          href = _contactHttpUrl(value);
          display = _contactHandleFromUrl(href) || _contactShortUrl(href || value);
          break;
        }
        const user = value.replace(/^@/, '');
        if (/^[A-Za-z0-9_]{3,32}$/.test(user)) { href = 'https://t.me/' + user; display = '@' + user; }
        break;
      }
      case 'email': {
        const mail = value.replace(/^mailto:/i, '');
        display = mail;
        if (/^[^\s@<>"']+@[^\s@<>"']+\.[^\s@<>"']{2,}$/.test(mail)) href = 'mailto:' + mail;
        break;
      }
      case 'phone': {
        const raw = value.replace(/^tel:/i, '');
        display = raw;
        const digits = raw.replace(/\D/g, '');
        if (digits.length >= 6 && digits.length <= 15) href = 'tel:' + (raw.trim().startsWith('+') ? '+' : '') + digits;
        break;
      }
      case 'tiktok': social('tiktok.com', /^[A-Za-z0-9._]{2,24}$/); break;
      case 'instagram': social('instagram.com', /^[A-Za-z0-9._]{1,30}$/); break;
      default: { // discord, website, other
        href = _contactHttpUrl(value);
        if (href) display = _contactShortUrl(href);
      }
    }
    href = _contactSafeHref(href);
    return { type, value, label: custom || display, display, href };
  }
  // Lista CRUDA para editar ({ type, value, label }): contactMethods si existe
  // (aunque esté vacía: la agencia quitó todas a propósito), si no, legacy.
  function agencyContactMethodsRaw(agency) {
    const a = agency || {};
    if (Array.isArray(a.contactMethods)) {
      return a.contactMethods
        .filter(m => m && typeof m === 'object' && String(m.value == null ? '' : m.value).trim())
        .map(m => ({ type: AGENCY_CONTACT_TYPES.includes(m.type) ? m.type : 'other', value: String(m.value).trim(), label: String(m.label == null ? '' : m.label).trim() }));
    }
    // El email marcado como oculto a creadores no entra (tampoco al precargar la consola).
    const out = [];
    const push = (type, value) => { const v = String(value == null ? '' : value).trim(); if (v) out.push({ type, value: v, label: '' }); };
    if (a.contactEmail && !a.contactEmailHidden) push('email', a.contactEmail);
    push('phone', a.contactPhone);
    push('discord', a.discord);
    push('website', a.website);
    push('tiktok', a.tiktokUrl || (a.externalTiktok ? '@' + String(a.externalTiktok).replace(/^@/, '') : ''));
    push('instagram', a.instagramUrl);
    return out;
  }
  // Lista NORMALIZADA para mostrar a creadores: [{ type, value, label, display, href }].
  // href vacío = dato sin enlace (p. ej. un usuario de Discord): se muestra/copia.
  function agencyContactMethods(agency) {
    const seen = new Set();
    const out = [];
    for (const it of agencyContactMethodsRaw(agency)) {
      const n = normalizeAgencyContact(it);
      if (!n) continue;
      const k = n.type + '|' + n.value.toLowerCase();
      if (seen.has(k)) continue;
      seen.add(k);
      out.push(n);
    }
    return out;
  }
  // Legacy S3 host patterns that still live in old Firestore docs. Any URL
  // whose host matches one of these gets rewritten to storage.tikcontrol.live
  // (the public R2 custom domain), preserving the object key.
  const _S3_HOST_RE = /^https?:\/\/tikcontrol-storage\.s3(?:[.-][^/]+)?\.amazonaws\.com/i;
  function safeImgUrl(url) {
    if (typeof url !== 'string') return url;
    // Trim first: some legacy Firestore docs have a trailing space in
    // logoUrl/bannerUrl which survives as "%20" after encoding and breaks
    // the CSP because the browser sees it as a different origin.
    let trimmed = url.trim();
    if (!trimmed.startsWith('https://') && !trimmed.startsWith('http://')) return trimmed;
    // Drop presigned-URL query params (X-Amz-Algorithm=…). The objects
    // migrated to R2 are publicly readable so the signed URL is unnecessary
    // and its embedded expiry makes the cached rows fail after 1 h.
    if (trimmed.includes('X-Amz-')) {
      trimmed = trimmed.split('?')[0];
    }
    // Rewrite legacy S3 hostnames to R2. The object key is unchanged.
    if (_S3_HOST_RE.test(trimmed)) {
      trimmed = trimmed.replace(_S3_HOST_RE, 'https://storage.tikcontrol.live');
    }
    // ── Avatares de TikTok CDN ──
    // Las URLs de avatar de TikTok caducan (x-expires) o usan plantillas
    // (~tplv-) que rompen si se sirven tal cual. Mismo tratamiento que
    // renderer/tabs/puntos/index.js::_cleanAvatarUrl para que se vean bien.
    // 1) Desenvolver weserv ya aplicado (evita doble proxy).
    for (let i = 0; i < 4 && trimmed.includes('images.weserv.nl'); i++) {
      try {
        const inner = new URL(trimmed).searchParams.get('url');
        if (!inner || inner === trimmed) break;
        trimmed = decodeURIComponent(inner);
      } catch (_) { break; }
    }
    if (trimmed.includes('X-Amz-')) trimmed = trimmed.split('?')[0];
    // 2) Avatares de TikTok → resolvedor único (url-403-interceptor.js):
    //    proxy del Worker con la firma fresca como ?src=, o lo cacheado/👤
    //    por mUri. El host "estable" p16-common y weserv ya no sirven
    //    avatares (ago-2026); una firma caducada antes devolvía ''.
    if (trimmed.includes('tiktokcdn') || trimmed.includes('tiktok.com')) {
      if (typeof window.__tcAvatarUrl === 'function') return window.__tcAvatarUrl(trimmed, '');
      return '';
    }
    try { return encodeURI(decodeURI(trimmed)); } catch (_) { return trimmed; }
  }

  // ─── IDIOMA DE FECHAS Y CIFRAS ─────────────────────────────
  // Meses, fechas y números de Agencias van con el idioma elegido en
  // TikControl, nunca con el de Windows: con `toLocaleDateString(undefined)`
  // o un 'es-ES' fijo, con la app en inglés salía «Octubre de 2026» (QA,
  // 25-oct-2026). Etiqueta BCP-47 de cada idioma de la app ('ar' a secas: con
  // 'ar-SA' el calendario sería el islámico y las cifras, arábigo-orientales).
  // Solo para lo que se ENSEÑA: las claves de mes ('YYYY-MM') y lo que se
  // guarda o se manda al Worker no pasan por aquí.
  const INTL_LOCALES = {
    en: 'en-US', es: 'es-ES', fr: 'fr-FR', de: 'de-DE', zh: 'zh-CN', ja: 'ja-JP', hi: 'hi-IN',
    ru: 'ru-RU', ar: 'ar', it: 'it-IT', id: 'id-ID', pt: 'pt-BR', ko: 'ko-KR', tr: 'tr-TR',
  };
  function appLang() {
    let lang = '';
    try { lang = (window.i18n && window.i18n.getCurrentLanguage && window.i18n.getCurrentLanguage()) || ''; } catch (_) { /* sin i18n */ }
    if (!lang) { try { lang = localStorage.getItem('tikcontrol_language') || ''; } catch (_) { /* sin almacenamiento */ } }
    lang = String(lang).toLowerCase().split(/[-_]/)[0];
    return INTL_LOCALES[lang] ? lang : 'en';
  }
  function locale() { return INTL_LOCALES[appLang()]; }
  // Fecha (ms, Date, Timestamp) con opciones de Intl en el idioma de la app.
  function formatDateWith(date, opts) {
    const d = toJsDate(date);
    if (!d) return '';
    try { return d.toLocaleDateString(locale(), opts); } catch (_) { return d.toLocaleDateString('en-US', opts); }
  }
  function formatDateTime(date, opts) {
    const d = toJsDate(date);
    if (!d) return '';
    try { return d.toLocaleString(locale(), opts); } catch (_) { return d.toLocaleString('en-US', opts); }
  }
  function formatTime(date, opts) {
    const d = toJsDate(date);
    if (!d) return '';
    const o = opts || { hour: '2-digit', minute: '2-digit' };
    try { return d.toLocaleTimeString(locale(), o); } catch (_) { return d.toLocaleTimeString('en-US', o); }
  }
  // Cifra en el idioma de la app («1,234» / «1.234» / «1 234»).
  function formatNum(n, opts) {
    const v = Number(n) || 0;
    try { return v.toLocaleString(locale(), opts); } catch (_) { return v.toLocaleString('en-US', opts); }
  }
  // Mes de una clave 'YYYY-MM' («Octubre de 2026», «October 2026», «2026年10月»).
  // style 'long' (por defecto: mes y año), 'month' (solo el mes) o 'short'
  // (mes abreviado). La primera letra va en mayúscula salvo con cap === false
  // (un mes en mitad de una frase). Día 15 en UTC: en América el día 1 a las
  // 00:00 UTC aún es el mes anterior en la hora del PC.
  function formatMonthKey(key, style, cap) {
    const [y, mo] = String(key || '').split('-').map(Number);
    if (!y || !mo) return String(key || '');
    const opts = style === 'month' ? { month: 'long', timeZone: 'UTC' }
      : style === 'short' ? { month: 'short', timeZone: 'UTC' }
      : { month: 'long', year: 'numeric', timeZone: 'UTC' };
    const loc = locale();
    let label;
    try { label = new Date(Date.UTC(y, mo - 1, 15)).toLocaleDateString(loc, opts); }
    catch (_) { return String(key); }
    return cap === false ? label : label.charAt(0).toLocaleUpperCase(loc) + label.slice(1);
  }
  function toJsDate(date) {
    if (date == null || date === '') return null;
    try {
      const secs = typeof date === 'object' && !(date instanceof Date) && !date.toDate ? (date.seconds ?? date._seconds) : null;
      const d = date.toDate ? date.toDate() : (secs != null ? new Date(secs * 1000) : new Date(date));
      return Number.isFinite(d.getTime()) ? d : null;
    } catch (_) { return null; }
  }

  // ─── FORMATTERS ────────────────────────────────────────────
  // Admite Timestamp de Firestore, Date, ms, ISO y el Timestamp ya pasado por
  // JSON ({ seconds, nanoseconds }), que es lo que queda tras clonar un doc
  // con JSON.parse(JSON.stringify(…)). Una fecha que no vale → '-'.
  function formatDate(date) {
    if (!date) return '-';
    return formatDateWith(date, { day: '2-digit', month: 'short', year: 'numeric' }) || '-';
  }

  // Contador «n/máx» de un campo con maxlength (textarea o input): se
  // actualiza al escribir y se marca al llegar al tope.
  function wireCharCounter(field, counter) {
    if (!field || !counter) return;
    const max = Number(field.maxLength) > 0 ? Number(field.maxLength) : 0;
    const paint = () => {
      const n = field.value.length;
      counter.textContent = max ? `${n}/${max}` : String(n);
      counter.classList.toggle('is-full', !!max && n >= max);
    };
    field.addEventListener('input', paint);
    paint();
  }

  // Largo máximo de la descripción de una agencia (alta, edición y vista
  // pública). Mismo tope en el Worker (lib/agencyDirectory.js).
  const AGENCY_DESCRIPTION_MAX = 2000;

  // Sin ".0" cuando la cifra es exacta: 40K, 1.5K, 2M (petición expresa).
  function formatNumber(n) {
    if (n == null) return '0';
    const short = (v) => String(+v.toFixed(1));
    if (n >= 1000000) return short(n / 1000000) + 'M';
    if (n >= 1000) return short(n / 1000) + 'K';
    return formatNum(n);
  }

  // ── Divisas de los premios en dinero (misiones específicas y automáticas).
  // Tres principales en el desplegable; cualquier otra la escribe la agencia
  // como código libre (p. ej. "MXN"). Sin divisa guardada = EUR, que es lo que
  // enseñaban los premios antes de existir el campo.
  const CURRENCIES = ['USD', 'EUR', 'GBP'];
  const CURRENCY_SYMBOLS = { USD: '$', EUR: '€', GBP: '£' };
  const DEFAULT_CURRENCY = 'EUR';
  function normCurrency(code) {
    const c = String(code == null ? '' : code).trim().toUpperCase().replace(/[^A-Z0-9$€£¥]/g, '').slice(0, 8);
    return c || DEFAULT_CURRENCY;
  }
  function currencySymbol(code) {
    const c = normCurrency(code);
    return CURRENCY_SYMBOLS[c] || c;
  }
  // "100 €", "100 $", "1.500 MXN" (sin abreviar a "1.5K": es dinero)
  function formatMoney(amount, code) {
    return `${formatNum(+amount || 0)} ${currencySymbol(code)}`;
  }

  // opts.custom = la agencia tiene condiciones a medida: se ve en la chapa
  // ("ROOKIE · Custom"), que si no enseñaba el plan de catálogo a secas.
  function formatPlanBadge(plan, opts) {
    const p = PLANS[plan] || PLANS.silver;
    const custom = !!(opts && opts.custom);
    const tag = custom ? `<small class="ag-plan-badge-custom">· ${t('agencies_plan_custom', 'Custom')}</small>` : '';
    return `<span class="ag-plan-badge ag-plan-${p.id}${custom ? ' is-custom' : ''}" style="--plan-color:${p.color}">${p.label}${tag}</span>`;
  }

  function formatStatusBadge(validated) {
    if (validated) {
      return `<span class="ag-status-badge ag-status-validated">${t('agencies_status_validated', 'Validada')}</span>`;
    }
    return `<span class="ag-status-badge ag-status-pending">${t('agencies_status_pending', 'Pendiente')}</span>`;
  }

  function truncate(text, max = 60) {
    if (!text) return '';
    return text.length > max ? text.slice(0, max) + '...' : text;
  }

  function timeSince(date) {
    if (!date) return '-';
    const d = date.toDate ? date.toDate() : new Date(date);
    const now = new Date();
    const diffMs = now - d;
    const diffH = Math.floor(diffMs / 3600000);
    const diffMin = Math.floor(diffMs / 60000);
    if (diffH < 1) {
      if (diffMin < 1) return t('agencies_time_just_now', 'ahora mismo');
      return t('agencies_time_minutes_ago', 'hace {n} min').replace('{n}', diffMin);
    }
    if (diffH < 24) return t('agencies_time_hours_ago', 'hace {n}h').replace('{n}', diffH);
    const diffD = Math.floor(diffH / 24);
    if (diffD === 1) return t('agencies_time_yesterday', 'ayer');
    return t('agencies_time_days_ago', 'hace {n}d').replace('{n}', diffD);
  }

  // ─── LANZAMIENTO ──────────────────────────────────────────
  // Agencias está abierta a todo el mundo desde la versión siguiente a la
  // 1.0.80 (Javier, 3-nov-2026). Hasta entonces solo el equipo de TikControl
  // (ADMIN) entraba en la pestaña y veía «Tu agencia» en el Inicio; el resto
  // veía el anuncio (tabs/agencias/launch/). Es la ÚNICA regla: la usan el
  // enrutador de la pestaña y el Inicio. Volver al anuncio para quien no es
  // ADMIN es devolverle `state.isAdmin !== true`.
  function launchOnly() {
    return false;
  }

  // ─── FIREBASE DATA LOADERS ────────────────────────────────
  // El listado completo solo lo usa la vista Admin (y la de TikTok Manager,
  // que lo pide ella misma si está vacío). Los demás no lo necesitan: leerlo
  // costaba una lectura por agencia cada vez que alguien abría la pestaña.
  async function loadAllAgenciesIfAdmin() {
    return state.isAdmin === true ? loadAllAgencies() : state.allAgencies;
  }

  async function loadAllAgencies() {
    try {
      const snap = await db().collection('agencies').get();
      const list = [];
      snap.forEach(doc => list.push({ id: doc.id, ...doc.data() }));
      state.allAgencies = list;
      return list;
    } catch (e) {
      console.error('[Agencias] Error cargando agencias:', e);
      return [];
    }
  }

  async function loadAgency(agencyId) {
    try {
      const doc = await db().collection('agencies').doc(agencyId).get();
      return doc.exists ? { id: doc.id, ...doc.data() } : null;
    } catch (e) {
      console.error('[Agencias] Error cargando agencia:', e);
      return null;
    }
  }

  // TODAS las agencias cuyo documento apunta a este uid como dueño (un mismo
  // usuario puede tener varias). Solo se usa como respaldo cuando no hay rol
  // 'owner' en users/{uid}.agencyRoles.
  async function loadOwnedAgencies(uid) {
    if (!uid) return [];
    const out = [];
    const seen = new Set();
    const tryOwnerField = async (field) => {
      const snap = await db().collection('agencies')
        .where(field, '==', uid)
        .limit(20)
        .get();
      snap.forEach((doc) => { if (!seen.has(doc.id)) { seen.add(doc.id); out.push({ id: doc.id, ...doc.data() }); } });
    };
    try {
      await tryOwnerField('ownerId');
      await tryOwnerField('ownerUid');
    } catch (e) {
      console.warn('[Agencias] Error cargando agencias por ownerId:', e.message);
    }
    return out;
  }

  // Agencias donde el usuario está en la Estructura de Licencias
  // (agencies/{id}.licStaff[uid]: Super Admin, Admin, Manager, Viewer o un
  // rol personalizado). Darle un rol ahí NO escribe users.MANAGER_<id> (el
  // cliente no puede tocar el doc de otro usuario), así que sin esta consulta
  // ese staff recibía el email de acceso y en el selector de vistas solo le
  // salía «Creador». Una consulta por el campo anidado (índice automático).
  async function loadStaffAgencies(uid) {
    const FieldPath = window.firebase?.firestore?.FieldPath;
    if (!uid || !db() || !FieldPath) return [];
    try {
      const snap = await db().collection('agencies')
        .where(new FieldPath('licStaff', uid, 'role'), '>', '')
        .limit(20)
        .get();
      const out = [];
      snap.forEach((doc) => {
        const ag = { id: doc.id, ...doc.data() };
        const st = ag.licStaff && ag.licStaff[uid];
        if (!st || !st.role || st.active === false || st.pendingEmail === true) return;
        out.push({ agency: ag, role: String(st.role) });
      });
      return out;
    } catch (e) {
      console.warn('[Agencias] Error cargando agencias del staff:', e.message);
      return [];
    }
  }

  // Nombre del rol de la Estructura para el selector de vistas (las mismas
  // claves que Licencias; un rol personalizado lleva el nombre que le puso la
  // agencia). Se traduce al pintar: el idioma puede cambiar después.
  const STAFF_ROLE_LABELS = {
    super_admin: ['agencies_lc_role_super', 'Super Admin'],
    admin: ['agencies_lc_role_admin', 'Admin'],
    manager: ['agencies_lc_role_manager', 'Manager'],
    viewer: ['agencies_lc_role_viewer', 'Viewer'],
  };
  function staffRoleLabel(role, customName) {
    const k = STAFF_ROLE_LABELS[role];
    if (k) return t(k[0], k[1]);
    return customName || t('agencies_view_manager', 'Manager');
  }

  // ─── AGENCIA ACTIVA POR ROL ────────────────────────────────
  // Con varias agencias en el mismo rol, la elegida se recuerda entre sesiones.
  const ACTIVE_AGENCY_KEYS = { owner: 'tc_agc_active_owner', manager: 'tc_agc_active_manager' };

  function pickActiveAgency(role, ids) {
    if (!ids || !ids.length) return null;
    let saved = null;
    try { saved = localStorage.getItem(ACTIVE_AGENCY_KEYS[role]); } catch (_) { /* noop */ }
    return (saved && ids.includes(saved)) ? saved : ids[0];
  }

  // Carga nombre/logo de todas las agencias del usuario para poder listarlas.
  // target: el estado a rellenar (detectUserRole pasa el que está calculando).
  async function loadRoleAgencies(target = state) {
    const ids = [...new Set([...(target.ownerAgencyIds || []), ...(target.managerAgencyIds || [])])];
    await Promise.all(ids.map(async (id) => {
      if (target.roleAgencies[id]) return;
      const ag = await loadAgency(id);
      if (ag) target.roleAgencies[id] = { id: ag.id, name: ag.name || id, logoUrl: ag.logoUrl || '' };
    }));
    return target.roleAgencies;
  }

  // Cambia la agencia activa de un rol (desde el selector "Tus agencias").
  // Devuelve true si el cambio es válido; el router re-renderiza después.
  async function setActiveRoleAgency(role, agencyId) {
    const list = role === 'manager' ? state.managerAgencyIds : state.ownerAgencyIds;
    if (!agencyId || !Array.isArray(list) || !list.includes(agencyId)) return false;
    if (role === 'manager') state.managerAgencyId = agencyId;
    else state.ownerAgencyId = agencyId;
    try { localStorage.setItem(ACTIVE_AGENCY_KEYS[role], agencyId); } catch (_) { /* noop */ }
    // Solo se refresca el nombre para el selector. userAgency/userMembership NO
    // se tocan a propósito: describen la agencia donde el usuario es CREADOR
    // (data.agencyId), que puede no ser ninguna de las que gestiona. La consola
    // carga su propia agencia a partir del id activo.
    const ag = await loadAgency(agencyId);
    if (ag) state.roleAgencies[agencyId] = { id: ag.id, name: ag.name || agencyId, logoUrl: ag.logoUrl || '' };
    return true;
  }

  // Nombre legible de una agencia del usuario (para etiquetas del selector).
  function roleAgencyName(agencyId) {
    if (!agencyId) return '';
    const r = state.roleAgencies[agencyId];
    if (r && r.name) return r.name;
    if (state.userAgency && state.userAgency.id === agencyId) return state.userAgency.name || agencyId;
    return agencyId;
  }

  async function loadAgencyMembers(agencyId) {
    try {
      const snap = await db().collection('agency_members')
        .where('agencyId', '==', agencyId)
        .where('status', '==', 'approved')
        .get();
      const members = [];
      snap.forEach(doc => members.push({ id: doc.id, ...doc.data() }));
      return members;
    } catch (e) {
      console.error('[Agencias] Error cargando miembros:', e);
      return [];
    }
  }

  async function refreshAgencyStats(agencyId) {
    if (!agencyId) return;
    try {
      const members = await loadAgencyMembers(agencyId);
      await db().collection('agencies').doc(agencyId).update({
        'stats.totalMembers': members.length,
        'stats.activeMembers': members.length,
        updatedAt: serverTimestamp()
      });
    } catch (e) {
      console.warn('[Agencias] Error actualizando stats:', e.message);
    }
  }

  async function loadAgencyEvents(agencyId, activeOnly = true) {
    try {
      let query = db().collection('agency_events').where('agencyId', '==', agencyId);
      if (activeOnly) query = query.where('active', '==', true);
      const snap = await query.get();
      const events = [];
      // El espejo de un evento del catálogo de TikTok destacado (mirrorOf
      // 'tik:…') sobra aquí: quien llama ya pinta tiktok_events.
      snap.forEach(doc => { const d = doc.data(); if (!String(d.mirrorOf || '').startsWith('tik:')) events.push({ id: doc.id, ...d }); });
      return events;
    } catch (e) {
      console.error('[Agencias] Error cargando eventos:', e);
      return [];
    }
  }

  async function loadTiktokEvents() {
    try {
      const snap = await db().collection('tiktok_events').limit(100).get();
      const events = [];
      snap.forEach(doc => events.push({ id: doc.id, ...doc.data() }));
      return events;
    } catch (e) {
      console.error('[Agencias] Error cargando eventos TikTok:', e);
      return [];
    }
  }

  async function loadUserStats(userId) {
    try {
      const doc = await db().collection('user_stats').doc(userId).get();
      return doc.exists ? doc.data() : null;
    } catch (e) {
      console.error('[Agencias] Error cargando stats:', e);
      return null;
    }
  }

  // opts.giftId: para el tipo 'gift' (regalos concretos recibidos en LIVE).
  function calculateMissionProgress(challengeType, goalValue, userStats, startDate, endDate, opts) {
    if (!goalValue || goalValue <= 0 || !userStats) return null;
    const giftId = (opts && opts.giftId != null) ? String(opts.giftId) : null;
    const daily = userStats.dailyStats || {};
    const sDate = startDate?.toDate ? startDate.toDate() : (startDate ? new Date(startDate) : null);
    const eDate = endDate?.toDate ? endDate.toDate() : (endDate ? new Date(endDate) : new Date());
    const today = new Date();
    const end = eDate && eDate < today ? eDate : today;

    const startStr = sDate ? sDate.toISOString().split('T')[0] : null;
    const endStr = end.toISOString().split('T')[0];
    const inRange = (dateStr) => {
      if (!startStr) return true;
      return dateStr >= startStr && dateStr <= endStr;
    };

    let current = 0;
    switch (challengeType) {
      case 'diamonds':
        Object.entries(daily).forEach(([d, s]) => { if (inRange(d)) current += (s.diamonds || 0); });
        break;
      case 'battles':
        Object.entries(daily).forEach(([d, s]) => { if (inRange(d)) current += (s.battles || 0); });
        break;
      case 'battleDiamonds':
        Object.entries(daily).forEach(([d, s]) => { if (inRange(d)) current += (s.battleDiamonds || 0); });
        break;
      case 'hours':
        Object.entries(daily).forEach(([d, s]) => { if (inRange(d)) current += (s.streamMinutes || 0); });
        current = Math.round(current / 60);
        break;
      case 'days': {
        Object.keys(daily).forEach(d => { if (inRange(d)) current++; });
        break;
      }
      case 'followers':
        Object.entries(daily).forEach(([d, s]) => { if (inRange(d)) current += (s.follows || 0); });
        break;
      case 'gift':
        if (!giftId) return null;
        Object.entries(daily).forEach(([d, s]) => { if (inRange(d) && s.giftCounts) current += (s.giftCounts[giftId] || 0); });
        break;
      default:
        return null;
    }
    const percentage = Math.min(100, (current / goalValue) * 100);
    return { current, goal: goalValue, percentage };
  }

  // Progreso multi-objetivo: además del objetivo principal (challengeType),
  // la misión puede exigir a la vez días válidos (goalDays), horas LIVE
  // (goalHours) y/o diamantes (goalDiamonds) — la constancia del modal o las
  // misiones automáticas combinadas. Manda el PEOR progreso (la misión solo
  // se completa cuando todos los objetivos llegan); `parts` trae el desglose.
  // Objetivos SECUNDARIOS de una misión, en orden: [tipo, meta]. Reúne los
  // campos sueltos de las automáticas (goalDays/goalHours/goalDiamonds), el
  // segundo objetivo del editor clásico (secondaryType/goalValue2) y la lista
  // secondaryGoals del modal de misiones específicas (hasta 3). Nunca repite
  // el tipo principal ni un tipo ya listado.
  // Cada entrada es [tipo, meta, opts] (opts.giftTarget en regalos).
  function missionSecondaryGoals(ch) {
    const type = ch.challengeType || 'custom';
    const out = [];
    const seen = new Set([type]);
    const push = (t, g, o) => { if (!seen.has(t) && +g > 0) { seen.add(t); out.push([t, +g, o || {}]); } };
    push('days', ch.goalDays);
    push('hours', ch.goalHours);
    push('diamonds', ch.goalDiamonds);
    if (ch.secondaryType) push(ch.secondaryType, ch.goalValue2);
    (Array.isArray(ch.secondaryGoals) ? ch.secondaryGoals : []).forEach(sg => {
      if (!sg) return;
      // Misión secundaria del modal (por tipo de misión): la constancia
      // aporta días + horas; el regalo lleva su regalo objetivo.
      if (sg.kind === 'live_activity') { push('days', sg.goal); push('hours', sg.goalHours); return; }
      if (sg.kind === 'gift') { push('gift', sg.goal, { giftTarget: sg.giftTarget || null }); return; }
      if (sg.type) push(sg.type, sg.goal);
    });
    return out;
  }

  // ─── Estado de una misión (regla ÚNICA) ───────────────────────
  // No hay campo status: se deriva de archived / draft / fechas / active.
  // Antes cada pantalla lo calculaba a su manera y la tabla de Creadores
  // contaba como "activa" cualquier misión no pausada (terminadas por fecha,
  // borradores, archivadas y programadas incluidas) mientras el creador y
  // Misiones específicas solo veían las EN CURSO.
  function missionToMs(v) {
    if (!v) return 0;
    try {
      if (typeof v === 'number') return v;
      if (typeof v.toMillis === 'function') return v.toMillis();
      if (typeof v.toDate === 'function') return v.toDate().getTime();
      const ms = new Date(v.seconds ? v.seconds * 1000 : v).getTime();
      return Number.isFinite(ms) ? ms : 0;
    } catch (_) { return 0; }
  }
  // Fin efectivo: una fecha a las 00:00 (solo día) cubre ese día entero.
  function missionEndMs(c) {
    const raw = missionToMs(c.endDate);
    if (!raw) return 0;
    const d = new Date(raw);
    if (d.getHours() === 0 && d.getMinutes() === 0 && d.getSeconds() === 0) return raw + 86399999;
    return raw;
  }
  // 'archived' | 'draft' | 'completed' | 'scheduled' | 'paused' | 'active'
  function missionStatus(c, now) {
    const at = now || Date.now();
    if (c.archived === true) return 'archived';
    if (c.draft === true) return 'draft';
    const start = missionToMs(c.startDate), end = missionEndMs(c);
    if (end && end < at) return 'completed';
    if (start && start > at) return 'scheduled';
    if (c.active === false) return 'paused';
    return 'active';
  }
  // ¿Está en curso ahora mismo? (lo que cuenta como "activa" en todas partes)
  function missionIsOngoing(c, now) { return missionStatus(c, now) === 'active'; }

  // ─── Plazo relativo (misión «Ver formación») ──────────────────
  // deadlineMode 'relative' + relativeDays (7 = «1 semana desde que se une»):
  // la misión no tiene endDate común (sigue en curso para la agencia) y cada
  // creador tiene su propio plazo = fecha de unión (approvedAt → joinedAt →
  // createdAt de su agency_members) + N días, hasta el final de ese día.
  // Quien ya estaba en la agencia cuando se creó la misión cuenta desde el
  // inicio de la misión: si no, nacería vencida.
  const RELATIVE_DAYS_DEFAULT = 7;
  function missionIsRelative(c) { return !!c && c.deadlineMode === 'relative'; }
  function missionRelativeDays(c) {
    const n = Math.round(+(c && c.relativeDays));
    return n >= 1 && n <= 365 ? n : RELATIVE_DAYS_DEFAULT;
  }
  function memberJoinedMs(member) {
    return member ? (missionToMs(member.approvedAt) || missionToMs(member.joinedAt) || missionToMs(member.createdAt)) : 0;
  }
  // Fin del plazo de ESE creador (ms, fin del día) · 0 si no se puede saber.
  // Con fecha fija, el fin de la misión (missionEndMs).
  function missionMemberDeadlineMs(c, member) {
    if (!missionIsRelative(c)) return missionEndMs(c);
    const from = Math.max(memberJoinedMs(member), missionToMs(c.startDate) || missionToMs(c.createdAt));
    if (!from) return 0;
    const end = new Date(from + missionRelativeDays(c) * 864e5);
    end.setHours(23, 59, 59, 999);
    return end.getTime();
  }
  // La misión tal y como la vive ESE creador: con plazo relativo, su propio
  // endDate (así missionStatus, «Quedan N días» y las fechas del detalle
  // funcionan sin tocarlos). Sin datos del miembro, tal cual.
  function missionForMember(c, member) {
    if (!missionIsRelative(c) || !member) return c;
    const end = missionMemberDeadlineMs(c, member);
    return end ? { ...c, endDate: new Date(end) } : c;
  }
  // Las misiones relativas guardan la audiencia de su formación
  // (courseAudience): quien entre después en ella también la recibe, aunque
  // no estuviera en targetCreators al crearla. viewer: { uid, level, tagIds,
  // groupIds } (como audienceIncludes).
  // «1 semana desde que se une» · «10 días desde que se une».
  function relativeDeadlineLabel(c) {
    const n = missionRelativeDays(c);
    return n === 7
      ? t('agencies_ms_rel_week', '1 semana desde que se une a la agencia')
      : t('agencies_ms_rel_days', '{n} días desde que se une a la agencia').replace('{n}', n);
  }
  function missionIncludesViewer(c, viewer) {
    if (!viewer || !viewer.uid) return false;
    if (missionIncludes(c, viewer.uid)) return true;
    return missionIsRelative(c) && !!c.courseAudience && typeof c.courseAudience === 'object' && audienceIncludes(c.courseAudience, viewer);
  }

  // ─── Destinatarios de una misión (regla ÚNICA) ────────────────
  // Los docs de agency_challenges guardan el alcance de tres formas según
  // quién los creó: targetCreators + scope ('creator' / 'agency') en las
  // específicas del modal nuevo, creatorIds + assignedTo ('selected' /
  // 'all') en las automáticas y el editor antiguo, y nada en las globales
  // legacy. Creadores decidía con "sin assignedTo = para todos" y contaba
  // las específicas nuevas a TODA la cartera; Misiones usaba otra regla.
  // Devuelve null si la misión es para toda la agencia; si no, los uids.
  function missionTargetUids(c) {
    const targeted = (Array.isArray(c.targetCreators) && c.targetCreators.length) ? c.targetCreators
      : (Array.isArray(c.creatorIds) && c.creatorIds.length) ? c.creatorIds : null;
    if (targeted) return targeted.slice();
    const isAll = c.scope === 'agency' || c.assignedTo === 'all' || (c.scope == null && c.assignedTo == null);
    return isAll ? null : [];
  }
  // ¿La misión va dirigida a este creador?
  function missionIncludes(c, uid) {
    const targets = missionTargetUids(c);
    return targets === null || targets.includes(uid);
  }
  // ¿La misión es global o alcanza a alguno de estos creadores? (alcance de
  // managers/admins: Set de uids/ids de su cartera)
  function missionTouches(c, keys) {
    const targets = missionTargetUids(c);
    return targets === null || targets.some(u => keys.has(u));
  }

  function calculateMissionProgressFull(ch, userStats) {
    const type = ch.challengeType || 'custom';
    const goalValue = +ch.goalValue || parseInt(ch.goal, 10) || 0;
    const extras = missionSecondaryGoals(ch);
    const base = calculateMissionProgress(type, goalValue, userStats, ch.startDate, ch.endDate, { giftId: ch.giftTarget && ch.giftTarget.id });
    if (!base || !extras.length) return base;
    const parts = { [type]: base };
    let worst = base;
    extras.forEach(([xt, xg, xo]) => {
      // Requisito que no se puede medir (p. ej. regalo sin id): cuenta como
      // 0 %, nunca se salta — la misión solo se completa con TODAS sus partes.
      const p = calculateMissionProgress(xt, xg, userStats, ch.startDate, ch.endDate, { giftId: xo && xo.giftTarget && xo.giftTarget.id })
        || { current: 0, goal: xg, percentage: 0 };
      parts[xt] = p;
      if (p.percentage < worst.percentage) worst = p;
    });
    return { current: worst.current, goal: worst.goal, percentage: worst.percentage, parts };
  }

  // ─── Progreso con datos del Backstage del miembro ─────────────
  // Las user_stats solo recogen los directos hechos con TikControl abierto;
  // un creador que emite sin la app (o un usuario dev con métricas fake)
  // se queda a 0 aunque Creadores muestre 30k / 12 días / 25 h. Si la misión
  // cubre el mes en curso desde el día 1 (las automáticas) o el mes anterior
  // completo, diamantes / días válidos / horas LIVE se toman también de
  // agency_members.backstageByMonth[YYYY-MM] (o backstageMtd), quedándose
  // con el MAYOR de las dos fuentes por objetivo. El resto de objetivos
  // (batallas, regalos, seguidores…) siguen con user_stats.
  function _msToNum(v) {
    if (!v) return 0;
    try {
      if (typeof v === 'number') return v;
      if (typeof v.toMillis === 'function') return v.toMillis();
      if (typeof v.toDate === 'function') return v.toDate().getTime();
      const n = new Date(v).getTime(); return Number.isFinite(n) ? n : 0;
    } catch (_) { return 0; }
  }
  function _monthKeyOf(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0'); }
  function missionMonthCovered(ch) {
    const start = _msToNum(ch.startDate);
    if (!start) return null;
    let end = _msToNum(ch.endDate);
    if (end && new Date(end).getHours() === 0 && new Date(end).getMinutes() === 0) end += 86399999;
    const now = new Date();
    const cs = new Date(now.getFullYear(), now.getMonth(), 1).getTime();
    const ce = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59).getTime();
    const ps = new Date(now.getFullYear(), now.getMonth() - 1, 1).getTime();
    const DAY = 864e5;
    if (start <= cs + DAY && start >= cs - DAY && (!end || end >= Math.min(Date.now(), ce) - DAY)) return _monthKeyOf(now);
    if (start <= ps + DAY && start >= ps - DAY && end && end >= cs - DAY - 1 && end <= ce) return _monthKeyOf(new Date(ps));
    return null;
  }
  function memberMonthMetrics(member, monthKey) {
    if (!member || !monthKey) return null;
    const bm = member.backstageByMonth && typeof member.backstageByMonth === 'object' ? member.backstageByMonth[monthKey] : null;
    const mtd = member.backstageMtd && member.backstageMtd.month === monthKey ? member.backstageMtd : null;
    // El más reciente manda (importedAt); sin sello, el parcial del mes (mtd).
    const pick = (bm && mtd) ? (_msToNum(mtd.importedAt) >= _msToNum(bm.importedAt) ? mtd : bm) : (bm || mtd);
    if (!pick) return null;
    return { diamonds: Number(pick.diamonds) || 0, validDays: Number(pick.validDays) || 0, liveHours: Number(pick.liveHours) || 0 };
  }
  // Sello de la última sincronización con datos del mes que cubre la misión
  // (importedAt del backstage del miembro); sin él, la última actualización
  // del doc de miembro. 0 si no hay nada.
  function memberSyncedAt(member, monthKey) {
    if (!member) return 0;
    const bm = monthKey && member.backstageByMonth && typeof member.backstageByMonth === 'object' ? member.backstageByMonth[monthKey] : null;
    const mtd = monthKey && member.backstageMtd && member.backstageMtd.month === monthKey ? member.backstageMtd : null;
    return Math.max(_msToNum(bm && bm.importedAt), _msToNum(mtd && mtd.importedAt), _msToNum(member.backstageLastSyncAt), _msToNum(member.updatedAt));
  }
  // Misión «Ver formación» (missionKind 'course'): la formación va dentro de
  // la misión (courseTarget: { id, name, tutorialIds }) y el avance son los
  // tutoriales de esa lista que el creador ya ha visto ENTEROS — su app lo
  // apunta en agency_members.completedTraining[tutorialId] = ms (vídeo
  // reproducido hasta el final o ≥ 95 %; un PDF o enlace, al abrirlo).
  // watchedTraining (abierto) ya no cuenta: abrir no es terminar.
  function courseMissionProgress(ch, member) {
    const target = ch && ch.courseTarget && typeof ch.courseTarget === 'object' ? ch.courseTarget : null;
    const ids = target && Array.isArray(target.tutorialIds) ? target.tutorialIds.filter(Boolean) : [];
    const done = member && member.completedTraining && typeof member.completedTraining === 'object' ? member.completedTraining : {};
    const goal = ids.length || +(ch && ch.goalValue) || 0;
    if (!goal) return null;
    const current = ids.filter(id => !!done[id]).length;
    return { current, goal, percentage: Math.min(100, (current / goal) * 100), parts: { course: { current, goal, percentage: Math.min(100, (current / goal) * 100) } } };
  }

  function calculateMissionProgressMerged(ch, userStats, member) {
    if (ch && ch.challengeType === 'course') return courseMissionProgress(ch, member);
    const base = calculateMissionProgressFull(ch, userStats || { dailyStats: {} });
    const monthKey = missionMonthCovered(ch);
    const met = memberMonthMetrics(member, monthKey);
    if (!met) return base;
    const type = ch.challengeType || 'custom';
    const goals = [[type, +ch.goalValue || parseInt(ch.goal, 10) || 0]].concat(missionSecondaryGoals(ch).map(([t2, g]) => [t2, g]));
    const bsValue = (k) => k === 'diamonds' ? met.diamonds : k === 'days' ? met.validDays : k === 'hours' ? Math.floor(met.liveHours) : null;
    const parts = {};
    let worst = null, any = false;
    for (const [k, g] of goals) {
      if (!(g > 0)) continue;
      const prev = base && base.parts ? base.parts[k] : (base && k === type ? base : null);
      const bv = bsValue(k);
      let p = prev ? { current: prev.current, goal: prev.goal, percentage: prev.percentage } : null;
      if (bv != null) {
        any = true;
        const cur = Math.max(bv, p ? p.current : 0);
        p = { current: cur, goal: g, percentage: Math.min(100, (cur / g) * 100) };
      }
      // Sin medida de ninguna fuente: 0 %, no se salta (todas las partes cuentan).
      if (!p) p = { current: 0, goal: g, percentage: 0 };
      parts[k] = p;
      if (!worst || p.percentage < worst.percentage) worst = p;
    }
    if (!any || !worst) return base;
    return { current: worst.current, goal: worst.goal, percentage: worst.percentage, parts };
  }

  // ─── Detalle de misión: cuerpo compartido (creador + previews) ─
  // El modal "así ve el creador su misión" (member.js) y las vistas previas
  // del owner (Misiones automáticas y Crear misión específica) pintan ESTE
  // mismo HTML: una sola pieza para que la vista previa nunca mienta.
  // Iconos SVG del detalle (nada de emojis: petición expresa).
  const _MD_ICO = {
    calendar: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>',
    clock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>',
    diamond: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="6 3 18 3 22 9 12 22 2 9"/><line x1="2" y1="9" x2="22" y2="9"/></svg>',
    swords: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="14.5 17.5 3 6 3 3 6 3 17.5 14.5"/><line x1="13" y1="19" x2="19" y2="13"/><line x1="16" y1="16" x2="20" y2="20"/><line x1="19" y1="21" x2="21" y2="19"/><polyline points="14.5 6.5 18 3 21 3 21 6 17.5 9.5"/><line x1="5" y1="14" x2="9" y2="18"/><line x1="7" y1="17" x2="4" y2="20"/><line x1="3" y1="19" x2="5" y2="21"/></svg>',
    users: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>',
    gift: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>',
    trophy: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"/><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"/><path d="M4 22h16"/><path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"/><path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"/><path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"/></svg>',
    ticket: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"/><path d="M13 5v2"/><path d="M13 17v2"/><path d="M13 11v2"/></svg>',
    star: '<svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>',
    coins: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="8" r="6"/><path d="M18.09 10.37A6 6 0 1 1 10.34 18"/><path d="M7 6h1v4"/><path d="m16.71 13.88.7.71-2.82 2.82"/></svg>',
    info: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>',
    target: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>',
    crown: '<svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"><path d="M3 8l4.5 4L12 5l4.5 7L21 8l-2 11H5z"/></svg>',
  };
  const _mdIco = (name, cls) => `<span class="agm-md-ico ${cls || ''}">${_MD_ICO[name] || ''}</span>`;

  // Cada objetivo tiene SU color (petición expresa): diamantes cian, días
  // válidos verde, horas LIVE azul, batallas morado. El color viaja como
  // --c a las celdas de objetivo y a las métricas de progreso.
  const _MD_PARTS = {
    days: { icon: 'calendar', key: 'agencies_valid_days', label: 'días válidos', color: '#22c55e' },
    hours: { icon: 'clock', key: 'agencies_md_live_hours', label: 'horas LIVE', color: '#3b82f6' },
    diamonds: { icon: 'diamond', key: 'agencies_md_diamonds', label: 'diamantes', color: '#06b6d4' },
    battles: { icon: 'swords', key: 'agencies_md_battles', label: 'batallas', color: '#a855f7' },
    battleDiamonds: { icon: 'swords', key: 'agencies_md_battle_diamonds', label: 'diamantes en batallas', color: '#237bff' },
    followers: { icon: 'users', key: 'agencies_md_followers', label: 'seguidores', color: '#f59e0b' },
    gift: { icon: 'gift', key: 'agencies_md_gifts', label: 'regalos', color: '#f59e0b' },
    course: { icon: 'trophy', key: 'agencies_md_course_videos', label: 'vídeos vistos', color: '#22d3ee' },
  };
  const _mdPartColor = (k) => (_MD_PARTS[k] && _MD_PARTS[k].color) || '#6ea8ff';
  function _mdEsc(s) { return String(s == null ? '' : s).replace(/[<>&"]/g, c => ({ '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;' }[c])); }
  // OJO: no confundir con el _isImg local del modal de eventos (es const
  // interna de esa función y desde aquí no existe).
  function _mdIsImg(url) { return !!url && (String(url).startsWith('https://') || String(url).startsWith('http://') || String(url).startsWith('data:')); }

  // Celdas del bloque "Objetivos a conseguir", que van en fila: el objetivo
  // PRINCIPAL (challengeType — diamantes en las automáticas) primero y, a su
  // lado, los secundarios (días, horas, extras del modal), cada uno con su
  // color.
  // `prog` (opcional: el de calculateMissionProgressFull en el detalle del
  // creador, o el de ejemplo en las vistas previas) pone en cada celda lo que
  // falta para cumplirla o "Misión cumplida" (y la celda en verde). Las
  // barras con «actual / objetivo» ya no van aquí: están en el banner
  // (AgenciasMissionLook.goalBarsHtml).
  function missionGoalCells(ch, prog) {
    const cells = [];
    const type = ch.challengeType || 'custom';
    // Lo que la agencia cambió en las tarjetas de objetivo de ESTA misión
    // («Editar visuales de la misión»): el fondo (color o imagen), la
    // intensidad del brillo y el icono (del catálogo o una imagen). El texto
    // del objetivo es siempre el suyo.
    const ML = window.AgenciasMissionLook || null;
    const own = ML ? (ML.lookOf(ch).goals || {}) : {};
    const partOf = (k) => {
      const m = _MD_PARTS[k] || {};
      const g = own[k] || {};
      return {
        ico: (ML && ML.goalIconHtml(g)) || (g.icon && ML.ICONS[g.icon]) || _MD_ICO[m.icon] || _MD_ICO.target,
        label: t(m.key, m.label),
        color: g.color || m.color || '#6ea8ff',
        ownColor: g.color || '',
        card: ML ? ML.goalCardAttrs(g) : null,
      };
    };
    // Avance de una pieza: con partes, la suya; sin partes, el progreso ES el
    // del objetivo principal.
    const progOf = (k) => {
      if (!prog) return null;
      if (prog.parts) return prog.parts[k] || null;
      return k === type ? prog : null;
    };
    const progState = (pp) => {
      const cur = +pp.current || 0, goal = +pp.goal || 0;
      const pct = Math.max(0, Math.min(100, Math.round(goal > 0 ? (cur / goal) * 100 : (+pp.percentage || 0))));
      return { cur, goal, pct, done: pct >= 100 || (goal > 0 && cur >= goal) };
    };
    const progHtml = (k, pp, unit) => {
      if (!pp) return '';
      const { cur, goal, done } = progState(pp);
      const status = done
        ? `<span class="agm-md-goal-status done">${_MD_ICO.check}${t('agencies_md_mission_done', 'Misión cumplida')}</span>`
        : `<span class="agm-md-goal-status">${t('agencies_md_remaining', 'Faltan {n} {u} para completar').replace('{n}', formatNumber(Math.max(0, goal - cur))).replace('{u}', unit)}</span>`;
      return `<div class="agm-md-goal-prog">${status}</div>`;
    };
    // cls extra: 'gift' = el valor es el NOMBRE del regalo (texto, no cifra).
    // k = clave de la pieza (tipo) para casar su progreso. card = imagen de
    // fondo y brillo propios de la tarjeta ({ cls, style }).
    const cell = (k, icoHtml, val, label, color, primary, cls, card) => {
      const pp = progOf(k);
      const ph = progHtml(k, pp, label);
      const done = !!pp && progState(pp).done;
      // Cumplido: la celda entera pasa a verde (el --c va inline, así que el
      // color se decide aquí y no en CSS).
      return `<div class="agm-md-goal-cell ${primary ? 'primary' : 'secondary'} ${cls || ''} ${ph ? 'has-prog' : ''} ${done ? 'done' : ''}${card ? card.cls : ''}" style="--c:${done ? '#22c55e' : color}${card && card.style ? ';' + card.style : ''}">
      <span class="agm-md-goal-ico">${icoHtml}</span>
      <div class="agm-md-goal-body">
        ${primary ? `<span class="agm-md-goal-rank">${t('agencies_md_primary', 'Objetivo principal')}</span>` : ''}
        <strong>${val}</strong>
        <span class="agm-md-goal-lbl">${label}</span>
      </div>
      ${primary ? '' : `<span class="agm-md-goal-rank">${t('agencies_md_secondary', 'Secundario')}</span>`}
      ${ph || '<i class="agm-md-goal-tick"></i>'}
    </div>`;
    };
    const gv = +ch.goalValue || parseInt(ch.goal, 10) || 0;
    if (ch.giftTarget && ch.giftTarget.id != null) {
      const g = ch.giftTarget;
      const p = partOf(type);
      cells.push(cell(type,
        g.image ? `<img class="agm-md-goal-gift" src="${safeGiftImgUrl(g.image)}" alt="">` : _MD_ICO.gift,
        `${gv > 1 ? formatNumber(gv) + '× ' : ''}${_mdEsc(g.name || '')}`,
        t('agencies_md_gift_goal', 'regalo objetivo'), p.ownColor || '#f59e0b', true, 'gift', p.card));
    } else if (gv > 0 && _MD_PARTS[type]) {
      const p = partOf(type);
      cells.push(cell(type, p.ico, formatNumber(gv), p.label, p.color, true, '', p.card));
    }
    missionSecondaryGoals(ch).forEach(([k, g, o]) => {
      const m = _MD_PARTS[k];
      if (!m) return;
      const gt = o && o.giftTarget;
      const p = partOf(k);
      if (k === 'gift' && gt) {
        cells.push(cell(k,
          gt.image ? `<img class="agm-md-goal-gift" src="${safeGiftImgUrl(gt.image)}" alt="">` : _MD_ICO.gift,
          `${g > 1 ? formatNumber(g) + '× ' : ''}${_mdEsc(gt.name || '')}`,
          t('agencies_md_gift_goal', 'regalo objetivo'), p.color, false, 'gift', p.card));
        return;
      }
      cells.push(cell(k, p.ico, formatNumber(g), p.label, p.color, false, '', p.card));
    });
    return cells;
  }

  // Texto del bloque "Descripción de la misión": la descripción escrita por
  // la agencia; sin ella, las frases de la automática (retener / subir /
  // actividad); y si tampoco, un texto por defecto.
  // Sin descripción (también en las automáticas): el texto por defecto.
  function missionDescriptionLines(ch) {
    // Cada salto de línea de la descripción es un párrafo propio (las
    // misiones de evento traen "Además, en esta fase: …" + descripción).
    if (ch.description) {
      const parts = String(ch.description).split(/\n+/).map(x => x.trim()).filter(Boolean);
      if (parts.length) return parts.map(_mdEsc);
    }
    return [t('agencies_md_desc_default', 'Completa los objetivos de arriba para completar la misión')];
  }

  // Qué significa la misión automática (retener / subir / actividad).
  function _mdAutoLines(ch) {
    if (!ch.auto) return [];
    const kinds = Array.isArray(ch.autoKinds) && ch.autoKinds.length ? ch.autoKinds : (ch.autoKind ? [ch.autoKind] : []);
    const L = [];
    if (kinds.includes('retain')) L.push(t('agencies_md_auto_retain', 'Iguala los diamantes de tu nivel del mes pasado para mantener tu Incentivo de Subida.'));
    if (kinds.includes('rise')) L.push(t('agencies_md_auto_rise', 'Alcanza los diamantes del siguiente nivel para subir en el Incentivo de Subida.'));
    if (kinds.includes('activity')) L.push(t('agencies_md_auto_activity', 'Cumple los días válidos y las horas LIVE para asegurar tu Incentivo de Actividad.'));
    return L;
  }

  // "Nombre - @handle" → { title, handle } (los títulos de las misiones
  // automáticas llevan el @ del creador al final; en la cabecera del mockup
  // van separados).
  function _mdSplitName(name) {
    const m = String(name || '').match(/^(.*?)\s*[-–—]\s*(@[\w.\-]+)\s*$/);
    return m ? { title: m[1], handle: m[2] } : { title: String(name || ''), handle: '' };
  }
  // A partir de cuántos caracteres se pliega con «Ver más» el objetivo
  // escrito a mano del detalle (tres líneas)…
  const MISSION_DESC_FOLD = 220;
  // …y la descripción, que va en la columna lateral y tiene más sitio (seis
  // líneas; .agm-md-colside .agm-md-desc.is-folded en agencies.css): con
  // más de 360 caracteres o de 6 párrafos.
  const MISSION_DESC_SIDE_FOLD = 360;
  const MISSION_DESC_SIDE_LINES = 6;

  // Card de recompensa (mockup): imagen apaisada grande a la izquierda,
  // categoría + nombre en el centro, metas a la derecha y badge circular.
  // giftImg = la imagen es un regalo de TikTok (PNG cuadrado): se enseña
  // ENTERO (contain), no recortado como las fotos subidas por la agencia.
  // state (opcional) = el estado de ese premio para quien mira su misión
  // ({ status: 'pending' | 'won' | 'raffle' | 'raffle_won' | 'raffle_lost',
  // delivered }, el mismo que marca la tarjeta de misión del creador):
  // conseguido → la card en verde con el tick en la insignia y «Conseguido»;
  // participando en el sorteo → boleto; sorteo ganado → dorada con corona;
  // sorteo ya hecho sin suerte → apagada. Sin state (consola, vista previa) o
  // pendiente, la card de siempre.
  function _mdPrizeState(state) {
    const none = { cls: '', html: '', badge: '' };
    if (!state || !state.status) return none;
    const txt = {
      won: t('agencies_crx_prize_won', 'Conseguido'),
      raffle: t('agencies_crx_raffle_in', 'Participando en el sorteo'),
      raffle_won: t('agencies_crx_raffle_won', '¡Ganaste el sorteo!'),
      raffle_lost: t('agencies_crm_badge_raffled', 'Participaste en el sorteo'),
    }[state.status] || '';
    if (!txt) return none;
    const badge = { won: 'check', raffle: 'ticket', raffle_won: 'crown' }[state.status] || '';
    const parts = [txt, state.delivered ? t('agencies_crx_delivered', 'Entregado') : ''].filter(Boolean);
    return {
      cls: ' is-' + state.status,
      html: `<span class="agm-md-prize-state">${badge ? _MD_ICO[badge] : ''}${parts.join(' · ')}</span>`,
      badge,
    };
  }
  function _mdPrizeCard(kind, title, text, imgUrl, metas, giftImg, state) {
    const sv = _mdPrizeState(state);
    // Con foto, la imagen se puede pulsar para verla a tamaño completo.
    return `<div class="agm-md-prize ${kind}${sv.cls}">
      <span class="agm-md-prize-img ${giftImg ? 'gift' : ''}">${imgUrl ? `<img src="${imgUrl}" alt="" data-lightbox="${_mdEsc(imgUrl)}" title="${t('agencies_md_zoom_img', 'Ver imagen a tamaño completo')}">` : _mdIco(kind === 'raffle' ? 'gift' : 'trophy')}</span>
      <div class="agm-md-prize-info">
        <span class="agm-md-prize-k">${title}</span>
        <strong>${text}</strong>
        ${sv.html}
      </div>
      ${metas && metas.length ? `<div class="agm-md-prize-metas">${metas.map(m => `<span>${m}</span>`).join('')}</div>` : ''}
      <span class="agm-md-prize-badge">${_MD_ICO[sv.badge || (kind === 'raffle' ? 'gift' : 'trophy')]}</span>
    </div>`;
  }

  // Texto + imagen de un premio en formato prizeConfig[0] (legacy compat).
  function _mdPcText(pc0) {
    if (!pc0) return { text: '', img: '' };
    if (pc0.type === 'gift') {
      return {
        text: `${(+pc0.giftQty || 1) > 1 ? (+pc0.giftQty) + '× ' : ''}${_mdEsc(pc0.giftName || '')}`,
        img: pc0.giftImage ? safeGiftImgUrl(pc0.giftImage) : '',
        isGift: !!pc0.giftImage,
      };
    }
    if (pc0.type === 'coins') return { text: `${_mdIco('coins', 'inline')} ${formatNumber(+pc0.amount || 0)} ${t('agencies_coins_unit', 'monedas')}`, img: '' };
    // 'physical': las automáticas guardan el dinero como "💰 <importe>" — se
    // limpia el emoji y se antepone el icono de monedas.
    const desc = String(pc0.description || '');
    const money = desc.match(/^💰\s*(.+)$/);
    if (money) return { text: `${_mdIco('coins', 'inline')} ${_mdEsc(money[1])}`, img: '' };
    return { text: _mdEsc(desc || t('agencies_prize_word', 'Premio')), img: '' };
  }

  // Cards de recompensas: TODOS los premios del nivel (automáticas), o el
  // premio directo (específicas / legacy prizeConfig), más el sorteo.
  // Premio de un puesto de rankingGroups en texto: formato nuevo (kind del
  // editor de premios) o antiguo (prizeType coins/gift sin kind).
  function rankingPositionText(g, p) {
    const kind = p.kind || ((g && g.prizeType === 'gift') ? 'gift' : 'coins');
    const qty = (p.giftQty || 1) > 1 ? p.giftQty + '× ' : '';
    if (kind === 'gift') return `${qty}${p.giftName || (p.giftTarget && p.giftTarget.name) || ''}`.trim();
    if (kind === 'money') return formatMoney(p.amount || 0, p.currency);
    if (kind === 'diamonds') return `${formatNumber(p.amount || 0)} 💎`;
    if (kind === 'coins') return `🪙 ${formatNumber(p.amount || 0)} ${t('agencies_coins_unit', 'monedas')}`;
    return String(p.name || '');
  }

  // states (opcional): el estado de cada premio para quien mira, en el MISMO
  // orden que missionPrizeList (las cards salen una a una en ese orden; null
  // = sin estado). Lo pasa la vista del creador (member.js).
  function missionRewardCards(ch, states) {
    const cards = [];
    const st = () => (Array.isArray(states) ? states[cards.length] : null) || null;
    // Los premios se entregan al terminar la misión (final de mes en las
    // automáticas): la fecha va SIEMPRE tras el separador, como en sorteos.
    const deliveryMeta = ch.endDate ? `${_mdIco('calendar', 'inline')}${t('agencies_md_delivery', 'Entrega')}: ${formatDate(ch.endDate)}` : '';
    const dp = ch.directPrize || null;
    // Automáticas: autoPrizes trae los premios del NIVEL completos (retener
    // y aumentar, cada uno con su foto y cantidad) — se enseñan todos.
    const lp = (!dp && Array.isArray(ch.autoPrizes))
      ? ch.autoPrizes.filter(x => x && Array.isArray(x.prizeConfig) && x.prizeConfig.length) : [];
    const pc = (!dp && !lp.length && Array.isArray(ch.prizeConfig) && ch.prizeConfig.length) ? ch.prizeConfig[0] : null;
    const rf = ch.raffle || null;
    // El editor de misiones específicas admite varios premios directos y
    // varios sorteos: el primero viaja como siempre (directPrize / raffle) y
    // el resto en extraPrizes / extraRaffles.
    const extraDp = Array.isArray(ch.extraPrizes) ? ch.extraPrizes.filter(x => x && typeof x === 'object') : [];
    const extraRf = Array.isArray(ch.extraRaffles) ? ch.extraRaffles.filter(x => x && typeof x === 'object') : [];
    const directCard = (dp) => {
      let txt;
      if (dp.kind === 'money') txt = _mdEsc(formatMoney(dp.amount, dp.currency));
      else if (dp.kind === 'diamonds') txt = `${formatNumber(+dp.amount || 0)} 💎`;
      else if (dp.kind === 'gift' && dp.giftTarget) txt = `${(+dp.giftQty || 1) > 1 ? (+dp.giftQty) + '× ' : ''}${_mdEsc(dp.giftTarget.name || t('agencies_prize_word', 'Premio'))}`;
      else txt = _mdEsc(dp.name || t('agencies_prize_word', 'Premio'));
      const ownImg = dp.imageUrl ? safeImgUrl(dp.imageUrl) : '';
      const giftImg = !ownImg && dp.kind === 'gift' && dp.giftTarget && dp.giftTarget.image;
      const imgUrl = ownImg || (giftImg ? safeGiftImgUrl(dp.giftTarget.image) : '');
      const metas = [];
      if (+dp.qty > 0) metas.push(t('agencies_md_available', 'Disponibles: {n}').replace('{n}', dp.qty));
      if (dp.condition) metas.push(`${_mdIco('calendar', 'inline')}${t('agencies_md_delivery', 'Entrega')}: ${_mdEsc(dp.condition)}`);
      else if (deliveryMeta) metas.push(deliveryMeta);
      cards.push(_mdPrizeCard('direct', t('agencies_md_direct', 'Premio al completar'), txt, imgUrl, metas, !!giftImg, st()));
    };
    if (dp) {
      [dp, ...extraDp].forEach(directCard);
    } else if (lp.length) {
      lp.forEach(entry => {
        const info = _mdPcText(entry.prizeConfig[0]);
        const ownImg = entry.imageUrl ? safeImgUrl(entry.imageUrl) : '';
        const imgUrl = ownImg || info.img;
        const metas = [];
        if (+entry.qty > 0) metas.push(t('agencies_md_available', 'Disponibles: {n}').replace('{n}', entry.qty));
        if (deliveryMeta) metas.push(deliveryMeta);
        const title = entry.variant === 'rise'
          ? t('agencies_md_prize_rise', 'Premio por subir de nivel')
          : t('agencies_md_prize_retain', 'Premio por retener tu nivel');
        cards.push(_mdPrizeCard('direct', title, info.text, imgUrl, metas, !ownImg && !!info.isGift, st()));
      });
    } else if (pc) {
      const info = _mdPcText(pc);
      let imgUrl = info.img;
      // Automáticas legacy: la foto real del premio del plan viaja como
      // imageUrl top-level de la misión — es la imagen de esta card.
      if (!imgUrl && ch.auto && _mdIsImg(ch.imageUrl)) imgUrl = safeImgUrl(ch.imageUrl);
      cards.push(_mdPrizeCard('direct', t('agencies_md_direct', 'Premio al completar'), info.text, imgUrl, deliveryMeta ? [deliveryMeta] : [], !!info.isGift && imgUrl === info.img, st()));
    }
    // Sorteo solo de unos niveles (levels): se dice de cuáles.
    const ML = window.AgenciasMissionLook || null;
    const lvlMeta = (r) => (ML && ML.raffleLevels(r).length ? _mdEsc(ML.levelsText(r.levels)) : '');
    [rf, ...extraRf].forEach(rf => {
      if (!rf || !(rf.prizeName || rf.imageUrl)) return;
      const metas = [];
      if (lvlMeta(rf)) metas.push(lvlMeta(rf));
      if (+rf.winners > 1) metas.push(`${rf.winners} ${t('agencies_ms_winners_low', 'ganadores')}`);
      if (+rf.value > 0) metas.push(`~${formatNumber(+rf.value)} €`);
      const rfDate = rf.date || ch.endDate;   // sin fecha propia: fin de la misión
      if (rfDate) metas.push(`${_mdIco('calendar', 'inline')}${t('agencies_md_draw', 'Sorteo')}: ${formatDate(rfDate)}`);
      cards.push(_mdPrizeCard('raffle', t('agencies_md_raffle', 'Sorteo entre los que completen'), _mdEsc(rf.prizeName || t('agencies_raffle_word', 'Sorteo')), rf.imageUrl ? safeImgUrl(rf.imageUrl) : '', metas, false, st()));
    });
    // Sorteos GLOBALES del plan automático: entre todos los creadores de la
    // agencia que completen su misión (viajan en el doc como globalRaffles).
    (Array.isArray(ch.globalRaffles) ? ch.globalRaffles : []).forEach(g => {
      if (!g || !(g.prizeName || g.imageUrl)) return;
      const metas = [];
      if (Number.isFinite(+g.dateMs) && +g.dateMs > 0) metas.push(`${_mdIco('calendar', 'inline')}${t('agencies_md_draw', 'Sorteo')}: ${formatDate(new Date(+g.dateMs))}`);
      if (+g.winners > 1) metas.push(`${+g.winners} ${t('agencies_ma_raffle_prize_many', 'premios')}`);
      const byLevel = !!lvlMeta(g);
      cards.push(_mdPrizeCard('raffle', byLevel
        ? t('agencies_md_lraffle', 'Sorteo de tu nivel (entre los que completen)')
        : t('agencies_md_graffle', 'Sorteo global (todos los que completen)'), _mdEsc(g.prizeName || t('agencies_raffle_word', 'Sorteo')), g.imageUrl ? safeImgUrl(g.imageUrl) : '', metas, false, st()));
    });
    return cards;
  }

  // Los mismos premios que missionRewardCards, EN EL MISMO ORDEN (el estado
  // de cada premio se casa por posición), en datos y sin fechas: para las
  // tarjetas de misión del creador. → [{ text, img, gift, raffle }]
  // con `text` ya escapado (puede llevar el icono de monedas).
  function missionPrizeList(ch) {
    const out = [];
    const dp = ch.directPrize || null;
    const lp = (!dp && Array.isArray(ch.autoPrizes))
      ? ch.autoPrizes.filter(x => x && Array.isArray(x.prizeConfig) && x.prizeConfig.length) : [];
    const pc = (!dp && !lp.length && Array.isArray(ch.prizeConfig) && ch.prizeConfig.length) ? ch.prizeConfig[0] : null;
    const directs = dp ? [dp, ...(Array.isArray(ch.extraPrizes) ? ch.extraPrizes.filter(x => x && typeof x === 'object') : [])] : [];
    directs.forEach(p => {
      let text;
      if (p.kind === 'money') text = _mdEsc(formatMoney(p.amount, p.currency));
      else if (p.kind === 'diamonds') text = `${formatNumber(+p.amount || 0)} 💎`;
      else if (p.kind === 'gift' && p.giftTarget) text = `${(+p.giftQty || 1) > 1 ? (+p.giftQty) + '× ' : ''}${_mdEsc(p.giftTarget.name || t('agencies_prize_word', 'Premio'))}`;
      else text = _mdEsc(p.name || t('agencies_prize_word', 'Premio'));
      const own = p.imageUrl ? safeImgUrl(p.imageUrl) : '';
      const gift = !own && p.kind === 'gift' && p.giftTarget && p.giftTarget.image ? safeGiftImgUrl(p.giftTarget.image) : '';
      out.push({ text, img: own || gift, gift: !!gift, raffle: false });
    });
    lp.forEach(entry => {
      const info = _mdPcText(entry.prizeConfig[0]);
      const own = entry.imageUrl ? safeImgUrl(entry.imageUrl) : '';
      out.push({ text: info.text, img: own || info.img, gift: !own && !!info.isGift, raffle: false });
    });
    if (pc) {
      const info = _mdPcText(pc);
      const img = info.img || (ch.auto && _mdIsImg(ch.imageUrl) ? safeImgUrl(ch.imageUrl) : '');
      out.push({ text: info.text, img, gift: !!info.isGift && img === info.img, raffle: false });
    }
    [ch.raffle, ...(Array.isArray(ch.extraRaffles) ? ch.extraRaffles : []), ...(Array.isArray(ch.globalRaffles) ? ch.globalRaffles : [])].forEach(r => {
      if (!r || typeof r !== 'object' || !(r.prizeName || r.imageUrl)) return;
      out.push({ text: _mdEsc(r.prizeName || t('agencies_raffle_word', 'Sorteo')), img: r.imageUrl ? safeImgUrl(r.imageUrl) : '', gift: false, raffle: true });
    });
    return out;
  }

  // Premios que GANA quien completa la misión (sin sorteos). Igual que
  // missionPrizeList salvo en las automáticas con premios por nivel de dos
  // fases (autoPrizes «mantener» + «subir»): cada misión da solo el de SU
  // pieza — la de subir (autoKind/autoKinds con 'rise') el de subir y el
  // resto el de mantener. La otra fase es otra misión (o no llega).
  function missionWonPrizes(ch) {
    const all = missionPrizeList(ch || {}).filter(p => !p.raffle);
    if (!ch || ch.directPrize || !Array.isArray(ch.autoPrizes)) return all;
    const lp = ch.autoPrizes.filter(x => x && Array.isArray(x.prizeConfig) && x.prizeConfig.length);
    if (lp.length < 2) return all;
    const kinds = Array.isArray(ch.autoKinds) && ch.autoKinds.length ? ch.autoKinds : [ch.autoKind];
    const variant = kinds.includes('rise') ? 'rise' : 'retain';
    // missionPrizeList pinta primero los autoPrizes, en su orden.
    const mine = lp.map((x, i) => ((x.variant || 'retain') === variant ? i : -1)).filter(i => i >= 0);
    const keep = new Set(mine.length ? mine : [0]);
    return all.filter((p, i) => i >= lp.length || keep.has(i));
  }

  // Premios de la fase SIGUIENTE de una automática de dos fases, vistos desde
  // la misión de mantener: los de «subir de nivel» (missionPrizeList, en su
  // orden). El creador los tiene a la vista en el detalle desde el primer día,
  // pero la misión de subir no existe hasta que iguala su nivel y el motor la
  // crea (al abrirse la consola de la agencia): mientras tanto, su vista los
  // enseña con esta misión, como pendientes. [] en cualquier otro caso (una
  // sola fase, o la propia misión de subir).
  function missionNextPhasePrizes(ch) {
    if (!ch || ch.directPrize || !Array.isArray(ch.autoPrizes)) return [];
    const lp = ch.autoPrizes.filter(x => x && Array.isArray(x.prizeConfig) && x.prizeConfig.length);
    if (lp.length < 2) return [];
    const kinds = Array.isArray(ch.autoKinds) && ch.autoKinds.length ? ch.autoKinds : [ch.autoKind];
    if (kinds.includes('rise')) return [];
    // missionPrizeList pinta primero los autoPrizes, en su orden.
    return missionPrizeList(ch).filter(p => !p.raffle).filter((p, i) => i < lp.length && lp[i].variant === 'rise');
  }

  // Icono, nombre y color de cada objetivo de misión (días válidos, horas,
  // diamantes…): los mismos que las celdas del detalle.
  function missionPartMeta(k) {
    const p = _MD_PARTS[k];
    if (!p) return null;
    return { svg: _MD_ICO[p.icon] || '', label: t(p.key, p.label), color: p.color };
  }

  // Progreso ficticio para las vistas previas del owner (~40%): va dentro
  // de las celdas de objetivo, como el real en el detalle del creador.
  function _mdPreviewProg(ch) {
    const type = ch.challengeType || 'custom';
    const gv = +ch.goalValue || 0;
    const mk = (goal, ratio) => ({ current: Math.round((goal || 0) * ratio), goal: goal || 0, percentage: Math.round(ratio * 100) });
    const parts = {};
    // El principal primero (mismo orden que calculateMissionProgressFull).
    if (gv > 0 && _MD_PARTS[type]) parts[type] = mk(gv, 0.4);
    const ratios = [0.5, 0.35, 0.6, 0.45];
    missionSecondaryGoals(ch).forEach(([k, g], i) => { if (_MD_PARTS[k]) parts[k] = mk(g, ratios[i % ratios.length]); });
    const keys = Object.keys(parts);
    if (keys.length > 1) {
      const worst = keys.reduce((a, b) => (parts[a].percentage <= parts[b].percentage ? a : b));
      return { ...parts[worst], parts };
    }
    if (keys.length === 1) return parts[keys[0]];
    return { current: 0, goal: gv, percentage: 40 };
  }

  // Cuerpo completo del detalle: banner con el título, las fechas y el
  // avance total a la izquierda y las barras de avance de los objetivos a la
  // derecha; debajo, en dos columnas,
  // los objetivos en fila con las recompensas debajo (60 %) y, en el lateral
  // (40 %), la descripción de la misión y la frase de ánimo.
  // opts: { progress, motivationPct, handle, prizeStates } (member: progreso
  // real de calculateMissionProgressFull y el estado de cada premio para él,
  // en el orden de missionPrizeList) o { preview: true } (owner: progreso de
  // ejemplo + nota).
  // Ábrelo con showModal('', body, footer, { size: 'xl', extraClass: 'ag-modal-mission' }).
  // Foto PROPIA de la misión (la que sube la agencia), o '' si no tiene o si
  // su imageUrl es en realidad la foto de un premio (específicas: la del
  // primer premio o sorteo; automáticas: siempre la del premio del plan).
  function missionOwnImage(ch) {
    const dp = ch.directPrize || null;
    const rf = ch.raffle || null;
    const usedByPrize = (dp && dp.imageUrl && dp.imageUrl === ch.imageUrl)
      || (rf && rf.imageUrl && rf.imageUrl === ch.imageUrl)
      || (!!ch.auto && !dp);
    return (_mdIsImg(ch.imageUrl) && !usedByPrize) ? safeImgUrl(ch.imageUrl) : '';
  }

  function missionDetailHtml(ch, opts) {
    const o = opts || {};
    const type = ch.challengeType || 'custom';

    // ── Cabecera con el aspecto de la misión (components/mission-look.js):
    // fondo (el básico de TikControl, un color o una imagen), icono, color,
    // posición y tamaño del texto. Sin esa pieza cargada, la cabecera lisa.
    const ML = window.AgenciasMissionLook || null;
    const look = ML ? ML.lookOf(ch) : null;
    const hero = ML ? ML.heroAttrs(look) : { cls: '', bgCls: '', posCls: '', style: '' };
    const headIco = ML ? ML.iconOf(ch, look).svg : '';

    // ── Cabecera: título + @handle (separados del nombre guardado) + chips
    // + fechas y días restantes. Las misiones ESPECÍFICAS no llevan el @ en
    // el nombre: el que llama lo pasa en opts.handle para que el header sea
    // el mismo modelo en todas.
    const parsed = _mdSplitName(ch.name);
    const title = parsed.title;
    const handle = parsed.handle || (o.handle ? '@' + String(o.handle).replace(/^@/, '') : '');
    let daysLeft = null;
    try {
      if (ch.endDate) {
        const end = ch.endDate.toDate ? ch.endDate.toDate() : new Date(ch.endDate.seconds ? ch.endDate.seconds * 1000 : ch.endDate);
        const n = Math.ceil((end.getTime() + 86399999 - Date.now()) / 86400000);
        if (Number.isFinite(n) && n >= 0) daysLeft = n;
      }
    } catch (_) { /* */ }
    const typeIco = (_MD_PARTS[type] && _MD_PARTS[type].icon) || (ch.giftTarget ? 'gift' : 'target');
    // ── Avance: el real (member) o el de ejemplo (vistas previas del owner).
    const previewProg = o.preview ? _mdPreviewProg(ch) : null;
    const prog = o.progress || previewProg || null;
    // Las barras de los objetivos van en el banner, a la derecha del todo, y
    // el avance total («Tu avance N %») a la izquierda, debajo del título y
    // las fechas: las mismas piezas que la tarjeta de misión del creador.
    const barRows = !prog ? [] : (prog.parts
      ? Object.keys(prog.parts).map(k => ({ k, current: prog.parts[k].current, goal: prog.parts[k].goal }))
      : [{ k: type, current: prog.current, goal: prog.goal }]);
    const bars = (ML && typeof ML.goalBarsHtml === 'function') ? ML.goalBarsHtml(ch, barRows, look) : '';
    const total = (bars && typeof ML.totalBarHtml === 'function') ? ML.totalBarHtml(prog.percentage) : '';

    // Cabecera: a la izquierda icono + título en H1, debajo avatar + @handle
    // + pill del tipo, debajo fechas + días restantes y, debajo, el avance
    // total, sobre el fondo de la misión; a la derecha, las barras. El fondo
    // va en la caja de fuera y la posición del texto que eligió la agencia,
    // en la de dentro.
    const head = `
      <div class="agm-md-head ${hero.bgCls || ''}${bars ? ' has-bars' : ''}"${hero.style ? ` style="${hero.style}"` : ''}>
        <div class="agm-md-head-main ${hero.posCls || ''}">
          <div class="agm-md-head-txt">
            ${headIco ? `<span class="ml-icon agm-md-head-ico">${headIco}</span>` : ''}
            <h1 class="agm-md-title ml-title">${_mdEsc(title)}</h1>
            <div class="agm-md-idrow ml-info">
              ${handle ? `<span class="agm-md-handle"><i class="agm-md-avatar">${_mdEsc(handle.replace(/^@/, '').charAt(0).toUpperCase())}</i>${_mdEsc(handle)}</span>` : ''}
              <span class="agm-md-typechip">${_mdIco(typeIco, 'inline')}${t('agencies_type_' + type, type)}</span>
            </div>
            <div class="agm-md-daterow ml-info">
              ${(ch.startDate || ch.endDate) ? `<span>${_mdIco('calendar', 'inline')}${ch.startDate ? formatDate(ch.startDate) : ''}${ch.endDate ? ' — ' + formatDate(ch.endDate) : ''}</span>` : ''}
              ${missionIsRelative(ch) && !ch.endDate ? `<i class="agm-md-datesep"></i><span>${_mdIco('clock', 'inline')}${_mdEsc(relativeDeadlineLabel(ch))}</span>` : ''}
              ${daysLeft != null ? `<i class="agm-md-datesep"></i><span>${_mdIco('clock', 'inline')}${t('agencies_md_days_left', 'Quedan {n} días').replace('{n}', daysLeft)}</span>` : ''}
              ${o.syncedAt ? `<i class="agm-md-datesep"></i><span class="agm-md-sync" title="${_mdEsc(t('agencies_mis_sync_tip_creator', 'Tu avance se calcula con los datos de la última sincronización de tu agencia con el Backstage (diamantes, días válidos y horas LIVE). Se actualiza cada vez que la agencia sincroniza.'))} · ${_mdEsc(formatDateTime(o.syncedAt))}">${_mdIco('info', 'inline')}${t('agencies_mis_synced', 'Datos sincronizados')}: ${_mdEsc(timeSince(new Date(o.syncedAt)))}</span>` : ''}
            </div>
            ${total}
          </div>
        </div>
        ${bars}
      </div>`;

    // ── Objetivos, en fila (la principal primero): la cifra a conseguir y,
    // debajo, lo que falta o «Misión cumplida». Las barras están en el banner.
    const goalCells = missionGoalCells(ch, prog);
    // Vistas previas del owner: aviso de que el avance es de ejemplo.
    const exampleNote = (o.preview && goalCells.length)
      ? `<p class="agm-md-example">${t('agencies_md_example', 'Progreso de ejemplo: el creador verá aquí su avance real.')}</p>` : '';
    // Objetivo de texto (misiones personalizadas): misma celda del modelo,
    // a lo ancho, con el icono de diana.
    // Si es largo (el que pone un evento es un párrafo), plegado con «Ver
    // más», como la descripción.
    const goalStr = String(ch.goal || '');
    const goalLong = goalStr.length > MISSION_DESC_FOLD;
    const goalTxt = (!goalCells.length && ch.goal) ? `<div class="agm-md-goal"><div class="agm-md-goal-cell wide">
        <span class="agm-md-goal-ico">${_MD_ICO.target}</span>
        <div class="agm-md-goal-txtwrap">
          <div class="agm-md-desc${goalLong ? ' is-folded' : ''}"><strong class="txt">${_mdEsc(goalStr)}</strong></div>
          ${goalLong ? `<button type="button" class="agm-md-desc-more" data-md-more data-more="${_mdEsc(t('agencies_md_desc_more', 'Ver más'))}" data-less="${_mdEsc(t('agencies_md_desc_less', 'Ver menos'))}">${t('agencies_md_desc_more', 'Ver más')}</button>` : ''}
        </div>
        <i class="agm-md-goal-tick"></i>
      </div></div>` : '';
    // "Descripción de la misión": siempre presente (con texto por defecto si
    // la agencia no escribió nada). Va en la columna lateral, así que hay
    // sitio para más texto que antes, pero una descripción larga tampoco se
    // enseña entera: se queda en unas líneas con «Ver más» (listener
    // delegado abajo).
    const descLines = missionDescriptionLines(ch);
    const descLong = descLines.length > MISSION_DESC_SIDE_LINES || descLines.join(' ').length > MISSION_DESC_SIDE_FOLD;
    const whatBlock = `
      <div class="agm-md-what">
        <div class="agm-md-what-head">
          <span class="agm-md-what-ico">${_MD_ICO.info}</span>
          <span class="agm-md-what-k">${t('agencies_md_what', 'Descripción de la misión')}</span>
        </div>
        <div class="agm-md-what-txt">
          <div class="agm-md-desc${descLong ? ' is-folded' : ''}">${descLines.map(x => `<p>${x}</p>`).join('')}</div>
          ${descLong ? `<button type="button" class="agm-md-desc-more" data-md-more data-more="${_mdEsc(t('agencies_md_desc_more', 'Ver más'))}" data-less="${_mdEsc(t('agencies_md_desc_less', 'Ver menos'))}">${t('agencies_md_desc_more', 'Ver más')}</button>` : ''}
        </div>
      </div>`;

    // ── Recompensas.
    const rewards = missionRewardCards(ch, o.prizeStates);

    // ── Motivación según el avance real (o el de ejemplo).
    const motPct = o.motivationPct != null ? o.motivationPct : (prog ? prog.percentage : null);
    const mot = motPct == null ? '' : `
      <div class="agm-md-mot">
        <span class="agm-md-mot-ico">${_MD_ICO.star}</span>
        <span>${motPct >= 80 ? t('agencies_md_mot_high', '¡Ya casi lo tienes! Último empujón.')
          : motPct >= 40 ? t('agencies_md_mot_mid', '¡Vas por buen camino! Sigue así.')
          : t('agencies_md_mot_start', '¡A por ello! Cada directo suma.')}</span>
      </div>`;

    // Cuerpo en dos columnas: a la izquierda (60 %) los objetivos en fila y,
    // debajo, las recompensas (dos por fila si caben; una sola, a lo ancho);
    // a la derecha (40 %) la descripción de la misión y la frase de ánimo. La
    // tarjeta de la descripción empieza a la altura de las tarjetas de
    // objetivo, no a la de su rótulo: el lateral lleva delante un hueco igual
    // de alto que «Objetivos a conseguir» (.agm-md-sect-ghost).
    const rewardsBlock = !rewards.length ? '' : `
        <h5 class="agm-md-sect">${t('agencies_ms_b4', 'Recompensas')}</h5>
        ${rewards.length === 1
          ? `<div class="agm-md-rewards-wide"><div class="agm-md-rewardlist">${rewards[0]}</div></div>`
          : `<div class="agm-md-rewardlist is-grid">${rewards.join('')}</div>`}`;
    const colMain = `<div class="agm-md-col agm-md-colmain">
        <h5 class="agm-md-sect">${t('agencies_md_goals', 'Objetivos a conseguir')}</h5>
        ${goalCells.length ? `<div class="agm-md-goal">${goalCells.join('')}</div>` : goalTxt}
        ${exampleNote}
        ${rewardsBlock}
      </div>`;
    const colSide = `<aside class="agm-md-col agm-md-colside">
        <div class="agm-md-sect agm-md-sect-ghost" aria-hidden="true">&nbsp;</div>
        ${whatBlock}
        ${mot}
      </aside>`;
    return `<div class="agm-md">
      ${head}
      <div class="agm-md-inner">
        <div class="agm-md-split">${colMain}${colSide}</div>
      </div>
    </div>`;
  }

  // ─── Lightbox de imágenes del detalle de misión ───────────────
  // Las fotos de los premios y la imagen de la misión llevan data-lightbox:
  // un único listener delegado abre la ampliación por encima de cualquier
  // modal (el de crear misión específica vive a z-index 100040).
  function openImageLightbox(src) {
    if (!src) return;
    document.getElementById('ag-md-lightbox')?.remove();
    const overlay = document.createElement('div');
    overlay.id = 'ag-md-lightbox';
    overlay.className = 'ag-lightbox';
    overlay.style.zIndex = '100100';
    overlay.innerHTML = `<img src="${_mdEsc(src)}" class="ag-lightbox-img" alt=""><span class="ag-lightbox-close">&times;</span>`;
    const closeLb = () => { overlay.remove(); document.removeEventListener('keydown', onKey, true); };
    const onKey = (e) => { if (e.key === 'Escape') { e.stopPropagation(); closeLb(); } };
    overlay.addEventListener('click', closeLb);
    document.addEventListener('keydown', onKey, true);
    document.body.appendChild(overlay);
  }
  if (!window.__agMdLightboxBound) {
    window.__agMdLightboxBound = true;
    document.addEventListener('click', (e) => {
      // «Ver más / Ver menos» de la descripción del detalle.
      const more = e.target.closest && e.target.closest('.agm-md [data-md-more]');
      if (more) {
        const box = more.parentElement && more.parentElement.querySelector('.agm-md-desc');
        if (box) {
          const folded = box.classList.toggle('is-folded');
          more.textContent = folded ? more.dataset.more : more.dataset.less;
        }
        return;
      }
      const el = e.target.closest && e.target.closest('.agm-md [data-lightbox]');
      if (!el) return;
      e.preventDefault();
      e.stopPropagation();
      openImageLightbox(el.getAttribute('data-lightbox'));
    });
  }

  // ─── @ DE TIKTOK CAMBIADO ───────────────────────────────────
  // Si el creador se cambia el @ en TikTok y su sesión de TikTok en la app ha
  // caducado, la app se queda con el viejo (la detección de arriba depende de
  // esa sesión). Su ficha de agencia sí trae el @ nuevo (lo pone el Backstage)
  // con el MISMO id numérico de TikTok. Si TikTok confirma que ese @ es de ese
  // id, se guarda en su cuenta y en el usuario con el que conecta. Una vez por
  // @ y sesión.
  const _renameTried = new Set();
  function cleanHandle(v) { return String(v == null ? '' : v).trim().toLowerCase().replace(/^@/, ''); }
  async function healRenamedTikTok(uid, userData, membership) {
    try {
      const myNum = String(state.tiktokNumericId || (userData && userData.tiktokNumericId) || '').trim();
      const mine = cleanHandle(state.tiktokUsername || (userData && userData.tiktokUsername));
      const theirs = cleanHandle(membership && membership.tiktokUsername);
      const theirNum = String((membership && membership.tiktokNumericId) || '').trim();
      if (!uid || !/^[0-9]{6,}$/.test(myNum) || theirNum !== myNum) return false;
      if (!theirs || theirs === mine || _renameTried.has(theirs)) return false;
      _renameTried.add(theirs);
      const profile = await window.tikcontrol?.fetchTikTokProfile?.(theirs);
      if (!profile || !profile.success || String(profile.userId || '') !== myNum) return false;
      await db().collection('users').doc(uid).update({ tiktokUsername: theirs });
      state.tiktokUsername = theirs;
      if (state.userData) state.userData.tiktokUsername = theirs;
      // El usuario con el que conecta al LIVE (mismas claves que la
      // detección por sesión de index.html) y los campos que lo muestran.
      try {
        const prevSaved = cleanHandle(localStorage.getItem('tikcontrol_tiktok_username'));
        if (!prevSaved || prevSaved === mine) localStorage.setItem('tikcontrol_tiktok_username', theirs);
        if (cleanHandle(localStorage.getItem('cfg-live-username')) === mine) localStorage.setItem('cfg-live-username', theirs);
      } catch (_) { /* almacenamiento no disponible */ }
      ['sidebar-username', 'cfg-live-username'].forEach((id) => {
        const el = document.getElementById(id);
        if (el && cleanHandle(el.value) === mine) el.value = theirs;
      });
      console.info('[Agencias] @' + mine + ' ahora es @' + theirs + ' en TikTok (mismo id): cuenta actualizada');
      return true;
    } catch (e) {
      console.warn('[Agencias] @ de TikTok cambiado:', e.message);
      return false;
    }
  }

  // ─── ROLE DETECTION (dinámico desde Firebase) ──────────────
  // Una sola detección a la vez: al arrancar llegan varias casi juntas (init,
  // cambio de sesión, primer snapshot de users/) y cada una consulta TikTok y
  // Firestore. Las que llegan con una en marcha se juntan en UNA más al
  // terminar (con el uid más reciente), y todas esperan a esa.
  let _roleRun = null;
  let _roleQueued = null;
  let _roleQueuedUid = null;
  function detectUserRole(uid) {
    if (!_roleRun) {
      _roleRun = _detectUserRole(uid).finally(() => { _roleRun = null; });
      return _roleRun;
    }
    _roleQueuedUid = uid;
    if (!_roleQueued) {
      _roleQueued = _roleRun.then(() => {
        _roleQueued = null;
        return detectUserRole(_roleQueuedUid);
      });
    }
    return _roleQueued;
  }

  async function _detectUserRole(uid) {
    if (!db() || !uid) return;

    try {
      const userDoc = await db().collection('users').doc(uid).get();
      if (!userDoc.exists) return;

      const data = userDoc.data();
      state.userData = data;
      state.tiktokUsername = data.tiktokUsername || null;
      state.tiktokNumericId = data.tiktokNumericId || null;

      // Sync TikTok username & PUBLIC profile numeric ID from all available sources
      // NOTE: The public profile ID (used in XLSX "ID de creador") is DIFFERENT from
      // the passport/account user_id. We need the PUBLIC one for XLSX matching.
      {
        const firebaseUser = (data.tiktokUsername || '').toLowerCase().trim();
        const currentNumericId = data.tiktokNumericId || '';

        // Get username from TikTok Login session
        let sessionUsername = null;
        let hasTikTokSession = false;
        try {
          const sessionRes = await window.tikcontrol.authRefreshUsername();
          sessionUsername = (sessionRes?.newUsername || sessionRes?.username || '').toLowerCase().trim();
          hasTikTokSession = !!(sessionRes?.username || sessionRes?.newUsername);
          console.log('[Agencias] Session refresh result:', JSON.stringify(sessionRes));
        } catch (_) { /* session not available */ }

        const lsUser = (localStorage.getItem('tiktok_user') || '').replace('@', '').toLowerCase().trim();
        const bestUsername = sessionUsername || lsUser || firebaseUser || '';
        
        // ALWAYS re-verify the public profile ID when we have a TikTok session
        // The passport API returns a DIFFERENT ID than the public profile - we need the public one
        const needsVerification = hasTikTokSession || lsUser;
        const needsUsernameUpdate = bestUsername && bestUsername !== firebaseUser;

        console.log('[Agencias] TikTok sync: firebaseUser=' + firebaseUser + ', sessionUser=' + sessionUsername + ', localStorage=' + lsUser + ', currentNumericId=' + currentNumericId + ', needsVerification=' + needsVerification);

        // Fetch the PUBLIC profile ID via fetchTikTokProfile (uses page scraping)
        if (needsVerification || !currentNumericId || needsUsernameUpdate) {
          console.log('[Agencias] Fetching PUBLIC profile ID for:', bestUsername);

          try {
            const profileRes = await window.tikcontrol.fetchTikTokProfile(bestUsername);
            console.log('[Agencias] fetchTikTokProfile result:', JSON.stringify(profileRes));
            if (profileRes?.success && profileRes.userId) {
              const updateData = {};
              const resolvedUsername = (profileRes.uniqueId || bestUsername).toLowerCase().trim();
              if (resolvedUsername && resolvedUsername !== firebaseUser) {
                updateData.tiktokUsername = resolvedUsername;
                state.tiktokUsername = resolvedUsername;
                if (state.userData) state.userData.tiktokUsername = resolvedUsername;
              }
              // Always update the numeric ID if it differs (may have had wrong passport ID before)
              const newNumericId = String(profileRes.userId);
              if (newNumericId !== currentNumericId) {
                updateData.tiktokNumericId = newNumericId;
                state.tiktokNumericId = newNumericId;
                if (state.userData) state.userData.tiktokNumericId = newNumericId;
                console.log('[Agencias] Updating numericId: old=' + currentNumericId + ' -> new=' + newNumericId);
              }
              if (Object.keys(updateData).length > 0) {
                await db().collection('users').doc(uid).update(updateData);
                console.log('[Agencias] Firebase updated with PUBLIC profile data:', JSON.stringify(updateData));
              } else {
                console.log('[Agencias] Public profile ID matches Firebase, no update needed');
              }
            } else {
              // Sin cuenta de TikTok todavía no hay perfil que consultar: es el
              // estado normal de quien acaba de instalar, no un aviso.
              const noUser = /no username/i.test(String(profileRes?.error || ''));
              (noUser ? console.debug : console.warn)('[Agencias] Could not get public profile ID:', profileRes?.error);
              // At least update the username if we have it
              if (sessionUsername && sessionUsername !== firebaseUser) {
                await db().collection('users').doc(uid).update({ tiktokUsername: sessionUsername });
                state.tiktokUsername = sessionUsername;
                if (state.userData) state.userData.tiktokUsername = sessionUsername;
                console.log('[Agencias] Updated username only:', sessionUsername);
              }
            }
          } catch (apiErr) {
            console.warn('[Agencias] API error:', apiErr.message);
          }
        } else {
          console.log('[Agencias] TikTok data already complete in Firebase, no sync needed');
        }
      }

      // Los roles se calculan en `next` y se publican de una vez al final.
      // La pestaña puede pintarse mientras esto espera a Firestore: antes el
      // estado se vaciaba aquí y se rellenaba poco a poco, y el selector de
      // vistas podía salir a medias (sin Owner/Manager, o solo «Creador»).
      // superOwnerAgencyId NO se toca: detectUserRole se re-ejecuta con cada
      // cambio del doc users/ y limpiarla expulsaría al admin de la consola
      // Super Owner en la que está; se limpia al final solo si la cuenta deja
      // de ser ADMIN (y al desloguear, en el router).
      const next = {
        isAdmin: data.ADMIN === true,
        isAgencyOwner: false,
        isManager: false,
        isTiktokManager: data.TIKTOK_MANAGER === true,
        tiktokManagerApprovedAgencies: [],
        ownerAgencyIds: [],
        managerAgencyIds: [],
        roleAgencies: {},
        staffRoles: {},
        staffOnlyAgencyIds: [],
        managerAgencyId: null,
        ownerAgencyId: null,
        userAgency: null,
        userMembership: null,
        pendingInvitation: null,
        whitelistMatch: null,
      };

      if (next.isTiktokManager) {
        next.tiktokManagerApprovedAgencies = await loadTiktokManagerApprovedAgencies(uid);
      }

      // Check OWNER / MANAGER roles (son roles distintos)
      // owner = Admin de agencia (acceso total al panel)
      // manager = Manager (acceso limitado, solo su cartera)
      // Fuente: users/{uid}.agencyRoles (ver agencyRoleOf), lo mismo que miran
      // las reglas y el Worker. Las marcas legacy (OWNER_X/MANAGER_X: true,
      // role, roles) se ignoran: el propio usuario podía escribírselas.
      // Se recogen TODAS las agencias de cada rol (antes se cogía la primera y
      // se paraba: quien lleva dos agencias solo veía una y no podía cambiar).
      const ownerIds = next.ownerAgencyIds, managerIds = next.managerAgencyIds;
      const fromMap = agencyRoleIds(data);
      for (const id of fromMap.ownerIds) if (!ownerIds.includes(id)) ownerIds.push(id);
      for (const id of fromMap.managerIds) if (!managerIds.includes(id)) managerIds.push(id);

      // Sin rol en users/: agencias cuyo doc apunta a este uid como dueño.
      // (Su agencia de creador se busca abajo como la de cualquiera: antes se
      // fijaba aquí la propia y un dueño que además es creador de OTRA agencia
      // se quedaba sin la opción «Creador».)
      if (!ownerIds.length) {
        const owned = await loadOwnedAgencies(uid);
        for (const a of owned) {
          if (!ownerIds.includes(a.id)) ownerIds.push(a.id);
          next.roleAgencies[a.id] = { id: a.id, name: a.name || a.id, logoUrl: a.logoUrl || '' };
        }
      }

      // Staff de la Estructura de Licencias (ver loadStaffAgencies): su rol da
      // nombre a la entrada del selector y, si no tiene flag MANAGER_, la
      // agencia entra igualmente como consola de staff (managerMode; el rol
      // concreto lo aplica la consola leyendo licStaff). En sus agencias de
      // Owner manda el rol de Owner.
      for (const { agency: ag, role } of await loadStaffAgencies(uid)) {
        if (ownerIds.includes(ag.id)) continue;
        const custom = ag.licCustomRoles && ag.licCustomRoles[role];
        next.staffRoles[ag.id] = { role, customName: (custom && custom.name) || '' };
        next.roleAgencies[ag.id] = { id: ag.id, name: ag.name || ag.id, logoUrl: ag.logoUrl || '' };
        if (!managerIds.includes(ag.id)) {
          managerIds.push(ag.id);
          next.staffOnlyAgencyIds.push(ag.id);
        }
      }

      next.isAgencyOwner = ownerIds.length > 0;
      next.isManager = managerIds.length > 0;
      // Agencia ACTIVA de cada rol: la que el usuario dejó seleccionada, si
      // sigue siendo suya; si no, la primera.
      next.ownerAgencyId = pickActiveAgency('owner', ownerIds);
      next.managerAgencyId = pickActiveAgency('manager', managerIds);
      // Nombres de todas sus agencias (para el selector "Tus agencias").
      await loadRoleAgencies(next);

      // Agencia SIN PUBLICAR por su Owner (published === false, ver
      // agencyHiddenTo): para sus creadores todavía no existe —ni «Tu
      // agencia» en Inicio ni la vista de creador ni la invitación—. Su
      // Owner, su staff y los ADMIN sí la ven (para configurarla).
      const hiddenToMe = (ag) => agencyHiddenTo(ag, uid, next);

      if (data.agencyId) {
        const own = await loadAgency(data.agencyId);
        if (!hiddenToMe(own)) {
          next.userAgency = own;
          // Cargar su membresía activa
          next.userMembership = await loadUserMembership(uid, data.agencyId);
        }
      }
      // Creadores vinculados por la sync del Backstage (o unidos sin que se
      // escribiera users.agencyId): la agencia sale de su ficha en
      // agency_members. Sin esto veían el Explorador en vez de su vista de
      // creador, y un Owner/Manager que además es creador de OTRA agencia no
      // tenía la opción «Creador». Se salta la ficha de una agencia borrada.
      if (!next.userAgency) {
        const memberships = await loadActiveMemberships(uid, { fresh: true }).catch(() => []);
        for (const m of memberships) {
          if (!m.agencyId) continue;
          const ag = await loadAgency(m.agencyId);
          if (ag && !hiddenToMe(ag)) { next.userAgency = ag; next.userMembership = m; break; }
        }
      }
      // Su ficha trae su @ actual de TikTok: si cambió, se pone al día (sin
      // esperar: no frena la detección de roles).
      if (next.userMembership && next.userMembership.id) healRenamedTikTok(uid, data, next.userMembership);

      // Si es owner/manager sin agencyId, cargar agencia y membresía desde el role
      if ((next.isAgencyOwner || next.isManager) && !next.userAgency) {
        const roleAgencyId = next.ownerAgencyId || next.managerAgencyId;
        if (roleAgencyId) {
          next.userAgency = await loadAgency(roleAgencyId);
          next.userMembership = await loadUserMembership(uid, roleAgencyId);
          // Si no tiene membresía en agency_members, crear un obj local mínimo para el nickname
          if (!next.userMembership) {
            next.userMembership = {
              id: null,
              userId: uid,
              agencyId: roleAgencyId,
              status: 'owner_manager'
            };
          }
        }
      }

      // Si NO tiene agencia, NO es admin/owner/manager → buscar dinámicamente
      if (!next.isAdmin && !next.isAgencyOwner && !next.isManager && !next.userAgency) {
        // 1. Buscar invitaciones pendientes en agency_members
        next.pendingInvitation = await checkPendingInvitation(uid);
        if (next.pendingInvitation && hiddenToMe(next.pendingInvitation.agency)) next.pendingInvitation = null;
        // 2. Buscar en whitelists por email, tiktok username, or tiktok numeric ID
        if (!next.pendingInvitation) {
          next.whitelistMatch = await checkWhitelists(data.email, state.tiktokUsername, state.tiktokNumericId);
        }
      }

      // La sesión cambió mientras se detectaba (cerrar sesión, otra cuenta):
      // el resultado es de otro usuario y no se publica.
      const authNow = auth();
      if (authNow && (!authNow.currentUser || authNow.currentUser.uid !== uid)) return;
      Object.assign(state, next);
      state.rolesCheckedAt = Date.now();
      // Super Owner: automático para los ADMIN de TikControl — cualquier
      // ADMIN entra a cualquier agencia con "Ver como Super Owner" (vista
      // Admin). Sin ADMIN no hay vista Super Owner: se limpia la agencia
      // activa que hubiera quedado de una sesión anterior.
      if (!state.isAdmin) { state.superOwnerAgencyId = null; endSuperOwnerSession(); }

    } catch (e) {
      console.error('[Agencias] Error detectando rol:', e);
    }
  }

  // ─── TIKTOK MANAGER HELPERS ─────────────────────────────────

  async function loadTiktokManagerApprovedAgencies(uid) {
    try {
      const snap = await db().collection('tiktok_manager_requests')
        .where('tiktokManagerUid', '==', uid)
        .where('status', '==', 'approved')
        .get();
      const ids = [];
      snap.forEach(doc => ids.push(doc.data().agencyId));
      return ids;
    } catch (e) {
      console.warn('[Agencias] Error cargando agencias aprobadas de TikTok Manager:', e.message);
      return [];
    }
  }

  async function sendTiktokManagerRequest(agencyId) {
    if (!state.currentUser || !state.isTiktokManager) return false;
    const uid = state.currentUser.uid;
    try {
      const existing = await db().collection('tiktok_manager_requests')
        .where('tiktokManagerUid', '==', uid)
        .where('agencyId', '==', agencyId)
        .where('status', 'in', ['pending', 'approved'])
        .limit(1).get();
      if (!existing.empty) {
        toast(t('agencies_tm_request_exists', 'Ya tienes una solicitud pendiente o aprobada para esta agencia'), 'info');
        return false;
      }
      const alreadyAssigned = await db().collection('tiktok_manager_requests')
        .where('agencyId', '==', agencyId)
        .where('status', '==', 'approved')
        .limit(1).get();
      if (!alreadyAssigned.empty) {
        toast(t('agencies_tm_agency_has_manager', 'Esta agencia ya tiene un Manager TikTok asignado'), 'error');
        return false;
      }
      await db().collection('tiktok_manager_requests').add({
        tiktokManagerUid: uid,
        tiktokManagerEmail: state.currentUser.email || '',
        agencyId,
        status: 'pending',
        createdAt: serverTimestamp()
      });
      toast(t('agencies_tm_request_sent', 'Solicitud enviada al Owner de la agencia'), 'success');
      return true;
    } catch (e) {
      toast(t('agencies_tm_request_error', 'Error al enviar solicitud') + ': ' + e.message, 'error');
      return false;
    }
  }

  async function sendRecommendedAction(agencyId, actionType, actionData) {
    if (!state.currentUser) return false;
    const senderType = state.isTiktokManager ? 'tiktok_manager' : (state.isAdmin ? 'admin' : null);
    if (!senderType) return false;
    try {
      await db().collection('agency_recommended_actions').add({
        agencyId,
        type: actionType,
        senderType,
        senderUid: state.currentUser.uid,
        senderEmail: state.currentUser.email || '',
        data: actionData,
        status: 'pending',
        createdAt: serverTimestamp()
      });
      toast(t('agencies_tm_action_sent', 'Acción recomendada enviada'), 'success');
      return true;
    } catch (e) {
      toast(t('agencies_tm_action_error', 'Error al enviar') + ': ' + e.message, 'error');
      return false;
    }
  }

  async function loadRecommendedActions(agencyId) {
    try {
      const snap = await db().collection('agency_recommended_actions')
        .where('agencyId', '==', agencyId)
        .where('status', '==', 'pending')
        .get();
      const actions = [];
      snap.forEach(doc => actions.push({ id: doc.id, ...doc.data() }));
      return actions;
    } catch (e) {
      console.warn('[Agencias] Error cargando acciones recomendadas:', e.message);
      return [];
    }
  }

  async function loadTiktokManagerRequests(agencyId) {
    try {
      const snap = await db().collection('tiktok_manager_requests')
        .where('agencyId', '==', agencyId)
        .get();
      const requests = [];
      snap.forEach(doc => requests.push({ id: doc.id, ...doc.data() }));
      return requests;
    } catch (e) {
      return [];
    }
  }

  async function respondTiktokManagerRequest(requestId, approved) {
    try {
      const reqDoc = await db().collection('tiktok_manager_requests').doc(requestId).get();
      if (!reqDoc.exists) return false;
      const reqData = reqDoc.data();

      if (approved) {
        // Rechazar todas las demás solicitudes pendientes o aprobadas para esta agencia
        const othersSnap = await db().collection('tiktok_manager_requests')
          .where('agencyId', '==', reqData.agencyId)
          .get();
        const batch = db().batch();
        othersSnap.forEach(doc => {
          if (doc.id !== requestId && (doc.data().status === 'pending' || doc.data().status === 'approved')) {
            batch.update(doc.ref, {
              status: 'rejected',
              respondedAt: serverTimestamp(),
              respondedBy: state.currentUser?.uid || '',
              rejectedReason: 'another_manager_approved'
            });
          }
        });
        batch.update(db().collection('tiktok_manager_requests').doc(requestId), {
          status: 'approved',
          respondedAt: serverTimestamp(),
          respondedBy: state.currentUser?.uid || ''
        });
        await batch.commit();
      } else {
        await db().collection('tiktok_manager_requests').doc(requestId).update({
          status: 'rejected',
          respondedAt: serverTimestamp(),
          respondedBy: state.currentUser?.uid || ''
        });
      }

      toast(approved ? t('agencies_tm_request_approved', 'Solicitud aprobada') : t('agencies_tm_request_rejected', 'Solicitud rechazada'), 'success');
      return true;
    } catch (e) {
      toast(t('agencies_admin_error', 'Error') + ': ' + e.message, 'error');
      return false;
    }
  }

  async function revokeTiktokManager(requestId) {
    try {
      await db().collection('tiktok_manager_requests').doc(requestId).update({
        status: 'revoked',
        revokedAt: serverTimestamp(),
        revokedBy: state.currentUser?.uid || ''
      });
      toast(t('agencies_tm_revoked', 'Acceso de Manager TikTok revocado'), 'success');
      return true;
    } catch (e) {
      toast(t('agencies_admin_error', 'Error') + ': ' + e.message, 'error');
      return false;
    }
  }

  // ─── DYNAMIC CHECKS (todo desde Firebase) ─────────────────

  // Cargar membresía activa del usuario
  const ACTIVE_MEMBER_STATUSES = ['approved', 'linked'];
  async function loadUserMembership(uid, agencyId) {
    try {
      const snap = await db().collection('agency_members')
        .where('userId', '==', uid)
        .where('agencyId', '==', agencyId)
        .where('status', 'in', ACTIVE_MEMBER_STATUSES)
        .limit(1)
        .get();
      if (snap.empty) return null;
      const doc = snap.docs[0];
      return { id: doc.id, ...doc.data() };
    } catch (e) {
      return null;
    }
  }

  // ─── STATS COLLECTOR (arranque headless) ────────────────────
  // stats-collector.js escribe user_stats.dailyStats, la serie diaria que
  // pintan las gráficas de la consola (Evolución/Rendimiento del creador).
  // Antes solo arrancaba desde agencias/index.js — que solo se carga al abrir
  // la pestaña Agencias, bloqueada para no-ADMIN — y solo si users.agencyId
  // estaba puesto (los vinculados por el sync del Backstage no lo tienen):
  // ningún creador normal generaba datos. Ahora lo arranca también Inicio en
  // cuanto hay sesión, y basta con una membresía activa (approved/linked).
  // Membresías activas del usuario: aprobadas o vinculadas por la sync del
  // Backstage (estas no escriben users.agencyId). Una consulta que comparten
  // detectUserRole (fresh) y el colector de stats (la de la sesión).
  const _membershipsCache = {}; // uid → Promise<Array<{id, agencyId, status…}>>
  function loadActiveMemberships(uid, opts = {}) {
    if (!uid || !db()) return Promise.resolve([]);
    if (!opts.fresh && _membershipsCache[uid]) return _membershipsCache[uid];
    const p = db().collection('agency_members')
      .where('userId', '==', uid)
      .where('status', 'in', ACTIVE_MEMBER_STATUSES)
      .limit(10).get()
      .then((snap) => snap.docs.map((d) => ({ id: d.id, ...d.data() })))
      .catch((e) => {
        if (_membershipsCache[uid] === p) delete _membershipsCache[uid]; // el fallo no se guarda: se reintenta
        throw e;
      });
    _membershipsCache[uid] = p;
    return p;
  }
  async function hasActiveMembership(uid) {
    try {
      return (await loadActiveMemberships(uid)).length > 0;
    } catch (e) {
      console.warn('[Agencias] hasActiveMembership:', e.message);
      return false;
    }
  }

  let _collectorImport = null;
  let _collectorUid = null;
  // Arranca el colector si el usuario tiene agencia, es ADMIN (acredita las
  // stats al miembro cuyo LIVE conecta, ver resolveTargetUid) o tiene una
  // membresía activa. Idempotente: varias llamadas no duplican listeners.
  async function ensureStatsCollector(uid) {
    if (!uid) return false;
    const should = !!state.userAgency || state.isAdmin === true || await hasActiveMembership(uid);
    if (!should) return false;
    if (!window.AgenciasStatsCollector) {
      if (!_collectorImport) {
        const version = document.querySelector('meta[name="app-version"]')?.content || '';
        _collectorImport = import(`./stats-collector.js?v=${version}`).catch((e) => {
          console.warn('[Agencias] stats-collector no disponible:', e.message);
          _collectorImport = null;
        });
      }
      await _collectorImport;
    }
    const c = window.AgenciasStatsCollector;
    if (!c) return false;
    if (!c.isCollecting()) { c.start(uid); _collectorUid = uid; }
    return true;
  }
  function stopStatsCollector() {
    const c = window.AgenciasStatsCollector;
    if (c && c.isCollecting()) c.stop(_collectorUid);
    _collectorUid = null;
  }

  // Buscar invitaciones pendientes (status = 'pending' o 'invited')
  async function checkPendingInvitation(uid) {
    try {
      const snap = await db().collection('agency_members')
        .where('userId', '==', uid)
        .where('status', 'in', ['pending', 'invited'])
        .limit(1)
        .get();
      if (snap.empty) return null;
      const doc = snap.docs[0];
      const data = doc.data();
      // Cargar datos de la agencia
      const agency = await loadAgency(data.agencyId);
      return { id: doc.id, ...data, agency };
    } catch (e) {
      return null;
    }
  }

  // ¿Está el usuario en la lista de autorizados de alguna agencia? (email,
  // usuario de TikTok o ID numérico). Lo resuelve el Worker con un índice
  // cacheado: antes cada app sin agencia leía aquí TODAS las agencias y hasta
  // 3 documentos por agencia validada en cada inicio de sesión. El Worker usa
  // el email del token y el usuario/ID de TikTok de users/{uid}; los
  // parámetros se mantienen por compatibilidad con quien la llama.
  async function checkWhitelists(/* email, tiktokUsername, tiktokNumericId */) {
    try {
      const user = auth() && auth().currentUser;
      if (!user || typeof user.getIdToken !== 'function') return null;
      const token = await user.getIdToken();
      const res = await fetch(apiBase() + '/api/agency/whitelist-match', {
        method: 'POST',
        headers: { Authorization: 'Bearer ' + token, 'Content-Type': 'application/json' },
        body: '{}',
      });
      if (!res.ok) return null;
      const json = await res.json();
      return json && json.match && json.match.agencyId ? json.match : null;
    } catch (e) {
      console.error('[Agencias] Error verificando whitelists:', e);
      return null;
    }
  }

  // ─── ACCIONES DINÁMICAS ────────────────────────────────────

  // Unirse a agencia (desde whitelist match)
  async function joinAgencyFromWhitelist(whitelistMatch) {
    if (!whitelistMatch || !state.currentUser) return false;
    try {
      const uid = state.currentUser.uid;
      const agencyId = whitelistMatch.agencyId;

      // Fase 8: comprobar suscripción dual
      await checkDualSubscription();

      // 1. Crear membresía en Firebase (sin licencia - el owner la asigna manualmente)
      const memberRef = await db().collection('agency_members').add({
        userId: uid,
        userEmail: state.currentUser.email,
        agencyId: agencyId,
        tiktokUsername: state.tiktokUsername || '',
        status: 'approved',
        licenseType: 'none',
        creditCost: 0,
        joinMethod: 'whitelist_' + whitelistMatch.type,
        appliedAt: serverTimestamp(),
        approvedAt: serverTimestamp(),
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      });

      // 2. Actualizar usuario en Firebase (sin premium - licencia es manual)
      await db().collection('users').doc(uid).update({
        agencyId: agencyId,
        agencyJoinedAt: serverTimestamp()
      });

      // 3. ACTUALIZAR ESTADO LOCAL INMEDIATAMENTE (sin esperar re-lectura)
      //    Esto es clave para que la UI se actualice al instante
      state.userAgency = await loadAgency(agencyId) || whitelistMatch.agency;
      state.userMembership = { id: memberRef.id, userId: uid, agencyId: agencyId, status: 'approved' };
      state.whitelistMatch = null;
      state.pendingInvitation = null;
      if (state.userData) state.userData.agencyId = agencyId;

      console.log('[Agencias] Unido a agencia desde whitelist:', agencyId);
      refreshAgencyStats(agencyId);
      return true;
    } catch (e) {
      console.error('[Agencias] Error uniéndose desde whitelist:', e);
      toast(t('agencies_join_error', 'Error al unirse') + ': ' + e.message, 'error');
      return false;
    }
  }

  // Aceptar invitación pendiente
  async function acceptInvitation(invitation) {
    if (!invitation || !state.currentUser) return false;
    try {
      const uid = state.currentUser.uid;
      const agencyId = invitation.agencyId;

      // Fase 8: comprobar suscripción dual
      await checkDualSubscription();

      // 1. Actualizar membresía a approved en Firebase (sin licencia - el owner la asigna manualmente)
      const updateData = {
        status: 'approved',
        approvedAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      };
      if (!invitation.licenseType) {
        updateData.licenseType = 'none';
        updateData.creditCost = 0;
      }
      await db().collection('agency_members').doc(invitation.id).update(updateData);

      // 2. Actualizar usuario en Firebase (sin premium - licencia es manual)
      await db().collection('users').doc(uid).update({
        agencyId: agencyId,
        agencyJoinedAt: serverTimestamp()
      });

      // 3. ACTUALIZAR ESTADO LOCAL INMEDIATAMENTE
      state.userAgency = invitation.agency || await loadAgency(agencyId);
      state.userMembership = { id: invitation.id, userId: uid, agencyId: agencyId, status: 'approved' };
      state.pendingInvitation = null;
      state.whitelistMatch = null;
      if (state.userData) state.userData.agencyId = agencyId;

      console.log('[Agencias] Invitación aceptada:', agencyId);
      refreshAgencyStats(agencyId);
      return true;
    } catch (e) {
      console.error('[Agencias] Error aceptando invitación:', e);
      toast(t('agencies_accept_error', 'Error al aceptar') + ': ' + e.message, 'error');
      return false;
    }
  }

  // Rechazar invitación
  async function rejectInvitation(invitation) {
    if (!invitation) return false;
    try {
      await db().collection('agency_members').doc(invitation.id).update({
        status: 'rejected',
        rejectedAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      });
      state.pendingInvitation = null;
      return true;
    } catch (e) {
      toast(t('agencies_reject_error', 'Error al rechazar') + ': ' + e.message, 'error');
      return false;
    }
  }

  // Salir de la agencia
  async function leaveAgency() {
    if (!state.currentUser || !state.userMembership) return false;
    try {
      const uid = state.currentUser.uid;
      const leftAgencyId = state.userMembership.agencyId;

      // 1. Soltar la licencia de la agencia ANTES de irse: el Worker le
      // devuelve su plan (reanudando el cobro que la agencia le pausó) y
      // libera los créditos. Si falla, no se sale: se quedaría con la
      // licencia pagada por una agencia a la que ya no pertenece.
      const userDoc = await db().collection('users').doc(uid).get();
      const userData = userDoc.exists ? userDoc.data() : {};
      const licensed = userData.agencyLicense === true
        || (!!state.userMembership.licenseType && state.userMembership.licenseType !== 'none');
      if (licensed) {
        const res = await licenseApi('release', { agencyId: leftAgencyId, reason: 'left' });
        if (!res.ok) throw new Error(licenseErrorText(res));
      }

      // 2. Actualizar membresía en Firebase
      await db().collection('agency_members').doc(state.userMembership.id).update({
        status: 'left',
        leftAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      });

      // 3. Quitar la agencia del usuario
      await db().collection('users').doc(uid).update({ agencyId: null, agencyJoinedAt: null });

      // 4. ACTUALIZAR ESTADO LOCAL INMEDIATAMENTE (el plan, tal como lo ha
      // dejado el Worker)
      state.userAgency = null;
      state.userMembership = null;
      state.pendingInvitation = null;
      state.whitelistMatch = null;
      if (state.userData) {
        state.userData.agencyId = null;
        if (licensed) {
          const fresh = await db().collection('users').doc(uid).get().catch(() => null);
          const fd = (fresh && fresh.exists && fresh.data()) || {};
          state.userData.plan = fd.plan || 'free';
          state.userData.stripeStatus = fd.stripeStatus || null;
          state.userData.agencyLicense = fd.agencyLicense || null;
        }
      }

      console.log('[Agencias] Ha salido de la agencia');
      return true;
    } catch (e) {
      toast(t('agencies_leave_error', 'Error al salir') + ': ' + e.message, 'error');
      return false;
    }
  }

  // ─── FASE 8: DETECCIÓN SUSCRIPCIÓN DUAL ────────────────────
  // Comprueba si el usuario ya tiene una suscripción Premium activa
  // y muestra un modal para que decida si cancelar la personal
  async function checkDualSubscription() {
    const userData = state.userData;
    if (!userData) return 'free';

    const plan = userData.plan || 'free';
    const stripeStatus = userData.stripeStatus || '';
    const isPremium = plan !== 'free' && stripeStatus === 'active';

    if (!isPremium) return 'free';

    // El usuario ya paga Premium - mostrar modal informativo
    return new Promise((resolve) => {
      showModal(
        t('agencies_dual_sub_title', 'Ya tienes Premium activo'),
        `
          <div style="text-align:center;padding:10px 0;">
            <span style="font-size:2.5em;">⚠️</span>
            <h3 style="margin:12px 0 8px;">${t('agencies_dual_sub_heading', '¡Ya eres usuario Premium!')}</h3>
            <p class="ag-text-muted" style="max-width:420px;margin:0 auto 16px;">
              ${t('agencies_dual_sub_desc', 'Tienes una suscripción Premium activa. Al unirte a una agencia, la agencia cubrirá tu acceso Premium. Puedes cancelar tu suscripción personal para evitar pagar dos veces.')}
            </p>
            <div class="ag-card" style="text-align:left;padding:16px;margin:16px 0;">
              <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;">
                <span>${t('agencies_your_plan', 'Tu plan actual')}:</span>
                <strong>${plan.replace('premium_', 'Premium ').replace('monthly', t('agencies_monthly', 'Mensual')).replace('6months', t('agencies_6months', '6 Meses')).replace('year', t('agencies_annual', 'Anual'))}</strong>
              </div>
              <div style="display:flex;justify-content:space-between;align-items:center;">
                <span>${t('agencies_stripe_status', 'Estado Stripe')}:</span>
                <span class="ag-badge ag-badge-success">${t('agencies_active', 'Activo')}</span>
              </div>
            </div>
          </div>
        `,
        `
          <button class="btn btn-secondary" id="ag-dual-keep">${t('agencies_keep_subscription', 'Mantener suscripción')}</button>
          <button class="btn btn-danger" id="ag-dual-cancel">${t('agencies_cancel_subscription', 'Cancelar mi suscripción')}</button>
        `,
        { size: 'md' }
      );

      document.getElementById('ag-dual-keep')?.addEventListener('click', () => {
        closeModal();
        resolve('keep');
      });

      document.getElementById('ag-dual-cancel')?.addEventListener('click', async () => {
        // Intentar cancelar suscripción en Stripe via premiumManager
        try {
          if (window.premiumManager?.cancelSubscription) {
            await window.premiumManager.cancelSubscription();
            toast(t('agencies_sub_cancelled', 'Suscripción cancelada correctamente'), 'success');
          } else {
            // Fallback: abrir modal de gestión de suscripción
            toast(t('agencies_cancel_manual', 'Ve a Configuración > Suscripción para cancelar manualmente'), 'info');
          }
        } catch (e) {
          toast(t('agencies_cancel_error', 'Error al cancelar') + ': ' + e.message, 'error');
        }
        closeModal();
        resolve('cancelled');
      });

      // Si cierran el modal sin elegir
      const modalOverlay = document.querySelector('.ag-modal-overlay');
      if (modalOverlay) {
        modalOverlay.addEventListener('click', (e) => {
          if (e.target === modalOverlay) {
            closeModal();
            resolve('keep');
          }
        });
      }
    });
  }

  // ─── REALTIME LISTENERS ─────────────────────────────────────

  // Limpia todos los listeners activos
  function cleanupRealtimeListeners() {
    state.realtimeUnsubs.forEach(unsub => {
      try { unsub(); } catch (e) { /* ignore */ }
    });
    state.realtimeUnsubs = [];
  }

  // Listener en tiempo real al documento del usuario (detecta cambios de rol, agencyId, etc.)
  // Refactor 2026-04: se subscribe al evento `tikcontrol:userDocUpdated` que
  // dispara el listener central de auth.js en vez de abrir otro onSnapshot.
  function watchUserDocument(uid, onChanged) {
    if (!uid) return;
    const handler = (e) => {
      const data = e.detail;
      if (!data) return;
      const prev = state.userData;

      // Detectar si algo relevante cambió
      const roleChanged = prev?.agencyId !== data.agencyId
        || prev?.ADMIN !== data.ADMIN
        || prev?.ADMIN_VIEWER !== data.ADMIN_VIEWER;

      // Detectar si se añadieron/quitaron/cambiaron roles de agencia
      const rolesSig = (d) => Object.entries((d && d.agencyRoles) || {}).map(([k, v]) => k + ':' + v).sort().join(',');
      const keysChanged = rolesSig(prev) !== rolesSig(data);

      // Detectar cambio de plan premium (licencia de agencia u otro)
      const planChanged = prev?.plan !== data.plan || prev?.stripeStatus !== data.stripeStatus;

      if (roleChanged || keysChanged) {
        console.log('[Agencias] Cambio de rol detectado en tiempo real');
        if (onChanged) onChanged(data);
      }

      if (planChanged) {
        console.log('[Agencias] Cambio de plan detectado:', prev?.plan, '->', data.plan);
        if (window.premiumManager?.checkStatus) {
          window.premiumManager.checkStatus();
        }
      }

      state.userData = data;
      state.tiktokUsername = data.tiktokUsername || null;
      state.tiktokNumericId = data.tiktokNumericId || null;
    };
    window.addEventListener('tikcontrol:userDocUpdated', handler);
    const unsub = () => window.removeEventListener('tikcontrol:userDocUpdated', handler);
    state.realtimeUnsubs.push(unsub);
    return unsub;
  }

  // Listener en tiempo real a las invitaciones del usuario
  function watchInvitations(uid, onInvitation) {
    if (!db() || !uid) return;
    const unsub = db().collection('agency_members')
      .where('userId', '==', uid)
      .where('status', 'in', ['pending', 'invited'])
      .onSnapshot(
        async (snap) => {
          if (snap.empty) {
            if (state.pendingInvitation) {
              state.pendingInvitation = null;
              if (onInvitation) onInvitation(null);
            }
            return;
          }
          const doc = snap.docs[0];
          const data = doc.data();
          const agency = await loadAgency(data.agencyId);
          // La de una agencia sin publicar todavía no se enseña: sin esto, el
          // primer aviso de este vigilante volvía a poner la invitación que
          // detectUserRole acababa de apartar.
          if (agencyHiddenTo(agency, uid)) {
            if (state.pendingInvitation) {
              state.pendingInvitation = null;
              if (onInvitation) onInvitation(null);
            }
            return;
          }
          state.pendingInvitation = { id: doc.id, ...data, agency };
          console.log('[Agencias] Invitación pendiente detectada en tiempo real:', data.agencyId);
          if (onInvitation) onInvitation(state.pendingInvitation);
        },
        (err) => console.error('[Agencias] Error en listener de invitaciones:', err)
      );
    state.realtimeUnsubs.push(unsub);
    return unsub;
  }

  // Listener en tiempo real a la agencia del usuario (cuando ya es miembro)
  function watchAgency(agencyId, onChanged) {
    if (!db() || !agencyId) return;
    const unsub = db().collection('agencies').doc(agencyId).onSnapshot(
      (doc) => {
        if (!doc.exists) {
          state.userAgency = null;
          if (onChanged) onChanged(null);
          return;
        }
        state.userAgency = { id: doc.id, ...doc.data() };
        if (onChanged) onChanged(state.userAgency);
      },
      (err) => console.error('[Agencias] Error en listener de agencia:', err)
    );
    state.realtimeUnsubs.push(unsub);
    return unsub;
  }

  // Listener genérico: membresía del usuario en su agencia
  function watchMembership(uid, agencyId, onChanged) {
    if (!db() || !uid || !agencyId) return;
    const unsub = db().collection('agency_members')
      .where('userId', '==', uid)
      .where('agencyId', '==', agencyId)
      .limit(1)
      .onSnapshot(
        (snap) => {
          if (snap.empty) {
            state.userMembership = null;
            if (onChanged) onChanged(null);
            return;
          }
          const doc = snap.docs[0];
          const data = { id: doc.id, ...doc.data() };
          const statusChanged = state.userMembership?.status !== data.status;
          state.userMembership = data;
          if (statusChanged && onChanged) onChanged(data);
        },
        (err) => console.error('[Agencias] Error en listener de membresía:', err)
      );
    state.realtimeUnsubs.push(unsub);
    return unsub;
  }

  // ─── UPLOAD HELPERS ─────────────────────────────────────────
  function readFileAsBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64Data = reader.result;
        const base64Content = base64Data.split(',')[1];
        resolve(base64Content);
      };
      reader.onerror = () => reject(new Error(t('agencies_file_read_error', 'Error leyendo archivo')));
      reader.readAsDataURL(file);
    });
  }

  // fileType: carpeta en R2 (agencies/<id>/<carpeta>/, ver AGENCY_UPLOAD_FOLDERS
  // del Worker): tutorial, tutorial_thumb, creative, creative_thumb, cover,
  // news, message, mission, event, prize, tiktok_manager… Sin él, files/.
  async function uploadAgencyFile(agencyId, file, agencyPlan = 'silver', fileType = '') {
    if (!file) return { success: false, error: t('agencies_no_file', 'Sin archivo') };
    if (file.size > 500 * 1024 * 1024) return { success: false, error: t('agencies_file_too_large', 'Archivo demasiado grande (max. 500MB)') };
    try {
      const filePath = window.tikcontrol?.getPathForFile?.(file) || file.path || '';
      if (filePath) {
        return await window.tikcontrol.cloudStorage.uploadAgencyFile(agencyId, {
          filePath,
          fileName: file.name,
          mimeType: file.type,
          fileType: fileType || undefined,
          agencyPlan
        });
      }
      if (file.size > 250 * 1024 * 1024) {
        return {
          success: false,
          error: t('agencies_large_file_requires_desktop_path', 'No se pudo acceder a la ruta local del archivo para subirlo por partes. Vuelve a seleccionar el archivo desde la app de escritorio.')
        };
      }
      const base64Content = await readFileAsBase64(file);
      return await window.tikcontrol.cloudStorage.uploadAgencyFile(agencyId, {
        base64Content,
        fileName: file.name,
        mimeType: file.type,
        fileType: fileType || undefined,
        agencyPlan
      });
    } catch (e) {
      return { success: false, error: e.message };
    }
  }

  async function deleteAgencyFile(agencyId, s3Key) {
    try {
      return await window.tikcontrol.cloudStorage.deleteAgencyFile(agencyId, s3Key);
    } catch (e) {
      return { success: false, error: e.message };
    }
  }

  // ─── RECORTADOR DE IMÁGENES (logo 1:1 · banner 10:3 · miniatura 16:9) ──
  // Devuelve un File ya recortado — PNG, o JPEG con opts.type 'image/jpeg'
  // (+ opts.quality) para fotos —, o null si el usuario cancela. Sin
  // librerías: la imagen se mueve y escala con CSS dentro del encuadre y el
  // recorte final se pinta en un canvas del tamaño de salida. Si el archivo
  // no se puede leer como imagen, se devuelve tal cual.
  // opts.fit 'original': la imagen abre a su tamaño real (sin zoom) para
  // elegir la zona arrastrando; el zoom se puede reducir hasta verla entera.
  // Sin él, abre llenando el encuadre (logo, banner).
  // Recortador. Dos modos:
  //  · por defecto: la imagen llena el encuadre y se arrastra/amplía (logo, banner);
  //  · opts.mode 'frame': se ve la imagen ENTERA y un recuadro con la
  //    proporción pedida marca lo que se verá; se arrastra y se estira por
  //    las esquinas (miniaturas de tutorial). Con opts.outside el recuadro
  //    puede salirse de la imagen (logo, banner e imagen de tarjeta).
  // opts.type: 'image/png' (por defecto), 'image/jpeg' o 'image/webp'.
  function openImageCropper(file, opts = {}) {
    if (opts.mode === 'frame') return openFrameCropper(file, opts);
    const aspect = opts.aspect || 1;
    const outW = opts.width || 512;
    const outH = Math.round(outW / aspect);
    const outType = opts.type === 'image/jpeg' ? 'image/jpeg' : 'image/png';
    return new Promise((resolve) => {
      const url = URL.createObjectURL(file);
      const img = new Image();
      img.onerror = () => { URL.revokeObjectURL(url); resolve(file); };
      img.onload = () => {
        const vw = Math.min(460, Math.floor(window.innerWidth * 0.8));
        const vh = Math.round(vw / aspect);
        const iw = img.naturalWidth, ih = img.naturalHeight;
        const cover = Math.max(vw / iw, vh / ih);   // la imagen nunca deja hueco en el encuadre
        const base = opts.fit === 'original' && cover < 1 ? 1 : cover;   // tamaño real, si cabe
        const zMin = Math.min(1, cover / base), zMax = 4;
        let z = 1, ox = (vw - iw * base) / 2, oy = (vh - ih * base) / 2;
        const ov = document.createElement('div');
        ov.className = 'ag-crop-overlay';
        ov.innerHTML = `<div class="ag-crop" role="dialog" aria-modal="true">
          <div class="ag-crop-head"><h3>${t('agencies_crop_title', 'Recortar imagen')}</h3><p>${base !== cover ? t('agencies_crop_hint_zone', 'Arrastra la imagen para elegir la zona. Se ve a su tamaño real: reduce el zoom para verla entera.') : t('agencies_crop_hint', 'Arrastra la imagen para encuadrarla y ajusta el zoom.')}</p></div>
          <div class="ag-crop-view" style="width:${vw}px;height:${vh}px"><img alt="" draggable="false"></div>
          <label class="ag-crop-zoom">${t('agencies_crop_zoom', 'Zoom')}<input type="range" min="${zMin}" max="${zMax}" step="any" value="1"></label>
          <div class="ag-crop-actions"><button type="button" class="btn btn-secondary" data-crop-cancel>${t('agencies_cancel', 'Cancelar')}</button><button type="button" class="btn btn-primary" data-crop-ok>${t('agencies_crop_apply', 'Recortar y usar')}</button></div>
        </div>`;
        document.body.appendChild(ov);
        const view = ov.querySelector('.ag-crop-view');
        const el = ov.querySelector('.ag-crop-view img');
        const range = ov.querySelector('input[type="range"]');
        el.src = url; el.style.width = iw + 'px'; el.style.height = ih + 'px';
        const paint = () => {
          const w = iw * base * z, h = ih * base * z;
          ox = Math.min(0, Math.max(vw - w, ox));
          oy = Math.min(0, Math.max(vh - h, oy));
          el.style.transform = `translate(${ox}px,${oy}px) scale(${base * z})`;
        };
        // Zoom centrado en el encuadre (rueda o deslizador).
        const setZoom = (nz) => {
          nz = Math.min(zMax, Math.max(zMin, nz));
          const k = nz / z, cx = vw / 2, cy = vh / 2;
          ox = cx - (cx - ox) * k; oy = cy - (cy - oy) * k; z = nz;
          range.value = String(z);
          paint();
        };
        range.addEventListener('input', () => setZoom(parseFloat(range.value)));
        view.addEventListener('wheel', (e) => { e.preventDefault(); setZoom(z * (e.deltaY < 0 ? 1.08 : 1 / 1.08)); }, { passive: false });
        let drag = null;
        view.addEventListener('pointerdown', (e) => { drag = { x: e.clientX - ox, y: e.clientY - oy }; view.setPointerCapture(e.pointerId); });
        view.addEventListener('pointermove', (e) => { if (!drag) return; ox = e.clientX - drag.x; oy = e.clientY - drag.y; paint(); });
        const stopDrag = () => { drag = null; };
        view.addEventListener('pointerup', stopDrag);
        view.addEventListener('pointercancel', stopDrag);
        const onKey = (e) => { if (e.key === 'Escape') { e.stopPropagation(); done(null); } };
        const done = (out) => { document.removeEventListener('keydown', onKey, true); ov.remove(); URL.revokeObjectURL(url); resolve(out); };
        document.addEventListener('keydown', onKey, true);
        ov.querySelector('[data-crop-cancel]').addEventListener('click', () => done(null));
        ov.addEventListener('mousedown', (e) => { if (e.target === ov) done(null); });
        ov.querySelector('[data-crop-ok]').addEventListener('click', () => {
          const c = document.createElement('canvas');
          c.width = outW; c.height = outH;
          const sc = base * z;
          c.getContext('2d').drawImage(img, -ox / sc, -oy / sc, vw / sc, vh / sc, 0, 0, outW, outH);
          c.toBlob((blob) => {
            if (!blob) { done(null); return; }
            const name = String(file.name || 'imagen').replace(/\.[a-z0-9]+$/i, '') + (outType === 'image/jpeg' ? '.jpg' : '.png');
            done(new File([blob], name, { type: outType }));
          }, outType, opts.quality);
        });
        paint();
      };
      img.src = url;
    });
  }
  // opts.outside: el recuadro puede salirse de la imagen (logo, banner,
  // imagen de tarjeta) para que se vea entera; lo que queda fuera sale
  // transparente (PNG / WEBP). El visor deja margen alrededor y hay atajos
  // para «Imagen entera» (el recuadro la abarca) y «Rellenar» (el mayor
  // recuadro sin huecos).
  function openFrameCropper(file, opts) {
    const aspect = opts.aspect || 1;
    const outW = opts.width || 512;
    const outH = Math.round(outW / aspect);
    const outType = ['image/jpeg', 'image/webp'].includes(opts.type) ? opts.type : 'image/png';
    const outside = !!opts.outside;
    return new Promise((resolve) => {
      const url = URL.createObjectURL(file);
      const img = new Image();
      img.onerror = () => { URL.revokeObjectURL(url); resolve(file); };
      img.onload = () => {
        const iw = img.naturalWidth, ih = img.naturalHeight;
        // Visor: la imagen entera o, con outside, un lienzo con la proporción
        // del recuadro que la abarca entera más un margen.
        const fitW = Math.max(iw, ih * aspect);          // recuadro que abarca la imagen (px de imagen)
        const MARGIN = 1.3;
        const sw = outside ? fitW * MARGIN : iw, sh = outside ? fitW / aspect * MARGIN : ih;
        const maxW = Math.min(760, Math.floor(window.innerWidth * 0.82)), maxH = Math.min(460, Math.floor(window.innerHeight * 0.55));
        const s = Math.min(maxW / sw, maxH / sh, 2);
        const vw = Math.round(sw * s), vh = Math.round(sh * s);
        const dw = iw * s, dh = ih * s;
        const ix = (vw - dw) / 2, iy = (vh - dh) / 2;      // la imagen, centrada en el visor
        const coverFw = Math.min(dw, dh * aspect);         // el mayor recuadro sin huecos
        const wholeFw = Math.max(dw, dh * aspect);         // el que abarca la imagen entera
        const maxFw = outside ? Math.min(vw, vh * aspect) : coverFw;
        const minFw = Math.max(24, coverFw * 0.2);
        let fw = coverFw, fx = ix + (dw - fw) / 2, fy = iy + (dh - fw / aspect) / 2;
        const ov = document.createElement('div');
        ov.className = 'ag-crop-overlay';
        ov.innerHTML = `<div class="ag-crop" role="dialog" aria-modal="true">
          <div class="ag-crop-head"><h3>${t('agencies_crop_title', 'Recortar imagen')}</h3><p>${outside
            ? t('agencies_crop_hint_outside', 'El recuadro es lo que se verá: arrástralo y estira las esquinas. Puede salirse de la imagen para que se vea entera; lo que quede fuera, transparente.')
            : t('agencies_crop_hint_frame', 'El recuadro es lo que se verá: arrástralo para elegir la zona y estira las esquinas para cambiar su tamaño.')}</p></div>
          <div class="ag-crop-view is-frame${outside ? ' is-outside' : ''}" style="width:${vw}px;height:${vh}px"><img alt="" draggable="false" style="left:${ix}px;top:${iy}px;width:${dw}px;height:${dh}px"><div class="ag-crop-frame">${['nw', 'ne', 'sw', 'se'].map(h => `<span class="ag-crop-handle" data-h="${h}"></span>`).join('')}</div></div>
          <div class="ag-crop-tools">
            <label class="ag-crop-zoom">${t('agencies_crop_frame_size', 'Tamaño del recuadro')}<input type="range" min="${minFw}" max="${maxFw}" step="any" value="${fw}"></label>
            ${outside && wholeFw - coverFw > 1 ? `<div class="ag-crop-fit">
              <button type="button" data-crop-fit="whole">${t('agencies_crop_fit_whole', 'Imagen entera')}</button>
              <button type="button" data-crop-fit="cover">${t('agencies_crop_fit_cover', 'Rellenar')}</button>
            </div>` : ''}
          </div>
          <div class="ag-crop-actions"><button type="button" class="btn btn-secondary" data-crop-cancel>${t('agencies_cancel', 'Cancelar')}</button><button type="button" class="btn btn-primary" data-crop-ok>${t('agencies_crop_apply', 'Recortar y usar')}</button></div>
        </div>`;
        document.body.appendChild(ov);
        const view = ov.querySelector('.ag-crop-view');
        const frame = ov.querySelector('.ag-crop-frame');
        const range = ov.querySelector('input[type="range"]');
        ov.querySelector('.ag-crop-view img').src = url;
        const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
        // Zona por la que se mueve el recuadro: la imagen o, con outside, todo el visor.
        const bx0 = outside ? 0 : ix, by0 = outside ? 0 : iy;
        const bx1 = outside ? vw : ix + dw, by1 = outside ? vh : iy + dh;
        const paint = () => {
          fw = clamp(fw, minFw, maxFw);
          const fh = fw / aspect;
          fx = clamp(fx, bx0, bx1 - fw); fy = clamp(fy, by0, by1 - fh);
          frame.style.left = fx + 'px'; frame.style.top = fy + 'px'; frame.style.width = fw + 'px'; frame.style.height = fh + 'px';
          range.value = String(fw);
        };
        // Cambiar el tamaño manteniendo el centro (deslizador, rueda o atajos).
        const setSize = (nw, cx = fx + fw / 2, cy = fy + fw / aspect / 2) => {
          nw = clamp(nw, minFw, maxFw);
          fw = nw; fx = cx - fw / 2; fy = cy - fw / aspect / 2;
          paint();
        };
        range.addEventListener('input', () => setSize(parseFloat(range.value)));
        view.addEventListener('wheel', (e) => { e.preventDefault(); setSize(fw * (e.deltaY < 0 ? 1.06 : 1 / 1.06)); }, { passive: false });
        ov.querySelectorAll('[data-crop-fit]').forEach(b => b.addEventListener('click', () => {
          setSize(b.dataset.cropFit === 'whole' ? wholeFw : coverFw, ix + dw / 2, iy + dh / 2);
        }));
        // Arrastrar el recuadro, o estirarlo por una esquina (la opuesta se queda fija).
        let drag = null;
        const pos = (e) => { const r = view.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; };
        view.addEventListener('pointerdown', (e) => {
          const p = pos(e);
          const handle = e.target.closest('.ag-crop-handle');
          if (handle) {
            const h = handle.dataset.h;
            drag = { h, ax: h.includes('w') ? fx + fw : fx, ay: h.includes('n') ? fy + fw / aspect : fy };
          } else if (e.target.closest('.ag-crop-frame')) drag = { h: 'move', dx: p.x - fx, dy: p.y - fy };
          else { drag = { h: 'move', dx: fw / 2, dy: fw / aspect / 2 }; fx = p.x - fw / 2; fy = p.y - fw / aspect / 2; paint(); }
          try { view.setPointerCapture(e.pointerId); } catch (_) { /* puntero sintético */ }
        });
        view.addEventListener('pointermove', (e) => {
          if (!drag) return;
          const p = pos(e);
          if (drag.h === 'move') { fx = p.x - drag.dx; fy = p.y - drag.dy; paint(); return; }
          const w = Math.abs(p.x - drag.ax), h = Math.abs(p.y - drag.ay);
          let nw = Math.max(w, h * aspect);
          // Que no se salga por el lado hacia el que crece.
          const roomX = drag.h.includes('w') ? drag.ax - bx0 : bx1 - drag.ax;
          const roomY = drag.h.includes('n') ? drag.ay - by0 : by1 - drag.ay;
          nw = clamp(nw, minFw, Math.min(maxFw, roomX, roomY * aspect));
          fw = nw;
          fx = drag.h.includes('w') ? drag.ax - nw : drag.ax;
          fy = drag.h.includes('n') ? drag.ay - nw / aspect : drag.ay;
          paint();
        });
        const stopDrag = () => { drag = null; };
        view.addEventListener('pointerup', stopDrag);
        view.addEventListener('pointercancel', stopDrag);
        const onKey = (e) => { if (e.key === 'Escape') { e.stopPropagation(); done(null); } };
        const done = (out) => { document.removeEventListener('keydown', onKey, true); ov.remove(); URL.revokeObjectURL(url); resolve(out); };
        document.addEventListener('keydown', onKey, true);
        ov.querySelector('[data-crop-cancel]').addEventListener('click', () => done(null));
        ov.addEventListener('mousedown', (e) => { if (e.target === ov) done(null); });
        ov.querySelector('[data-crop-ok]').addEventListener('click', () => {
          const c = document.createElement('canvas');
          c.width = outW; c.height = outH;
          const ctx = c.getContext('2d');
          ctx.imageSmoothingQuality = 'high';
          // La imagen entera, colocada respecto al recuadro: lo que quede
          // fuera de ella se queda transparente (o negro en JPEG).
          const k = outW / fw;
          ctx.drawImage(img, (ix - fx) * k, (iy - fy) * k, dw * k, dh * k);
          c.toBlob((blob) => {
            if (!blob) { done(null); return; }
            const ext = outType === 'image/jpeg' ? '.jpg' : outType === 'image/webp' ? '.webp' : '.png';
            const name = String(file.name || 'imagen').replace(/\.[a-z0-9]+$/i, '') + ext;
            done(new File([blob], name, { type: outType }));
          }, outType, opts.quality);
        });
        paint();
      };
      img.src = url;
    });
  }
  // Logo y banner: se ve la imagen entera y el recuadro puede salirse de ella.
  const CROP_LOGO = { aspect: 1, width: 512, mode: 'frame', outside: true };
  const CROP_BANNER = { aspect: 10 / 3, width: 1200, mode: 'frame', outside: true };

  async function uploadAgencyImage(agencyId, file, imageType = 'logo') {
    if (!file) return { success: false, error: t('agencies_no_file', 'Sin archivo') };
    if (file.size > 10 * 1024 * 1024) return { success: false, error: t('agencies_image_too_large', 'Archivo demasiado grande (max. 10MB)') };
    try {
      const base64Content = await readFileAsBase64(file);
      // Tier → cuota en el Worker (Silver 500 GB / Gold 2 TB / Titanium 5 TB)
      const agencyDoc = state.allAgencies.find(a => a.id === agencyId) || state.myAgency || await loadAgency(agencyId);
      const agencyTier = (agencyDoc?.plan || 'silver').toLowerCase();
      return await window.tikcontrol.cloudStorage.uploadAgencyImage(agencyId, {
        base64Content,
        fileName: file.name,
        mimeType: file.type,
        imageType,
        agencyTier
      });
    } catch (e) {
      return { success: false, error: e.message };
    }
  }

  // ─── RESOLVE CREATOR AVATAR (fetch → cache S3 → Firestore) ─
  const _avatarQueue = new Map();

  async function resolveCreatorAvatar(agencyId, memberDocId, tiktokUsername, existingAvatarUrl) {
    if (existingAvatarUrl && existingAvatarUrl.startsWith('https://')) return existingAvatarUrl;
    if (!tiktokUsername || !agencyId || !memberDocId) return null;
    // Miembros DEMO de la consola (datos inventados): ni perfil de TikTok ni subida al storage.
    if (String(memberDocId).startsWith('demo-') || String(tiktokUsername).startsWith('demo_user_')) return null;

    const cacheKey = `${agencyId}_${memberDocId}`;
    if (_avatarQueue.has(cacheKey)) return _avatarQueue.get(cacheKey);

    const task = (async () => {
      try {
        const info = await window.tikcontrol?.appGetStaticInfo?.();
        const port = info?.overlayPort || 34212;
        const cleanUser = tiktokUsername.replace(/^@/, '');
        const resp = await fetch(`http://localhost:${port}/api/tiktok-profile?username=${encodeURIComponent(cleanUser)}`);
        if (!resp.ok) return null;
        const data = await resp.json();
        const tiktokAvatarUrl = data.avatarUrl || data.avatarLarger || data.avatarMedium || data.avatarThumb || '';
        if (!tiktokAvatarUrl) return null;

        const imgResp = await fetch(tiktokAvatarUrl);
        if (!imgResp.ok) return null;
        const blob = await imgResp.blob();
        const arrayBuf = await blob.arrayBuffer();
        const bytes = new Uint8Array(arrayBuf);
        let binary = '';
        for (let i = 0; i < bytes.length; i++) binary += String.fromCharCode(bytes[i]);
        const base64Content = btoa(binary);
        const mimeType = blob.type || 'image/jpeg';
        const ext = mimeType.includes('png') ? 'png' : 'jpg';

        const uploadResult = await window.tikcontrol.cloudStorage.uploadAgencyImage(agencyId, {
          base64Content,
          fileName: `avatar_${cleanUser}.${ext}`,
          mimeType,
          imageType: `avatars/${cleanUser}`
        });

        if (!uploadResult?.success || !uploadResult?.url) return null;
        const cachedUrl = uploadResult.url;

        try {
          await db().collection('agency_members').doc(memberDocId).update({ avatarUrl: cachedUrl });
        } catch (_) {}

        return cachedUrl;
      } catch (e) {
        console.warn('[Shared] resolveCreatorAvatar error:', e.message);
        return null;
      } finally {
        setTimeout(() => _avatarQueue.delete(cacheKey), 60000);
      }
    })();

    _avatarQueue.set(cacheKey, task);
    return task;
  }

  // ─── UI HELPERS ───────────────────────────────────────────
  function spinner(text) {
    return `<div class="ag-loading"><span class="ag-spinner"></span><span>${text || t('agencies_loading', 'Cargando...')}</span></div>`;
  }

  function emptyState(icon, title, desc) {
    return `
      <div class="ag-empty">
        <span class="ag-empty-icon">${icon}</span>
        <h4>${title}</h4>
        <p>${desc || ''}</p>
      </div>`;
  }

  // ─── Repintar sin recargar (morphHtml) ─────────────────────
  // Pone en `container` el HTML nuevo cambiando solo lo que cambia: los
  // nodos que siguen igual se quedan tal cual. Con innerHTML, cada repintado
  // creaba de nuevo imágenes y vídeos: el vídeo del banner volvía a empezar,
  // los de «Conoce» se iban a negro y las imágenes parpadeaban (la vista
  // previa de «Editar vista pública» se repinta con cada tecla). Va por
  // posición, sin claves: está pensado para repintar la misma maqueta con
  // otros datos. Un vídeo o un iframe con otra dirección se cambia entero;
  // una imagen, solo su src (se ve la anterior hasta que carga la nueva).
  // Lo que un script haya puesto en un nodo (atributos, clases) se pierde
  // como con innerHTML; los oyentes y las propiedades JS se conservan.
  function morphSameKind(a, b) {
    if (a.nodeType !== b.nodeType) return false;
    if (a.nodeType !== 1) return true;
    if (a.nodeName !== b.nodeName) return false;
    if ((a.nodeName === 'VIDEO' || a.nodeName === 'IFRAME' || a.nodeName === 'AUDIO') && a.getAttribute('src') !== b.getAttribute('src')) return false;
    return true;
  }
  function morphNode(from, to) {
    if (from.nodeType !== 1) {
      if (from.nodeValue !== to.nodeValue) from.nodeValue = to.nodeValue;
      return;
    }
    for (const attr of [...from.attributes]) if (!to.hasAttribute(attr.name)) from.removeAttribute(attr.name);
    for (const attr of [...to.attributes]) if (from.getAttribute(attr.name) !== attr.value) from.setAttribute(attr.name, attr.value);
    morphChildren(from, to);
  }
  function morphChildren(from, to) {
    let cur = from.firstChild;
    for (const node of [...to.childNodes]) {
      if (cur && morphSameKind(cur, node)) {
        const next = cur.nextSibling;
        morphNode(cur, node);
        cur = next;
      } else if (cur && cur.nodeType === 1 && cur.nodeName === node.nodeName) {
        // La misma etiqueta con otra dirección (vídeo, iframe): se cambia en su sitio.
        const next = cur.nextSibling;
        from.insertBefore(node, cur);
        from.removeChild(cur);
        cur = next;
      } else {
        from.insertBefore(node, cur);
      }
    }
    while (cur) { const next = cur.nextSibling; from.removeChild(cur); cur = next; }
  }
  function morphHtml(container, html) {
    if (!container) return;
    const tpl = document.createElement('template');
    tpl.innerHTML = html;
    morphChildren(container, tpl.content);
  }

  // ─── MODAL SYSTEM ─────────────────────────────────────────
  function showModal(title, bodyHtml, footerHtml, opts = {}) {
    // Remove existing
    document.getElementById('ag-modal-overlay')?.remove();

    const sizeMap = { lg: 'ag-modal-lg', xl: 'ag-modal-xl', fullwidth: 'ag-modal-fullwidth' };
    const sizeClass = sizeMap[opts.size] || '';
    // Skin "pro" POR DEFECTO en todos los modales (mismo lenguaje visual que
    // los editores de Acción/Evento). opts.skin 'classic' recupera el modal
    // antiguo; opts.subtitle añade la línea gris bajo el título.
    const skinClass = opts.skin === 'classic' ? '' : 'ag-modal-pro';
    const titleHtml = opts.subtitle
      ? `<div class="ag-modal-titles"><h3>${title}</h3><span class="ag-modal-subtitle">${opts.subtitle}</span></div>`
      : `<h3>${title}</h3>`;

    const overlay = document.createElement('div');
    overlay.id = 'ag-modal-overlay';
    overlay.className = 'ag-modal-overlay';
    overlay.innerHTML = `
      <div class="ag-modal ${sizeClass} ${skinClass} ${opts.extraClass || ''}">
        <div class="ag-modal-header">
          ${titleHtml}
          <button class="ag-modal-close" id="ag-modal-close-btn">&times;</button>
        </div>
        <div class="ag-modal-body">${bodyHtml}</div>
        ${footerHtml ? `<div class="ag-modal-footer">${footerHtml}</div>` : ''}
      </div>
    `;

    document.body.appendChild(overlay);

    overlay.querySelector('#ag-modal-close-btn').addEventListener('click', closeModal);

    return overlay;
  }

  function closeModal() {
    document.getElementById('ag-modal-overlay')?.remove();
  }

  async function confirmDialog(title, message, confirmText = 'Confirmar', cancelText = 'Cancelar', options = {}) {
    // ModalHost.confirm espera un objeto de opciones — pasarle strings
    // posicionales hacía que TODOS los diálogos cayeran a los textos
    // genéricos ("Confirmar acción / ¿Estás seguro?").
    if (window.ModalHost?.confirm) {
      return window.ModalHost.confirm({
        title,
        message,
        confirmText,
        cancelText,
        type: options.type || 'warning'
      });
    }
    return window.confirm(message);
  }

  // ─── SHARED EVENT DETAIL MODAL ────────────────────────────
  function showEventDetailModal(ev, opts = {}) {
    // Normalise legacy S3 URLs on every image/video/PDF field so the modal
    // works for rows created before the Cloudflare migration.
    ev = ev || {};
    if (ev.imageUrl) ev.imageUrl = safeImgUrl(ev.imageUrl);
    if (ev.avatar) ev.avatar = safeImgUrl(ev.avatar);
    if (ev.videoUrl) ev.videoUrl = safeImgUrl(ev.videoUrl);
    if (ev.rulesUrl) ev.rulesUrl = safeImgUrl(ev.rulesUrl);

    const _cl = (url) => url && (url.startsWith('https://') || url.startsWith('http://'));
    const _isImg = (url) => url && (url.startsWith('https://') || url.startsWith('http://') || url.startsWith('data:') || url.startsWith('./') || url.startsWith('/'));
    const _br = (html) => html ? html.replace(/\n/g, '<br>') : '';

    const name = ev.name || t('agencies_event', 'Evento');
    const description = ev.description || '';
    const prizes = ev.prizes || '';
    const imageUrl = ev.imageUrl || ev.avatar || null;
    const videoUrl = ev.videoUrl || null;
    const rulesUrl = ev.rulesUrl || null;
    const startDate = ev.startDate || ev.dateStart || null;
    const endDate = ev.endDate || ev.dateEnd || null;

    const hasImage = _isImg(imageUrl);
    const hasVideo = _cl(videoUrl);
    const hasPdf = _cl(rulesUrl);
    const descHtml = _br(description);
    const prizesHtml = _br(prizes);

    /* ── Premios: texto + rankings por posición, en líneas (sin cajas) ── */
    const rankingGroups = ev.rankingGroups || [];
    const _posLabel = (p, pi) => {
      const from = p.from || (pi + 1);
      const to = p.to || from;
      return from === to ? `${t('agencies_top_position', 'Top')} ${from}` : `${t('agencies_top_position', 'Top')} ${from}-${to}`;
    };
    const rankingHtml = rankingGroups.map(g => {
      const pos = g.positions || [];
      return `<div class="ag-evd-rank">
        <div class="ag-evd-rank-h">${g.icon || '🏅'} ${g.name || ''}</div>
        ${pos.map((p, pi) => `<div class="ag-evd-rank-row">
          <span class="ag-evd-rank-pos">${_posLabel(p, pi)}</span>
          <span class="ag-evd-rank-prize">${(p.kind === 'gift' || (!p.kind && g.prizeType === 'gift'))
            ? `${p.giftImage ? `<img src="${safeImgUrl(p.giftImage)}" alt="">` : ICO.gift} ${rankingPositionText(g, p)}`
            : rankingPositionText(g, p)}</span>
        </div>`).join('')}
      </div>`;
    }).join('');
    // Premios directos / sorteos del creador de eventos nuevo: mismas
    // tarjetas que en el detalle de una misión.
    const hasRewards = !!(ev.directPrize || ev.raffle || (Array.isArray(ev.extraPrizes) && ev.extraPrizes.length) || (Array.isArray(ev.extraRaffles) && ev.extraRaffles.length));
    const rewardCards = hasRewards ? missionRewardCards(ev) : [];
    /* ── Date chips (+ chips informativos: rango recomendado, región…) ── */
    const chips = Array.isArray(ev.infoChips) ? ev.infoChips.filter(c => c && c.text) : [];
    const dateBlock = (startDate || endDate || chips.length) ? `
      <div class="ag-evd-dates">
        ${startDate ? `<span>${ICO.calendar} ${t('agencies_start', 'Inicio')}: ${formatDate(startDate)}</span>` : ''}
        ${endDate ? `<span>${ICO.calendar} ${t('agencies_end', 'Fin')}: ${formatDate(endDate)}</span>` : ''}
        ${chips.map(c => `<span>${c.ico || ''} ${_mdEsc(c.text)}</span>`).join('')}
      </div>` : '';
    /* ── Portada: imagen a sangre, o icono de campaña del Backstage sobre su
       color (a sangre salía pixelado) ── */
    const coverHtml = !hasImage ? '' : (ev.coverIcon
      ? `<div class="ag-evd-img ag-evd-cover-ico" style="${/^#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(String(ev.coverColor || '')) ? 'background:' + ev.coverColor : ''}"><img class="ag-evd-cover-blur" src="${imageUrl}" alt="" aria-hidden="true"><img class="ag-evd-cover-icon" src="${imageUrl}" alt=""></div>`
      : `<img src="${imageUrl}" alt="" class="ag-evd-img">`);
    /* ── Bloques de una campaña del Backstage (misiones y reglas, cómo se
       puntúa, partidas, regalos…): título + lista; los ítems que empiezan
       por «– » cuelgan del anterior, con el mismo aspecto que las fases ── */
    const campaignBlocks = Array.isArray(ev.campaignBlocks) ? ev.campaignBlocks.filter(b => b && Array.isArray(b.items) && b.items.length) : [];
    const campaignHtml = campaignBlocks.length ? `<div class="ag-evd-sec">
      <h5>${_MD_ICO.target} ${t('agencies_evd_how', 'Cómo se compite')}</h5>
      ${campaignBlocks.map(b => {
        const groups = [];
        b.items.forEach(it => {
          const str = String(it || '');
          if (str.startsWith('– ')) { if (!groups.length) groups.push({ title: '', subs: [] }); groups[groups.length - 1].subs.push(str.slice(2)); }
          else groups.push({ title: str, subs: [] });
        });
        return `${campaignBlocks.length > 1 ? `<p class="ag-evd-muted">${b.ico || ''} ${_mdEsc(b.label || '')}</p>` : ''}${groups.map(g => `<div class="ag-evd-phase">
          ${g.title ? `<div class="ag-evd-phase-h"><strong>${_mdEsc(g.title)}</strong></div>` : ''}
          ${g.subs.length ? `<ul class="ag-evd-metrics">${g.subs.map(x => `<li>${_mdEsc(x)}</li>`).join('')}</ul>` : ''}
        </div>`).join('')}`;
      }).join('')}
    </div>` : '';
    const campaignRewards = Array.isArray(ev.campaignRewards) ? ev.campaignRewards.filter(r => r && (r.label || r.image)) : [];
    // Mismas tarjetas que el premio directo (ámbar) y el sorteo (lila).
    const campaignRewardsHtml = campaignRewards.map(r => _mdPrizeCard(r.raffle ? 'raffle' : 'direct',
      r.raffle ? t('agencies_md_raffle', 'Sorteo entre los que completen') : t('agencies_evd_official_reward', 'Recompensa oficial'),
      _mdEsc(r.label || ''), _isImg(r.image) ? safeGiftImgUrl(r.image) : '', r.qty > 1 ? [t('agencies_md_available', 'Disponibles: {n}').replace('{n}', formatNumber(r.qty))] : [], !!_isImg(r.image))).join('');
    const prizesBlock = (prizesHtml || rankingHtml || rewardCards.length || campaignRewardsHtml) ? `
      <div class="ag-evd-sec">
        <h5>${ICO.trophy} ${t('agencies_prizes', 'Premios')}</h5>
        ${(campaignRewardsHtml || rewardCards.length) ? `<div class="agm-md-rewardlist ag-evd-rewards">${campaignRewardsHtml}${rewardCards.join('')}</div>` : ''}
        ${prizesHtml ? `<div class="ag-richtext-render ag-evd-text">${prizesHtml}</div>` : ''}
        ${rankingHtml}
      </div>` : '';

    /* ── Cómo se compite: fases del editor de eventos ── */
    const EVD_METRIC = { diamonds: 'Diamantes', liveDuration: 'Duración de LIVE', validDays: 'Días de emisión LIVE válidos', validLives: 'Emisiones LIVE válidas', matchDiamonds: 'Diamantes de partidas', matchesCompleted: 'Partidas completadas', matchWins: 'Victorias de partidas', newFans: 'Nuevos fans', fanHearts: 'Corazoncitos de los fans', fanPopular: 'Hazte popular de los fans' };
    const EVD_UNIT = { diamonds: 'diamante', liveDuration: 'hora LIVE', validDays: 'día válido', validLives: 'emisión válida', matchDiamonds: 'diamante de partida', matchesCompleted: 'partida completada', matchWins: 'victoria', newFans: 'nuevo fan', fanHearts: 'corazoncito', fanPopular: 'punto de popularidad' };
    const phases = Array.isArray(ev.phases) ? ev.phases : [];
    const phasesBlock = phases.length ? `
      <div class="ag-evd-sec">
        <h5>${_MD_ICO.target} ${t('agencies_evd_how', 'Cómo se compite')}</h5>
        ${phases.map((ph, i) => {
          const goals = ph.rule === 'goals';
          const mets = (Array.isArray(ph.metrics) ? ph.metrics : []).map(m => {
            const nm = t('agencies_evtm_' + m.id, EVD_METRIC[m.id] || m.id);
            const un = t('agencies_evtm_' + m.id + '_unit', EVD_UNIT[m.id] || '');
            return goals
              ? `<li>${nm}: <b>${formatNumber(Number(m.target) || 0)}</b></li>`
              : `<li>1 ${un} = <b>${formatNumber(Number(m.points) || 0)}</b> ${t('agencies_evt_bs_points', 'pts')}</li>`;
          }).join('');
          return `<div class="ag-evd-phase">
            <div class="ag-evd-phase-h"><strong>${phases.length > 1 ? `${t('agencies_evt_ed_phase', 'Fase')} ${i + 1} · ` : ''}${goals ? t('agencies_evtr_goals', 'Alcanza objetivos') : t('agencies_evtr_points', 'Consigue puntos')}</strong><em>${formatDate(ph.startDate)} – ${formatDate(ph.endDate)}</em></div>
            <p class="ag-evd-muted">${goals ? t('agencies_evd_goals_d', 'Cumple todos los objetivos de la fase:') : t('agencies_evd_points_d', 'Cada unidad suma puntos; gana quien más acumule:')}</p>
            ${mets ? `<ul class="ag-evd-metrics">${mets}</ul>` : ''}
          </div>`;
        }).join('')}
      </div>` : '';

    // Enlaces (oficial, normas PDF, vídeo) como botones cuando no se embeben
    const linksBlock = (ev.officialUrl || hasPdf || hasVideo) ? `
      <div class="ag-evd-links">
        ${ev.officialUrl && _cl(ev.officialUrl) ? `<a href="${ev.officialUrl}" target="_blank" rel="noopener" class="btn btn-secondary btn-sm">🔗 ${t('agencies_evd_official', 'Enlace oficial')}</a>` : ''}
        ${hasPdf ? `<button type="button" class="btn btn-secondary btn-sm" id="ag-evd-pdf-open">${ICO.file} ${t('agencies_rules', 'Reglas')} (PDF)</button>` : ''}
        ${hasVideo ? `<button type="button" class="btn btn-secondary btn-sm" id="ag-evd-video-open">🎬 ${t('agencies_evd_video', 'Vídeo')}</button>` : ''}
      </div>` : '';
    // Bloques que aporta la vista del creador (member.js): cómo voy y mis
    // misiones del evento. El owner ("ver como creador") no los tiene.
    const progressBlock = opts.progressHtml ? `<div class="ag-evd-sec">${opts.progressHtml}</div>` : '';
    const missionsBlock = opts.missionsHtml ? `<div class="ag-evd-sec">${opts.missionsHtml}</div>` : '';

    /* ── Build the modal body ── */
    // Con fases / progreso / misiones (eventos del editor nuevo) manda la
    // hoja en dos columnas y el PDF o vídeo van como enlaces; el visor
    // embebido queda para eventos antiguos que solo traen el archivo.
    const rightHtml = campaignHtml + phasesBlock + progressBlock + missionsBlock;
    const hasMedia = (hasVideo || hasPdf) && !rightHtml;
    let bodyHtml = '';
    let modalSize = 'lg';

    if (hasMedia) {
      const mediaContent = [];

      if (hasVideo) {
        const videoFlex = hasPdf ? 'flex:1 1 0;min-width:0;max-width:55%;' : 'flex-shrink:0;';
        mediaContent.push(`
          <div id="ag-ev-video-wrap" style="${videoFlex}border-radius:10px;overflow:hidden;">
            <video id="ag-ev-video-el" controls controlsList="nodownload noplaybackrate" disablePictureInPicture
              style="display:block;border-radius:10px;width:100%;height:100%;object-fit:contain;" preload="metadata">
              <source src="${videoUrl}" type="video/mp4">
            </video>
          </div>`);
      }

      if (hasPdf) {
        mediaContent.push(`
          <div id="ag-ev-pdf-wrap" style="flex:1 1 0;min-width:220px;display:flex;flex-direction:column;height:100%;">
            <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:4px;">
              <span style="font-size:11px;color:#94a3b8;font-weight:600;">${ICO.file} ${t('agencies_rules', 'Reglas')}</span>
              <div style="display:flex;gap:4px;">
                <button class="btn btn-secondary btn-sm" id="ag-ev-pdf-expand" style="padding:2px 8px;font-size:10px;">⛶ ${t('agencies_zoom', 'Ampliar')}</button>
                <a href="${rulesUrl}" target="_blank" class="btn btn-secondary btn-sm" style="padding:2px 8px;font-size:10px;text-decoration:none;">📥 PDF</a>
              </div>
            </div>
            <div id="ag-ev-pdf-box" style="flex:1;overflow:hidden;border-radius:8px;">
              <iframe id="ag-ev-pdf-frame" src="${rulesUrl}#toolbar=0&navpanes=0" style="width:1200px;height:1697px;border:none;transform-origin:0 0;display:block;" scrolling="no" title="PDF"></iframe>
            </div>
          </div>`);
      }

      bodyHtml = `
        <div id="ag-ev-layout" style="display:flex;gap:14px;height:580px;">
          <div id="ag-ev-left" style="flex:0 0 270px;overflow-y:auto;overflow-x:hidden;padding-right:4px;">
            ${hasImage ? `<img src="${imageUrl}" alt="" style="width:100%;max-height:110px;border-radius:8px;object-fit:cover;margin-bottom:8px;">` : ''}
            <div class="ag-richtext-render" style="margin-bottom:6px;line-height:1.4;white-space:pre-line;font-size:12px;color:#cbd5e1;">${descHtml || t('agencies_no_description', 'Sin descripción.')}</div>
            ${dateBlock}
            ${phasesBlock}
            ${progressBlock}
            ${missionsBlock}
            ${prizesBlock}
          </div>
          <div id="ag-ev-right" style="flex:1;min-width:0;display:flex;flex-direction:row;gap:10px;overflow:hidden;align-items:stretch;">
            ${mediaContent.join('')}
          </div>
        </div>`;
      modalSize = 'xl';

    } else {
      // Dos columnas separadas por una línea vertical (sin cajas): a la
      // izquierda qué es el evento (imagen, descripción, fechas, enlaces,
      // premios); a la derecha cómo se compite, cómo voy y mis misiones.
      bodyHtml = `
        <div class="ag-evd ${rightHtml ? '' : 'ag-evd-single'}">
          <div class="ag-evd-col">
            ${coverHtml}
            ${descHtml ? `<div class="ag-richtext-render ag-evd-desc">${descHtml}</div>` : (rightHtml ? '' : `<div class="ag-richtext-render ag-evd-desc">${t('agencies_no_description', 'Sin descripción.')}</div>`)}
            ${dateBlock}
            ${linksBlock}
            ${prizesBlock}
          </div>
          ${rightHtml ? `<div class="ag-evd-col ag-evd-right">${rightHtml}</div>` : ''}
        </div>`;
      modalSize = rightHtml ? 'xl' : 'lg';
    }

    const extraFooter = opts.extraFooterHtml || '';
    showModal(
      name,
      bodyHtml,
      `${extraFooter}<button class="btn btn-secondary" onclick="window.AgenciasShared.closeModal()">${t('agencies_close', 'Cerrar')}</button>`,
      { size: modalSize }
    );
    // Enlaces externos (PDF de normas, vídeo, enlace oficial): en Electron un
    // target="_blank" abre una ventana en blanco sin visor de PDF → se abren
    // en el navegador del sistema.
    try {
      const ovl = document.getElementById('ag-modal-overlay');
      if (ovl) ovl.addEventListener('click', (e) => {
        const a = e.target.closest('a[target="_blank"]');
        if (!a || !a.href) return;
        e.preventDefault(); e.stopPropagation();
        const sh = window.tikcontrol && window.tikcontrol.shell;
        if (sh && typeof sh.openExternal === 'function') sh.openExternal(a.href);
        else if (window.tikcontrol && typeof window.tikcontrol.openExternal === 'function') window.tikcontrol.openExternal(a.href);
        else window.open(a.href, '_blank');
      }, true);
    } catch (_) { /* */ }

    /* ── PDF: scale iframe to fill container exactly ── */
    if (hasPdf) {
      const IFW = 1200, IFH = 1697;
      let lastBw = 0;
      const scalePdf = () => {
        const box = document.getElementById('ag-ev-pdf-box');
        const frame = document.getElementById('ag-ev-pdf-frame');
        if (!box || !frame) return false;
        const bw = box.clientWidth;
        const bh = box.clientHeight;
        if (bw < 20 || bh < 20) return false;
        if (bw === lastBw) return true;
        lastBw = bw;
        const scaleW = bw / IFW;
        const scaleH = bh / IFH;
        const scale = Math.min(scaleW, scaleH);
        frame.style.transform = 'scale(' + scale.toFixed(4) + ')';
        return true;
      };
      const pdfWrap = document.getElementById('ag-ev-pdf-wrap');
      if (pdfWrap && typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(() => scalePdf()).observe(pdfWrap);
      }
      setTimeout(scalePdf, 150);
      setTimeout(scalePdf, 400);
      setTimeout(scalePdf, 800);
    }

    /* ── Video: adapt to container height ── */
    if (hasVideo) {
      const vid = document.getElementById('ag-ev-video-el');
      if (vid) {
        vid.addEventListener('loadedmetadata', () => {
          const isVert = vid.videoHeight > vid.videoWidth;
          vid.style.maxHeight = isVert ? '65vh' : '30vh';
          vid.style.maxWidth = '100%';
        });
      }
    }

    /* ── PDF expanded viewer (floating window adapted to PDF) ── */
    if (hasPdf) {
      const openPdfFs = () => {
        document.getElementById('ag-pdf-fullscreen')?.remove();

        const IFW = 1200, IFH = 1440;
        const maxH = window.innerHeight * 0.88;
        const maxW = window.innerWidth * 0.92;
        const headerH = 40;
        const availH = maxH - headerH;
        const scale = Math.min(maxW / IFW, availH / IFH);
        const winW = Math.floor(IFW * scale);
        const winH = Math.floor(IFH * scale) + headerH;

        const ov = document.createElement('div');
        ov.id = 'ag-pdf-fullscreen';
        ov.style.cssText = 'position:fixed;inset:0;z-index:10001;background:rgba(0,0,0,0.7);display:flex;align-items:center;justify-content:center;';
        ov.innerHTML = `
          <div style="background:#1a1a2e;border-radius:12px;box-shadow:0 20px 60px rgba(0,0,0,0.6);display:flex;flex-direction:column;width:${winW}px;height:${winH}px;overflow:hidden;border:1px solid rgba(255,255,255,0.08);">
            <div style="display:flex;justify-content:space-between;align-items:center;padding:6px 14px;border-bottom:1px solid rgba(255,255,255,0.08);flex-shrink:0;height:${headerH}px;box-sizing:border-box;">
              <div style="display:flex;align-items:center;gap:8px;min-width:0;">
                <span style="font-size:14px;">${ICO.file}</span>
                <span style="color:#e2e8f0;font-weight:600;font-size:12px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${name.replace(/<[^>]*>/g, '')}</span>
              </div>
              <div style="display:flex;gap:6px;align-items:center;flex-shrink:0;">
                <button id="ag-pdf-fs-close" style="background:rgba(255,255,255,0.06);border:1px solid rgba(255,255,255,0.1);color:#e2e8f0;width:28px;height:28px;border-radius:6px;font-size:15px;cursor:pointer;display:flex;align-items:center;justify-content:center;" title="Cerrar">&times;</button>
              </div>
            </div>
            <div style="overflow:hidden;flex:1;">
              <iframe src="${rulesUrl}#toolbar=0&navpanes=0" style="width:${IFW}px;height:${IFH}px;border:none;transform-origin:0 0;display:block;transform:scale(${scale.toFixed(4)});" scrolling="no" title="PDF"></iframe>
            </div>
          </div>`;
        document.body.appendChild(ov);
        ov.addEventListener('click', (e) => { if (e.target === ov) ov.remove(); });
        ov.querySelector('#ag-pdf-fs-close')?.addEventListener('click', () => ov.remove());
        const escH = (e) => { if (e.key === 'Escape') { ov.remove(); document.removeEventListener('keydown', escH); } };
        document.addEventListener('keydown', escH);
      };
      document.getElementById('ag-ev-pdf-expand')?.addEventListener('click', openPdfFs);
      document.getElementById('ag-evd-pdf-open')?.addEventListener('click', openPdfFs);
    }
    // Vídeo: reproductor dentro de la app (misma razón que el PDF).
    if (hasVideo) {
      document.getElementById('ag-evd-video-open')?.addEventListener('click', () => {
        document.getElementById('ag-video-fullscreen')?.remove();
        const ov = document.createElement('div');
        ov.id = 'ag-video-fullscreen';
        ov.style.cssText = 'position:fixed;inset:0;z-index:10001;background:rgba(0,0,0,0.8);display:flex;align-items:center;justify-content:center;';
        ov.innerHTML = `<div style="width:min(960px,92vw);background:#1a1a2e;border-radius:12px;overflow:hidden;border:1px solid rgba(255,255,255,0.08);">
            <video controls autoplay controlsList="nodownload noplaybackrate" disablePictureInPicture style="display:block;width:100%;max-height:82vh;background:#000;" preload="metadata"><source src="${videoUrl}" type="video/mp4"></video>
          </div>`;
        document.body.appendChild(ov);
        ov.addEventListener('click', (e) => { if (e.target === ov) ov.remove(); });
        const escH = (e) => { if (e.key === 'Escape') { ov.remove(); document.removeEventListener('keydown', escH); } };
        document.addEventListener('keydown', escH);
      });
    }

    if (opts.onRendered) opts.onRendered();
  }

  // ─── AGENCY NEWS: publicación + entrega programada ──────────
  // Un doc de agency_news está publicado si no tiene status (comunicados
  // clásicos, anteriores a la Biblioteca) o si status === 'sent'. Los
  // borradores/programados/plantillas nunca deben verse como publicados.
  function agencyNewsIsPublished(doc) {
    return !!doc && (!doc.status || doc.status === 'sent');
  }

  // ─── AGENCY NEWS: aprobación y "confianza" ──────────────────
  // Un comunicado del staff necesita que lo apruebe un superior antes de
  // llegar a los creadores (status 'pending_approval'), salvo que su autor
  // tenga confianza. Owner, Super Admin y Super Owner (staff de TikControl)
  // la tienen siempre. Al resto se la da un superior y se guarda en
  // agency.licStaff[uid].newsTrusted (+ newsTrustedBy / newsTrustedByRole /
  // newsTrustedAt). La confianza NO se copia en cascada: se DERIVA cada vez,
  // y solo vale si quien la dio aún podría darla — un Admin al que le quitan
  // la suya deja sin efecto, sin tocar nada más, la que dio a sus managers
  // (y la recuperan si él la recupera). También cae si el manager pasa a
  // depender de otro Admin o si quien la dio deja de ser Super Admin.

  // Quién actúa en la consola: { uid, role, asUid }. Sin managerMode es el
  // Owner (también el Super Owner viéndola como Owner). Con managerMode, su
  // entrada de licStaff; en modo Super Owner simulando un rol, esa entrada es
  // la simulada (__simulated, la pone la consola) y se comporta como ese rol:
  // un Manager simulado también manda sus comunicados a aprobación.
  // asUid: la persona simulada (__simUid) — con ella se decide de quién
  // depende o a quién puede aprobar; sin simular, el propio uid.
  function agencyNewsActor(agency, managerMode) {
    const uid = (state.currentUser && state.currentUser.uid) || null;
    if (!managerMode) return { uid, role: 'owner', asUid: uid };
    const st = agency && agency.licStaff && agency.licStaff[uid];
    return { uid, role: (st && st.active !== false && st.role) || 'manager', asUid: (st && st.__simUid) || uid };
  }

  // Rol de un miembro del staff (licStaff activo); sin entrada, manager (los
  // managers por flag no siempre tienen nodo en licStaff).
  function agencyNewsStaffRole(agency, uid) {
    const st = agency && agency.licStaff && agency.licStaff[uid];
    if (!st) return 'manager';
    return st.active === false ? '' : (st.role || 'manager');
  }

  // Admin del que depende un manager: el de su equipo o, sin equipo, el
  // elegido a mano (misma regla que Licencias).
  function agencyNewsAdminOf(agency, uid) {
    const st = (agency && agency.licStaff && agency.licStaff[uid]) || {};
    const team = st.teamId && agency.licTeams ? agency.licTeams[st.teamId] : null;
    return (team && team.active !== false && team.adminUid) || st.adminUid || null;
  }

  // ¿Publica sin aprobación? (el Owner se resuelve antes, por agencyNewsActor)
  function agencyNewsUidTrusted(agency, uid, depth) {
    const staff = (agency && agency.licStaff) || {};
    const st = staff[uid];
    if (!st || st.active === false) return false;
    if (st.role === 'super_admin') return true;
    if (st.newsTrusted !== true || (depth || 0) > 3) return false;
    const by = st.newsTrustedBy;
    if (st.newsTrustedByRole === 'owner' || st.newsTrustedByRole === 'tikcontrol'
      || (by && (by === agency.ownerId || by === agency.ownerUid))) return true;
    const g = by ? staff[by] : null;
    if (!g || g.active === false) return false;
    if (g.role === 'super_admin') return true;
    // Un Admin solo la da a SUS managers, y solo vale mientras él la tenga.
    return g.role === 'admin' && (st.role || 'manager') === 'manager'
      && agencyNewsAdminOf(agency, uid) === by && agencyNewsUidTrusted(agency, by, (depth || 0) + 1);
  }

  function agencyNewsTrusted(agency, actor) {
    if (!actor || !actor.uid) return false;
    if (actor.role === 'owner' || actor.role === 'super_admin') return true;
    return agencyNewsUidTrusted(agency, actor.uid, 0);
  }

  // ¿Puede `actor` dar o quitar la confianza a targetUid? → '' si puede o
  // el motivo: 'always' (Super Admin: la tiene siempre) · 'self' ·
  // 'admin_untrusted' (Admin sin confianza) · 'not_yours' (manager de otro
  // Admin) · 'forbidden'.
  function agencyNewsTrustBlock(agency, actor, targetUid, targetRole) {
    const role = targetRole || agencyNewsStaffRole(agency, targetUid);
    if (role === 'super_admin' || role === 'owner') return 'always';
    if (!actor || !actor.uid) return 'forbidden';
    const me = actor.asUid || actor.uid;
    if ((actor.uid === targetUid || me === targetUid) && actor.role !== 'owner') return 'self';
    if (actor.role === 'owner' || actor.role === 'super_admin') return '';
    if (actor.role !== 'admin') return 'forbidden';
    if (role !== 'manager' || agencyNewsAdminOf(agency, targetUid) !== me) return 'not_yours';
    return agencyNewsUidTrusted(agency, actor.uid, 0) ? '' : 'admin_untrusted';
  }
  function agencyNewsTrustBlockText(code) {
    return ({
      always: t('agencies_nw_trust_always', 'Owner y Super Admin publican siempre sin aprobación.'),
      self: t('agencies_nw_trust_self', 'No puedes cambiar tu propia confianza: te la da un superior.'),
      admin_untrusted: t('agencies_nw_trust_admin_untrusted', 'Necesitas tener confianza para dársela a tus managers. Pídesela al Owner o a un Super Admin.'),
      not_yours: t('agencies_nw_trust_not_yours', 'Solo puedes dar confianza a los managers que dependen de ti.'),
      forbidden: t('agencies_nw_trust_forbidden', 'Tu rol no puede dar confianza para comunicados.'),
    })[code] || '';
  }

  // Campos de licStaff[uid] al dar (value true) o quitar la confianza.
  function agencyNewsTrustPatch(agency, actor, value) {
    const tikcontrol = !!agency && state.superOwnerViewingAgencyId === agency.id;
    return {
      newsTrusted: value === true,
      newsTrustedBy: value === true ? (actor && actor.uid) || null : null,
      newsTrustedByRole: value === true ? (tikcontrol ? 'tikcontrol' : (actor && actor.role) || null) : null,
      newsTrustedAt: Date.now(),
    };
  }

  // ¿Puede `actor` aprobar o rechazar lo que pidió requesterUid? Super Admin
  // y Owner, cualquiera; un Admin, solo lo de SUS Managers (los que dependen
  // de él por equipo o a mano) — tenga o no confianza: la confianza solo
  // decide si sus PROPIOS comunicados se publican sin aprobación. Lo de un
  // Admin sin confianza, o de un Manager sin Admin asignado, lo aprueban un
  // Super Admin o el Owner.
  // requesterRole: el rol con el que se pidió (guardado en el comunicado; en
  // modo Super Owner el uid es el mismo aunque se simule otro rol después).
  function agencyNewsCanApprove(agency, actor, requesterUid, requesterRole) {
    if (!actor || !actor.uid) return false;
    if (actor.role === 'owner' || actor.role === 'super_admin') return true;
    if (actor.role !== 'admin' || !requesterUid) return false;
    const role = requesterRole || agencyNewsStaffRole(agency, requesterUid);
    if (role !== 'manager') return false;
    return agencyNewsAdminOf(agency, requesterUid) === (actor.asUid || actor.uid);
  }

  // ¿Puede `actor` eliminar (o editar) un comunicado creado por authorUid?
  // Misma regla que el resto del contenido de la consola
  // (agencyContentAccess): quien lo creó, el Admin de ese Manager y, siempre,
  // Super Admin y Owner. Sin autor conocido (comunicados antiguos) cuenta
  // como del Owner: solo Owner y Super Admin.
  function agencyNewsCanDelete(agency, actor, authorUid, authorRole) {
    return agencyContentAccess(agency, actor, authorUid, authorRole) === 'edit';
  }

  // ─── CONTENIDO DE LA CONSOLA: quién ve y toca lo que sube cada uno ───
  // Biblioteca (tutoriales, formaciones, creatividades y sus carpetas,
  // Perfiles LIVE) y Comunicados. Es una capa POR AUTOR dentro de lo que el
  // rol ya puede hacer (la matriz de Roles y permisos manda por encima):
  //  · Owner y Super Admin: ven, editan y eliminan todo.
  //  · Admin: lo suyo y lo de SUS managers (edita y elimina); lo de Owner y
  //    Super Admin, solo lectura; lo de otros Admins y sus managers, no lo ve.
  //  · Manager: lo suyo (edita y elimina); lo de Owner, Super Admin y SU
  //    Admin, solo lectura; lo de otros managers y otros Admins, no lo ve.
  //  · Viewer: como un Manager, pero nunca edita.
  // Sin autor (documentos antiguos) = del Owner. La vista del creador no
  // pasa por aquí: el creador ve todo lo publicado que le toca.
  function agencyIsOwnerUid(agency, uid) {
    return !!uid && !!agency && (uid === agency.ownerId || uid === agency.ownerUid);
  }

  // Rol base de un rol de staff: los personalizados (licCustomRoles) mandan
  // lo que su base; uno desconocido cuenta como Manager.
  const CONTENT_BASE_ROLES = ['owner', 'super_admin', 'admin', 'manager', 'viewer'];
  function agencyStaffBaseRole(agency, role) {
    if (CONTENT_BASE_ROLES.includes(role)) return role;
    const custom = agency && agency.licCustomRoles && agency.licCustomRoles[role];
    return custom && CONTENT_BASE_ROLES.includes(custom.base) && custom.base !== 'owner' ? custom.base : 'manager';
  }

  // ─── CARTERA DE CREADORES (agency_manager_assignments/{uid}) ─────────
  // No solo un Manager tiene creadores: el Owner, un Super Admin o un Admin
  // que en el Backstage es AGENTE de creadores los lleva igual. Pueden tener
  // cartera el Owner y el staff de la Estructura cuyo rol (o la base de su
  // rol personalizado) es Super Admin, Admin o Manager; un Viewer no.
  const PORTFOLIO_STAFF_ROLES = ['super_admin', 'admin', 'manager'];
  function agencyCanHoldPortfolio(agency, role) {
    return role === 'owner' || PORTFOLIO_STAFF_ROLES.includes(agencyStaffBaseRole(agency, role));
  }

  // Titulares de cartera de la agencia → [{ uid, role, name, email,
  // agentKeys, pendingEmail }], sin repetir uid (el Owner manda sobre una
  // entrada suya en licStaff).
  //   owners       → [{ uid, name, email }] Owners (users.agencyRoles.<id>
  //                  'owner' y ownerId/ownerUid del doc).
  //   flagManagers → [{ uid, name, email }] managers por agencyRoles sin
  //                  entrada en la Estructura.
  // agentKeys = «Agente» del Backstage (su email, en minúsculas) con el que
  // la sync le reparte creadores: el backstageAgent guardado al darle de
  // alta o, sin él, su email (para el Owner, el de su cuenta y el ownerEmail
  // de la agencia). Orden = prioridad si dos comparten agente: staff con
  // agente explícito, resto del staff, managers por flag y, al final, Owners.
  function agencyPortfolioHolders(agency, { owners = [], flagManagers = [] } = {}) {
    const lc = (v) => String(v || '').trim().toLowerCase();
    const keysOf = (...vals) => [...new Set(vals.map(lc).filter((k) => k.includes('@')))];
    const staff = (agency && agency.licStaff) || {};
    const ownerUids = new Set((owners || []).map((o) => o && o.uid).filter(Boolean));
    const explicit = [], byEmail = [], flags = [], own = [];
    const seen = new Set();
    for (const [uid, s] of Object.entries(staff)) {
      if (!s || s.__simulated || s.active === false || ownerUids.has(uid)) continue;
      if (!agencyCanHoldPortfolio(agency, s.role || 'manager')) continue;
      seen.add(uid);
      const h = { uid, role: s.role || 'manager', name: s.name || s.email || uid, email: s.email || '', agentKeys: keysOf(s.backstageAgent || s.email), pendingEmail: s.pendingEmail === true };
      (s.backstageAgent ? explicit : byEmail).push(h);
    }
    for (const m of flagManagers || []) {
      if (!m || !m.uid || seen.has(m.uid) || ownerUids.has(m.uid)) continue;
      // Uno con entrada en la Estructura manda su rol de ahí (desactivado o
      // Viewer: sin cartera).
      if (staff[m.uid]) continue;
      seen.add(m.uid);
      flags.push({ uid: m.uid, role: 'manager', name: m.name || m.email || m.uid, email: m.email || '', agentKeys: keysOf(m.email), pendingEmail: false });
    }
    const docOwner = agency && (agency.ownerId || agency.ownerUid);
    for (const o of owners || []) {
      if (!o || !o.uid || seen.has(o.uid)) continue;
      seen.add(o.uid);
      const st = staff[o.uid];
      const ownerEmail = o.uid === docOwner ? agency.ownerEmail : '';
      own.push({ uid: o.uid, role: 'owner', name: o.name || o.email || o.uid, email: o.email || '', agentKeys: keysOf(st && st.backstageAgent, o.email, ownerEmail), pendingEmail: false });
    }
    return [...explicit, ...byEmail, ...flags, ...own];
  }

  // Nombre de un titular de cartera en listas: con el rol al lado, salvo en
  // los Managers («Ana · Admin»).
  function agencyPortfolioHolderLabel(agency, h) {
    if (!h) return '';
    if (!h.role || h.role === 'manager') return h.name || '';
    const custom = agency && agency.licCustomRoles && agency.licCustomRoles[h.role];
    const role = h.role === 'owner' ? t('agencies_view_owner', 'Owner') : staffRoleLabel(h.role, custom && custom.name);
    return `${h.name} · ${role}`;
  }

  // Owners y managers por agencyRoles de una agencia (más el ownerId del doc
  // si su users no lleva el rol), para agencyPortfolioHolders y «Ver como…».
  // Los da el Worker (agencyPeople 'roles'): el users de otro no se lee.
  async function loadAgencyRoleUsers(agencyId, agency) {
    const owners = [], flagManagers = [];
    if (!agencyId) return { owners, flagManagers };
    const person = (x) => ({ uid: x.uid, email: String(x.email || '').trim(), name: x.displayName || x.email || x.uid });
    let got = false;
    try {
      const res = await agencyPeople(agencyId, 'roles');
      (res.owners || []).forEach((x) => { if (x && x.uid) owners.push(person(x)); });
      (res.managers || []).forEach((x) => { if (x && x.uid) flagManagers.push(person(x)); });
      got = true;
    } catch (e) { console.warn('[Agencias] roles de la agencia:', e.message); }
    // Sin respuesta, al menos el Owner del doc con el correo de la agencia.
    const docOwner = agency && (agency.ownerId || agency.ownerUid);
    if (!got && docOwner) owners.push(person({ uid: docOwner, email: agency.ownerEmail || '' }));
    return { owners, flagManagers };
  }

  // Autor de un documento: la persona simulada (modo Super Owner) o quien lo
  // creó. null en los antiguos.
  function agencyContentAuthor(doc) {
    return (doc && (doc.createdByAs || doc.createdBy)) || null;
  }

  // Rol del autor HOY (su entrada real de licStaff: si le cambian el rol,
  // cambia con él). Sin entrada, el que se guardó al crearlo (storedRole:
  // createdByRole, o authorRole en los comunicados); sin nada, Manager (los
  // managers por flag no siempre tienen nodo en licStaff). La entrada que la
  // consola simula en memoria (__simulated) no es de nadie: no cuenta.
  function agencyContentAuthorRole(agency, authorUid, storedRole) {
    if (!authorUid || agencyIsOwnerUid(agency, authorUid)) return 'owner';
    const st = agency && agency.licStaff && agency.licStaff[authorUid];
    if (st && !st.__simulated) return agencyStaffBaseRole(agency, st.role || 'manager');
    if (storedRole) return agencyStaffBaseRole(agency, storedRole);
    return 'manager';
  }

  // → 'edit' | 'view' | 'hidden'. actor: agencyNewsActor (asUid = la
  // persona simulada en modo Super Owner, con la que se decide qué es "mío"
  // y de quién dependo). authorRole: el guardado en el documento (ver
  // agencyContentAuthorRole).
  function agencyContentAccess(agency, actor, authorUid, authorRole) {
    if (!actor || !actor.uid) return 'hidden';
    const role = agencyStaffBaseRole(agency, actor.role);
    if (role === 'owner' || role === 'super_admin') return 'edit';
    const me = actor.asUid || actor.uid;
    if (authorUid && authorUid === me) return role === 'viewer' ? 'view' : 'edit';
    const author = agencyContentAuthorRole(agency, authorUid, authorRole);
    if (author === 'owner' || author === 'super_admin') return 'view';
    if (role === 'admin') {
      return author === 'manager' && agencyNewsAdminOf(agency, authorUid) === me ? 'edit' : 'hidden';
    }
    // Manager (y Viewer): lo de SU Admin, en solo lectura.
    return author === 'admin' && agencyNewsAdminOf(agency, me) === authorUid ? 'view' : 'hidden';
  }

  // Lo mismo, leyendo autor y rol guardado del propio documento.
  function agencyContentDocAccess(agency, actor, doc) {
    return agencyContentAccess(agency, actor, agencyContentAuthor(doc), doc && (doc.createdByRole || doc.authorRole));
  }

  // Campos de autoría para lo que se crea en la consola: createdBy (quien
  // escribe de verdad), createdByRole (su rol base, por si un día sale de
  // licStaff) y createdByAs (en modo Super Owner simulando a una persona,
  // esa persona: lo creado cuenta como suyo). managerMode: el de la consola;
  // sin él se deduce (staff = tiene entrada en licStaff o no es el dueño ni
  // TikControl viéndola como dueño).
  function agencyContentAuthorFields(agency, managerMode) {
    const uid = (state.currentUser && state.currentUser.uid) || null;
    let staff = managerMode;
    if (typeof staff !== 'boolean') {
      const st = agency && agency.licStaff && agency.licStaff[uid];
      staff = !!st || (!agencyIsOwnerUid(agency, uid) && !(agency && state.superOwnerViewingAgencyId === agency.id));
    }
    const actor = agencyNewsActor(agency, staff);
    return {
      createdBy: actor.uid,
      createdByRole: agencyStaffBaseRole(agency, actor.role),
      createdByAs: actor.asUid && actor.asUid !== actor.uid ? actor.asUid : null,
    };
  }

  // «Subido por Admin: solo lectura.» (aviso o candado de lo ajeno).
  function agencyContentReadOnlyText(agency, doc) {
    const role = agencyContentAuthorRole(agency, agencyContentAuthor(doc), doc && (doc.createdByRole || doc.authorRole));
    const label = ({
      owner: t('agencies_lc_role_owner', 'Dueño de la agencia'),
      super_admin: t('agencies_lc_role_super', 'Super Admin'),
      admin: t('agencies_lc_role_admin', 'Admin'),
      manager: t('agencies_lc_role_manager', 'Manager'),
      viewer: t('agencies_lc_role_viewer', 'Viewer'),
    })[role] || role;
    return t('agencies_own_readonly_by', 'Subido por {role}: solo lectura.').replace('{role}', () => label);
  }

  // ─── DESTACADOS (misiones y eventos) ─────────────────────────
  // Hasta FEATURED_MAX misiones y otros tantos eventos destacados «vivos» por
  // agencia (sin terminar): en la vista del creador salen los primeros, son
  // los del Resumen y llevan marco dorado y estrella. Campos del documento
  // (agency_challenges / agency_events):
  //   featured: true · featuredBy · featuredByName · featuredAt (ms)
  //   featureRequest: { by, byAs, byRole, byName, at } → pendiente de aprobar
  //   featureRejected: { by, byName, at } → último rechazo (lo ve quien pidió)
  // Quién decide, como en los comunicados: Owner y Super Admin destacan y
  // quitan directamente; Admin y Manager lo SOLICITAN y lo aprueba su
  // superior (agencyNewsCanApprove: el Admin, lo de sus managers; Super Admin
  // y Owner, todo). Quitar un destacado: Owner, Super Admin o quien lo aprobó.
  // El creador solo mira `featured === true` (featuredFirst).
  const FEATURED_MAX = 3;

  function featuredRole(agency, actor) {
    return actor && actor.uid ? agencyStaffBaseRole(agency, actor.role) : '';
  }
  // Owner y Super Admin: sin aprobación.
  function featuredCanSetDirect(agency, actor) {
    const role = featuredRole(agency, actor);
    return role === 'owner' || role === 'super_admin';
  }
  // Admin y Manager: lo piden a su superior. Viewer: nada.
  function featuredCanRequest(agency, actor) {
    const role = featuredRole(agency, actor);
    return role === 'admin' || role === 'manager';
  }
  // 'on' (destacado) · 'pending' (solicitado) · 'off'
  function featuredState(doc) {
    if (doc && doc.featured === true) return 'on';
    return doc && doc.featureRequest && doc.featureRequest.by ? 'pending' : 'off';
  }
  function featuredCanApprove(agency, actor, doc) {
    const req = doc && doc.featureRequest;
    if (!req || !req.by || (doc && doc.featured === true)) return false;
    return agencyNewsCanApprove(agency, actor, req.byAs || req.by, req.byRole || null);
  }
  function featuredCanUnset(agency, actor, doc) {
    if (!doc || doc.featured !== true) return false;
    if (featuredCanSetDirect(agency, actor)) return true;
    const me = actor && (actor.asUid || actor.uid);
    return !!me && doc.featuredBy === me;
  }
  // Quien pidió puede retirar su propia solicitud.
  function featuredIsMyRequest(actor, doc) {
    const req = doc && doc.featureRequest;
    const me = actor && (actor.asUid || actor.uid);
    return !!(req && me && (req.byAs || req.by) === me);
  }
  // Nº de destacados que ocupan plaza (isAlive: el doc sigue vivo — misión o
  // evento sin terminar). exceptId: el que se está editando.
  function featuredCount(docs, isAlive, exceptId) {
    return (docs || []).filter(d => d && d.featured === true && d.id !== exceptId && (!isAlive || isAlive(d))).length;
  }
  // Nombre visible de quien actúa (el staff de TikControl firma "TikControl").
  function agencyActorName(agency) {
    if (agency && state.superOwnerViewingAgencyId === agency.id) return 'TikControl';
    const u = state.currentUser || {};
    return u.displayName || u.email || '';
  }
  // Campos a escribir en el documento para cada acción.
  function featuredOnPatch(agency, actor) {
    return {
      featured: true, featuredBy: (actor && (actor.asUid || actor.uid)) || null,
      featuredByName: agencyActorName(agency), featuredAt: Date.now(),
      featureRequest: null, featureRejected: null,
    };
  }
  function featuredOffPatch() {
    return { featured: false, featuredBy: null, featuredByName: null, featuredAt: null, featureRequest: null };
  }
  function featureRequestPatch(agency, actor) {
    return {
      featureRequest: {
        by: (actor && actor.uid) || null,
        byAs: actor && actor.asUid && actor.asUid !== actor.uid ? actor.asUid : null,
        byRole: featuredRole(agency, actor) || null,
        byName: agencyActorName(agency), at: Date.now(),
      },
      featureRejected: null,
    };
  }
  function featureRejectPatch(agency, actor) {
    return {
      featureRequest: null,
      featureRejected: { by: (actor && (actor.asUid || actor.uid)) || null, byName: agencyActorName(agency), at: Date.now() },
    };
  }
  // Los destacados delante (hasta `max`, el más antiguo primero) y el resto
  // en su orden. No muta la lista.
  function featuredFirst(list, max) {
    const cap = max == null ? FEATURED_MAX : max;
    const featured = (list || []).filter(d => d && d.featured === true)
      .sort((a, b) => (Number(a.featuredAt) || 0) - (Number(b.featuredAt) || 0))
      .slice(0, cap);
    const picked = new Set(featured);
    return [...featured, ...(list || []).filter(d => !picked.has(d))];
  }
  function isFeatured(doc, list, max) {
    if (!doc || doc.featured !== true) return false;
    return !list || featuredFirst(list, max).slice(0, max == null ? FEATURED_MAX : max).includes(doc);
  }

  // ─── TUTORIALES DE LA AGENCIA: quién ve qué ──────────────────
  // Publicado = status 'published', o 'scheduled' con su fecha ya vencida
  // (no hace falta que nadie lo "publique": basta con que llegue la hora).
  // Los anteriores a los estados de Recursos › Tutoriales no tienen status
  // y siempre fueron visibles.
  function trainingIsPublished(doc) {
    if (!doc) return false;
    if (!doc.status || doc.status === 'published') return true;
    return doc.status === 'scheduled' && !!doc.publishAt && new Date(doc.publishAt).getTime() <= Date.now();
  }

  // ¿El creador está entre los destinatarios? audience: { type: 'all' |
  // 'levels' | 'tags' | 'groups' | 'creators', levels, tagIds, groupIds,
  // creatorIds }. viewer: { uid, level, tagIds, groupIds }. Sin audiencia =
  // todos. Las etiquetas (Rookie, Senior…) son las de Creadores › Añadir
  // etiqueta: agency.creatorTags + agency.creatorTagMap[uid].
  function audienceIncludes(audience, viewer) {
    const a = audience && typeof audience === 'object' ? audience : {};
    if (a.type === 'levels') return Array.isArray(a.levels) && a.levels.includes(viewer.level);
    if (a.type === 'tags') return Array.isArray(a.tagIds) && a.tagIds.some(id => (viewer.tagIds || []).includes(id));
    if (a.type === 'groups') return Array.isArray(a.groupIds) && a.groupIds.some(id => (viewer.groupIds || []).includes(id));
    if (a.type === 'creators') return Array.isArray(a.creatorIds) && a.creatorIds.includes(viewer.uid);
    return true;
  }

  // Tutoriales que ve un creador: publicados y, además, o independientes con
  // él entre sus destinatarios, o dentro de una formación (collections: docs
  // de agency_courses) a la que tiene acceso. Los anteriores al asistente
  // son independientes.
  function trainingVisibleTo(tutorials, collections, viewer) {
    const viaCollection = new Set();
    (collections || []).forEach(c => {
      if (audienceIncludes(c.audience, viewer)) (c.tutorialIds || []).forEach(id => viaCollection.add(id));
    });
    return tutorials.filter(doc => trainingIsPublished(doc)
      && ((doc.standalone !== false && audienceIncludes(doc.audience, viewer)) || viaCollection.has(doc.id)));
  }

  // ─── PERFILES LIVE DE LA AGENCIA: cuáles ve un creador ───────
  // Los activos (un borrador de Recursos › Perfiles LIVE no llega a nadie; los
  // anteriores a los estados no tienen status y siempre se vieron) que le
  // tocan: para todos, o con su uid en la selección — que ha vivido en
  // selectedMembers, en creatorIds y, en los más antiguos, en assignedTo.
  // Primero los que la agencia ha destacado (lo decide su dueño, Super Admin
  // o Admin) y, dentro de cada grupo, los más recientes. maxProfiles
  // (opcional): tope del plan — los perfiles que sobran (los más nuevos,
  // agencyProfilesOverLimit) no llegan a nadie.
  function agencyProfilesVisibleTo(profiles, uid, maxProfiles) {
    const picked = p => [p.selectedMembers, p.creatorIds, p.assignedTo].some(list => Array.isArray(list) && list.includes(uid));
    const recency = p => missionToMs(p.updatedAt || p.createdAt);
    const locked = agencyProfilesOverLimit(profiles, maxProfiles);
    return (profiles || [])
      .filter(p => p && p.status !== 'draft' && !locked.has(p.id) && (p.assignedTo === 'all' || !p.assignedTo || picked(p)))
      .sort((a, b) => (b.featured === true) - (a.featured === true) || recency(b) - recency(a));
  }

  // Tope de perfiles LIVE del plan: se pueden crear más, pero los que sobran
  // quedan en gris (no se usan ni llegan a los creadores) hasta borrar otro o
  // mejorar el plan — como los perfiles locales al pasar de Premium a Free.
  // Cuentan los activos (un borrador no ocupa plaza: pasar uno a borrador
  // libera un hueco), por orden de creación: los primeros `max` siguen; el
  // resto, no. → Set de ids fuera del tope.
  function agencyProfilesOverLimit(profiles, max) {
    const limit = Number(max);
    const list = (profiles || []).filter(p => p && p.status !== 'draft');
    if (!(limit > 0) || limit >= 9999 || list.length <= limit) return new Set();
    const byCreation = list.slice().sort((a, b) => missionToMs(a.createdAt) - missionToMs(b.createdAt) || String(a.id).localeCompare(String(b.id)));
    return new Set(byCreation.slice(limit).map(p => p.id));
  }

  // Destinatarios de un comunicado según su regla de audiencia (Recursos ›
  // Comunicados): { type: 'groups', groupIds } → los creadores que hay AHORA
  // en esos grupos (Creadores › Grupos) · { type: 'creators', creatorIds } →
  // esos uids · cualquier otra cosa → null, que es "todos".
  function agencyNewsRecipients(agency, rule) {
    const r = rule && typeof rule === 'object' ? rule : {};
    const unique = list => [...new Set((Array.isArray(list) ? list : []).filter(id => typeof id === 'string' && id))];
    if (r.type === 'creators') return unique(r.creatorIds);
    if (r.type === 'tags') {
      const tags = unique(r.tagIds);
      const map = (agency && agency.creatorTagMap && typeof agency.creatorTagMap === 'object') ? agency.creatorTagMap : {};
      return unique(Object.keys(map).filter(uid => (Array.isArray(map[uid]) ? map[uid] : []).some(id => tags.includes(id))));
    }
    if (r.type !== 'groups') return null;
    const chosen = unique(r.groupIds);
    const groups = (Array.isArray(agency && agency.creatorGroups) ? agency.creatorGroups : []).filter(g => chosen.includes(g.id));
    return unique(groups.flatMap(g => g.creatorIds));
  }

  // Fan-out de notificaciones a los destinatarios de un mensaje/noticia.
  // audienceUids (opcional) limita el envío a esos creadores — una lista
  // vacía no avisa a nadie; si no se pasa, va a todos los miembros aprobados
  // de la agencia.
  async function notifyAgencyNews(agencyId, agencyName, newsId, title, body, audienceUids) {
    let uids = Array.isArray(audienceUids) ? [...new Set(audienceUids.filter(Boolean))] : null;
    if (!uids) {
      const snap = await db().collection('agency_members')
        .where('agencyId', '==', agencyId)
        .where('status', '==', 'approved').get();
      const set = new Set();
      snap.forEach(d => { const uid = d.data().userId; if (uid) set.add(uid); });
      uids = [...set];
    }
    if (!uids.length) return 0;
    // Firestore limita cada batch a 500 escrituras.
    for (let i = 0; i < uids.length; i += 450) {
      const batch = db().batch();
      uids.slice(i, i + 450).forEach(uid => {
        const ref = db().collection('users').doc(uid).collection('notifications').doc();
        batch.set(ref, {
          type: 'communication', title: title || '', body: String(body || '').substring(0, 120),
          read: false, createdAt: serverTimestamp(),
          sourceId: newsId, agencyId, agencyName: agencyName || '',
        });
      });
      await batch.commit();
    }
    return uids.length;
  }

  // Entrega los mensajes programados vencidos de la agencia. No hay cron de
  // backend, así que cualquier sesión Owner/Manager que abra la consola
  // entrega lo pendiente. La reclamación es una transacción (scheduled →
  // sent) para que dos sesiones simultáneas no dupliquen el envío.
  async function deliverDueAgencyNews(agency) {
    const agencyId = agency && agency.id;
    if (!agencyId) return 0;
    const due = [];
    try {
      const snap = await db().collection('agency_news')
        .where('agencyId', '==', agencyId)
        .where('status', '==', 'scheduled').get();
      const now = Date.now();
      snap.forEach(d => {
        const data = d.data();
        const at = data.scheduledFor ? new Date(data.scheduledFor).getTime() : 0;
        if (at && at <= now) due.push({ id: d.id, ...data });
      });
    } catch (e) { console.warn('[Agencias] scheduled query:', e.message); return 0; }
    let delivered = 0;
    for (const item of due) {
      const ref = db().collection('agency_news').doc(item.id);
      // Un comunicado con regla de audiencia llega a quien esté en sus grupos
      // AHORA, no a quien estaba cuando se programó: sus uids se recalculan.
      const uids = item.audienceRule ? agencyNewsRecipients(agency, item.audienceRule)
        : (Array.isArray(item.audienceUids) ? item.audienceUids : null);
      try {
        const claimed = await db().runTransaction(async trx => {
          const doc = await trx.get(ref);
          if (!doc.exists || doc.data().status !== 'scheduled') return false;
          trx.update(ref, { status: 'sent', sentAt: serverTimestamp(), ...(item.audienceRule ? { audience: uids ? 'group' : 'all', audienceUids: uids } : {}) });
          return true;
        });
        if (!claimed) continue;
        await notifyAgencyNews(agencyId, agency.name, item.id, item.title, item.content, uids);
        delivered++;
      } catch (e) { console.warn('[Agencias] scheduled deliver:', item.id, e.message); }
    }
    return delivered;
  }

  // ─── REGISTRO DE ACTIVIDAD DE LA AGENCIA (auditoría) ────────
  // Append-only en agency_activity: quién hizo qué y en qué módulo. Lo lee
  // el bloque "Historial de cambios" de la pestaña Agencia. Best effort:
  // nunca rompe la acción principal si falla la escritura.
  // `extra` (opcional): campos planos adicionales para poder filtrar después
  // (p. ej. eventKey del evento sobre el que se actuó, count de destinatarios).
  async function logAgencyActivity(agency, action, module, detail, roleOverride, extra) {
    try {
      if (!agency || !agency.id) return;
      const u = state.currentUser || {};
      const uid = u.uid || null;
      let role = roleOverride || 'member';
      if (!roleOverride) {
        // Los módulos que solo tienen el id a mano llaman con { id } sin el
        // doc completo: ownerAgencyIds cubre entonces la detección de owner.
        if (uid && (agency.ownerId === uid || agency.ownerUid === uid || (Array.isArray(state.ownerAgencyIds) && state.ownerAgencyIds.includes(agency.id)))) role = 'owner';
        else if (state.isAdmin === true) role = 'admin';
        else if (state.isManager && (state.managerAgencyId === agency.id || (Array.isArray(state.managerAgencyIds) && state.managerAgencyIds.includes(agency.id)))) role = 'manager';
      }
      let userName = u.displayName || u.email || '';
      // Staff de TikControl dentro de la consola de esta agencia (modo Super
      // Owner, simule el rol que simule): la autoría visible es SIEMPRE
      // "TikControl", nunca la persona suplantada ni la cuenta del staff.
      // Gana también a roleOverride. El uid real se conserva para auditoría.
      if (state.superOwnerViewingAgencyId && state.superOwnerViewingAgencyId === agency.id) {
        userName = 'TikControl';
        role = 'tikcontrol';
      }
      const more = {};
      if (extra && typeof extra === 'object') {
        Object.keys(extra).forEach(k => {
          const v = extra[k];
          if (v === undefined || v === null) return;
          if (typeof v === 'string') more[k] = v.substring(0, 200);
          else if (typeof v === 'number' || typeof v === 'boolean') more[k] = v;
        });
      }
      await db().collection('agency_activity').add({
        agencyId: agency.id,
        at: serverTimestamp(),
        uid,
        userName,
        role,
        action: String(action || ''),
        module: String(module || ''),
        detail: String(detail || '').substring(0, 200),
        ...more,
      });
    } catch (e) { console.warn('[Agencias] activity log:', e.message); }
  }

  // ─── Región de la agencia: <option> agrupadas por zona ───────
  // Las usan «Editar vista pública» de la consola (owner-console/
  // public-view.js, que es quien edita la vista pública) y el alta del
  // Explorador, y los selectores del panel Admin. emptyLabel: texto de la
  // opción vacía (por defecto «Sin configurar»); opts.empty === false, sin ella.
  // El value es la región tal cual se guarda ('EU / España'); lo que se ve, el
  // país y su zona en el idioma de la app (AgenciasRegionGeo).
  function agencyRegionOptionsHtml(current, emptyLabel, opts) {
    const esc = v => String(v == null ? '' : v).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const Geo = window.AgenciasRegionGeo;
    const place = r => (Geo ? Geo.placeName(r) : (String(r).split(' / ')[1] || r));
    const zone = g => (Geo && Geo.groupLabel(g)) || g;
    const groups = {};
    const loose = [];
    REGIONS.forEach(r => {
      if (!String(r).includes(' / ')) { loose.push(r); return; }   // «Otro»
      const g = String(r).split(' / ')[0];
      (groups[g] = groups[g] || []).push(r);
    });
    const custom = current && !REGIONS.includes(current)
      ? `<option value="${esc(current)}" selected>${esc(Geo ? Geo.fullLabel(current) : current)}</option>` : '';
    const empty = opts && opts.empty === false ? ''
      : `<option value="">${esc(emptyLabel || t('agencies_library_not_configured', 'Sin configurar'))}</option>`;
    return empty + custom +
      Object.entries(groups).map(([g, list]) =>
        `<optgroup label="${esc(zone(g))}">${list.map(r =>
          `<option value="${esc(r)}" ${r === current ? 'selected' : ''}>${esc(place(r))}</option>`).join('')}</optgroup>`).join('') +
      loose.map(r => `<option value="${esc(r)}" ${r === current ? 'selected' : ''}>${esc(place(r))}</option>`).join('');
  }

  // ═══════════════════════════════════════════════════════════
  // BORRADO DE AGENCIA EN CASCADA
  // ═══════════════════════════════════════════════════════════
  // El id de la agencia lo escribe el admin a mano (ORYXAGENCY, …), así que
  // se REUTILIZA al recrearla. Si al borrar solo se quita agencies/{id}, todo
  // lo que cuelga de ese id sigue vivo y reaparece en la agencia nueva:
  // creadores importados del backstage, misiones, eventos, roles OWNER_… y
  // hasta la sesión del portal. Aquí se barre todo lo que lleva ese agencyId.

  // Colecciones con campo agencyId (documentos sueltos por agencia).
  const AGENCY_SCOPED_COLLECTIONS = [
    'agency_members', 'agency_activity', 'agency_challenges', 'agency_events',
    'agency_library_assets', 'agency_library_folders', 'agency_manager_assignments',
    'agency_manager_credits', 'agency_news', 'agency_overlays', 'agency_profiles',
    'agency_recommended_actions', 'agency_training', 'agency_courses',
    'tiktok_manager_requests',
  ];

  // Borra refs en lotes (el batch de Firestore admite 500 operaciones).
  async function deleteRefsInBatches(refs) {
    let done = 0;
    for (let i = 0; i < refs.length; i += 400) {
      const slice = refs.slice(i, i + 400);
      const batch = db().batch();
      slice.forEach((r) => batch.delete(r));
      await batch.commit();
      done += slice.length;
    }
    return done;
  }

  // Quita el rol de la agencia (agencyRoles.<id>) y las marcas legacy
  // OWNER_<id> / MANAGER_<id> / SUPEROWNER_<id> de los usuarios. Sin esto,
  // al recrear la agencia con el mismo id los antiguos owners/managers
  // vuelven a tener acceso solos.
  async function stripAgencyRoles(agencyId) {
    const roleOwner = 'OWNER_' + agencyId;
    const roleManager = 'MANAGER_' + agencyId;
    const roleSuperOwner = 'SUPEROWNER_' + agencyId;
    const FV = window.firebase?.firestore?.FieldValue;
    if (!FV) return 0;
    const found = new Map();
    const queries = [
      db().collection('users').where('agencyRoles.' + agencyId, 'in', ['owner', 'manager']),
      db().collection('users').where(roleOwner, '==', true),
      db().collection('users').where(roleManager, '==', true),
      db().collection('users').where(roleSuperOwner, '==', true),
      db().collection('users').where('role', 'in', [roleOwner, roleManager, roleSuperOwner]),
      db().collection('users').where('roles', 'array-contains-any', [roleOwner, roleManager, roleSuperOwner]),
    ];
    for (const q of queries) {
      try {
        const snap = await q.get();
        snap.forEach((d) => { if (!found.has(d.id)) found.set(d.id, d.data() || {}); });
      } catch (e) { console.warn('[Agencias] roles query:', e.message); }
    }
    let n = 0;
    for (const [uid, data] of found) {
      const patch = { ...agencyRolePatch(agencyId, null), [roleSuperOwner]: FV.delete() };
      if (data.role === roleOwner || data.role === roleManager || data.role === roleSuperOwner) patch.role = FV.delete();
      if (Array.isArray(data.roles)) patch.roles = FV.arrayRemove(roleOwner, roleManager, roleSuperOwner);
      if (data.agencyId === agencyId) patch.agencyId = FV.delete();
      try { await db().collection('users').doc(uid).update(patch); n++; }
      catch (e) { console.warn('[Agencias] roles patch', uid, e.message); }
    }
    return n;
  }

  // Rastro local de la agencia en ESTA máquina: sesión del portal del
  // backstage (partición propia) y marcas de sync/consentimiento.
  async function clearAgencyLocalData(agencyId) {
    try { await window.tikcontrol?.agencyBackstageDisconnect?.({ agencyId }); }
    catch (e) { console.warn('[Agencias] backstage disconnect:', e.message); }
    try {
      for (let i = localStorage.length - 1; i >= 0; i--) {
        const k = localStorage.key(i);
        if (!k) continue;
        if ((k.startsWith('tc_bs_') || k.startsWith('tc_agc_')) && k.endsWith('_' + agencyId)) localStorage.removeItem(k);
      }
      for (const k of ['tc_agc_active_owner', 'tc_agc_active_manager', 'tc_agc_active_superowner']) {
        if (localStorage.getItem(k) === agencyId) localStorage.removeItem(k);
      }
    } catch (e) { /* noop */ }
  }

  /**
   * Borra una agencia Y todo lo que cuelga de ella.
   * onProgress(label, index, total) para pintar el avance.
   * Devuelve { deleted: {coleccion: n}, roles, errors: [] }.
   */
  async function deleteAgencyCascade(agencyId, onProgress) {
    if (!agencyId) return { deleted: {}, roles: 0, errors: ['no_agency_id'] };
    const out = { deleted: {}, roles: 0, errors: [] };
    const steps = AGENCY_SCOPED_COLLECTIONS.length + 5;
    let step = 0;
    const tick = (label) => { step++; try { onProgress && onProgress(label, step, steps); } catch (e) { /* noop */ } };

    for (const col of AGENCY_SCOPED_COLLECTIONS) {
      tick(col);
      try {
        const snap = await db().collection(col).where('agencyId', '==', agencyId).get();
        const refs = [];
        snap.forEach((d) => refs.push(d.ref));
        out.deleted[col] = await deleteRefsInBatches(refs);
      } catch (e) {
        out.errors.push(col + ': ' + e.message);
        console.warn('[Agencias] cascade', col, e.message);
      }
    }

    // Whitelist (doc por agencia + subcolección de entradas).
    tick('agency_whitelists');
    try {
      const wl = await db().collection('agency_whitelists').doc(agencyId).collection('users').get();
      const refs = [];
      wl.forEach((d) => refs.push(d.ref));
      out.deleted.agency_whitelists = await deleteRefsInBatches(refs);
      try { await db().collection('agency_whitelists').doc(agencyId).delete(); } catch (e) { /* puede no existir */ }
    } catch (e) { out.errors.push('agency_whitelists: ' + e.message); }

    // Historial de licencias (subcolección del propio doc de agencia).
    tick('licenseLogs');
    try {
      const logs = await db().collection('agencies').doc(agencyId).collection('licenseLogs').get();
      const refs = [];
      logs.forEach((d) => refs.push(d.ref));
      out.deleted.licenseLogs = await deleteRefsInBatches(refs);
    } catch (e) { out.errors.push('licenseLogs: ' + e.message); }

    // Roles de usuarios + rastro local.
    tick('roles');
    try { out.roles = await stripAgencyRoles(agencyId); }
    catch (e) { out.errors.push('roles: ' + e.message); }
    await clearAgencyLocalData(agencyId);

    // La agencia, al final: si algo falla antes, el doc sigue ahí y se puede
    // reintentar el borrado en vez de dejar huérfano todo lo demás.
    tick('agencies');
    await db().collection('agencies').doc(agencyId).delete();

    // Lo que no está en Firestore o solo puede tocar el Worker: licencias de
    // sus creadores (reanuda el cobro que pausó la agencia y les devuelve su
    // plan), Backstage y archivos en R2, tracking en D1, colecciones del
    // Worker y KV. Solo actúa con el doc ya borrado (cf-worker ›
    // api/backofficeAgencyPurge.js); repetirlo termina lo que quede.
    tick('limpieza');
    out.purge = await purgeDeletedAgency(agencyId);
    if (out.purge.error) out.errors.push('limpieza: ' + out.purge.error);
    else (out.purge.report?.errors || []).forEach((e) => out.errors.push('limpieza · ' + e));
    return out;
  }

  // POST /api/backoffice/agencies/purge (solo ADMIN). Nunca lanza.
  async function purgeDeletedAgency(agencyId) {
    try {
      const user = auth() && auth().currentUser;
      if (!user || typeof user.getIdToken !== 'function') return { error: 'not_signed_in' };
      const res = await fetch(apiBase() + '/api/backoffice/agencies/purge', {
        method: 'POST',
        headers: { Authorization: 'Bearer ' + await user.getIdToken(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ agencyId }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) return { error: data.error || ('HTTP ' + res.status) };
      return { report: data.report || null };
    } catch (e) {
      return { error: e.message };
    }
  }

  // ─── PUBLIC API ───────────────────────────────────────────
  return {
    ICO,
    PLANS,
    PLAN_ORDER,
    PLAN_FEATURE_KEYS,
    ANIM_PACKS,
    ANIM_ITEMS,
    HIGHLIGHT_LEVELS,
    HIGHLIGHT_ORDER,
    highlightRank,
    UNLIMITED,
    agencyPlan,
    agencyTrial,
    agencyGrace,
    graceLeftLabel,
    GRACE_DEFAULT_HOURS,
    trialLeftLabel,
    trialLeftShort,
    planHas,
    planRank,
    minPlanFor,
    planUsageIssues,
    loadPlanUsage,
    planIssuesHtml,
    isUnlimited,
    limitLabel,
    LICENSE_TYPES,
    REGIONS,
    agencyRegionOptionsHtml,
    BADGES,
    state,
    db,
    auth,
    serverTimestamp,
    arrayUnion,
    arrayRemove,
    deleteField,
    // Roles de agencia (mapa protegido users.agencyRoles)
    agencyRoleOf,
    agencyRoleIds,
    agencyRolePatch,
    t,
    toast,
    formatDate,
    // Idioma de fechas y cifras (el de TikControl, no el de Windows)
    appLang, locale, formatDateWith, formatDateTime, formatTime, formatNum, formatMonthKey,
    wireCharCounter,
    AGENCY_DESCRIPTION_MAX,
    formatNumber,
    rankingPositionText,
    CURRENCIES, DEFAULT_CURRENCY, normCurrency, currencySymbol, formatMoney,
    formatPlanBadge,
    formatStatusBadge,
    truncate,
    timeSince,
    // URL helpers
    isCloudUrl,
    safeImgUrl,
    // Formas de contacto de la agencia
    AGENCY_CONTACT_TYPES,
    normalizeAgencyContact,
    // Web escrita con o sin https:// → URL http(s) válida, o '' si no lo es.
    normalizeWebUrl: _contactHttpUrl,
    agencyContactMethodsRaw,
    agencyContactMethods,
    apiBase,
    licenseApi,
    agencyPeople,
    AGENCY_PEOPLE_LIMITS,
    agencyIsPublished,
    agencyHiddenTo,
    publishAgency,
    sendOwnerWelcome,
    STAFF_PROFILE_NAME_MAX,
    loadStaffProfile,
    myStaffProfile,
    saveStaffProfile,
    licenseErrorText,
    // Data loaders
    loadAllAgencies,
    loadAllAgenciesIfAdmin,
    launchOnly,
    loadAgency,
    loadAgencyMembers,
    refreshAgencyStats,
    loadAgencyEvents,
    loadTiktokEvents,
    loadUserStats,
    calculateMissionProgress,
    calculateMissionProgressFull,
    calculateMissionProgressMerged, courseMissionProgress, missionMonthCovered, memberMonthMetrics, memberSyncedAt,
    missionSecondaryGoals,
    missionToMs,
    missionEndMs,
    missionStatus,
    missionIsOngoing,
    missionIsRelative, missionRelativeDays, memberJoinedMs, missionMemberDeadlineMs, missionForMember, missionIncludesViewer, relativeDeadlineLabel,
    missionTargetUids,
    missionIncludes,
    missionTouches,
    missionDetailHtml,
    missionTitleParts: _mdSplitName,
    missionPrizeList,
    missionWonPrizes,
    missionNextPhasePrizes,
    missionPartMeta,
    missionOwnImage,
    openImageLightbox,
    loadUserMembership,
    // Role detection
    detectUserRole,
    healRenamedTikTok,
    // Stats collector (arranque headless desde Inicio o la pestaña)
    hasActiveMembership,
    ensureStatsCollector,
    stopStatsCollector,
    // Borrado en cascada
    deleteAgencyCascade,
    AGENCY_SCOPED_COLLECTIONS,
    // Multi-agencia (varias agencias por rol)
    setActiveRoleAgency,
    loadRoleAgencies,
    loadStaffAgencies,
    staffRoleLabel,
    roleAgencyName,
    // Dynamic checks
    checkPendingInvitation,
    checkWhitelists,
    // Dynamic actions
    joinAgencyFromWhitelist,
    acceptInvitation,
    rejectInvitation,
    leaveAgency,
    checkDualSubscription,
    // TikTok Manager
    loadTiktokManagerApprovedAgencies,
    sendTiktokManagerRequest,
    sendRecommendedAction,
    loadRecommendedActions,
    loadTiktokManagerRequests,
    respondTiktokManagerRequest,
    revokeTiktokManager,
    // Realtime listeners
    cleanupRealtimeListeners,
    watchUserDocument,
    watchInvitations,
    watchAgency,
    watchMembership,
    // UI helpers
    spinner,
    emptyState,
    morphHtml,
    showModal,
    closeModal,
    confirmDialog,
    showEventDetailModal,
    openGiftPicker,
    safeGiftImgUrl,
    getGiftsList,
    uploadAgencyImage,
    openImageCropper,
    uploadAgencyFile,
    deleteAgencyFile,
    readFileAsBase64,
    resolveCreatorAvatar,
    // Agency news y tutoriales (Recursos)
    agencyNewsIsPublished,
    agencyNewsActor,
    agencyNewsStaffRole,
    agencyNewsAdminOf,
    agencyNewsTrusted,
    agencyNewsUidTrusted,
    agencyNewsTrustBlock,
    agencyNewsTrustBlockText,
    agencyNewsTrustPatch,
    agencyNewsCanApprove,
    agencyNewsCanDelete,
    FEATURED_MAX,
    featuredCanSetDirect,
    featuredCanRequest,
    featuredState,
    featuredCanApprove,
    featuredCanUnset,
    featuredIsMyRequest,
    featuredCount,
    featuredOnPatch,
    featuredOffPatch,
    featureRequestPatch,
    featureRejectPatch,
    featuredFirst,
    isFeatured,
    agencyActorName,
    agencyIsOwnerUid,
    agencyStaffBaseRole,
    agencyCanHoldPortfolio,
    agencyPortfolioHolders,
    agencyPortfolioHolderLabel,
    loadAgencyRoleUsers,
    agencyContentAuthor,
    agencyContentAuthorRole,
    agencyContentAccess,
    agencyContentDocAccess,
    agencyContentAuthorFields,
    agencyContentReadOnlyText,
    agencyNewsRecipients,
    notifyAgencyNews,
    deliverDueAgencyNews,
    trainingIsPublished,
    audienceIncludes,
    ticketsModeOf,
    ticketsEnabled,
    ticketsWhitelistOf,
    ticketGoesAuto,
    ticketsAutoUsedThisMonth,
    trainingVisibleTo,
    agencyProfilesVisibleTo,
    agencyProfilesOverLimit,
    // Auditoría (Historial de la pestaña Agencia)
    logAgencyActivity,
    // ¿La consola está montada en modo Super Owner (staff TikControl dentro
    // de una agencia ajena)? Los módulos que registran autoría (Licencias,
    // Misiones, Eventos…) firman entonces como "TikControl".
    superOwnerActing: () => !!state.superOwnerViewingAgencyId,
    // Super Owner protegido (solo lectura por defecto, marca de agua y
    // registro): ver «SUPER OWNER PROTEGIDO».
    superOwnerReadOnly,
    superOwnerBlocks,
    superOwnerReadOnlyText,
    startSuperOwnerSession,
    endSuperOwnerSession,
    setSuperOwnerEdit,
    superOwnerLog,
    showSuperOwnerWatermark,
    // Recortes de logo y banner (galerías de «Editar vista pública»,
    // owner-console/public-view.js)
    CROP_LOGO,
    CROP_BANNER
  };

  async function getGiftsList() {
    if (typeof window.getCachedGifts === 'function') {
      const g = window.getCachedGifts();
      if (g && g.length) return g;
    }
    if (Array.isArray(window._giftsList) && window._giftsList.length) return window._giftsList;
    const giftRegion = window.i18n?.getGiftRegion?.() || '';
    try {
      if (window.tikcontrol && typeof window.tikcontrol.invoke === 'function') {
        const data = await window.tikcontrol.invoke('gifts:fetch', giftRegion);
        if (data?.gifts?.length) { window._giftsList = data.gifts; return data.gifts; }
      }
      const res = await fetch(`/api/gifts/catalog${giftRegion ? '?region=' + giftRegion : ''}`);
      if (res.ok) {
        const data = await res.json();
        const gifts = Array.isArray(data?.gifts) ? data.gifts : [];
        if (gifts.length) { window._giftsList = gifts; return gifts; }
      }
    } catch (_) {}
    return [];
  }

  // URL de imagen de regalo: las de TikTok CDN se usan TAL CUAL (safeImgUrl
  // las reescribe con plantilla/expiry y rompe la imagen); el resto sí pasa
  // por safeImgUrl. Misma regla que los avatares de creador.
  function safeGiftImgUrl(src) {
    const s = String(src || '').trim();
    if (!s) return '';
    if (/tiktokcdn|tiktok\.com/i.test(s)) return s.startsWith('https://') ? s : '';
    return safeImgUrl(s);
  }

  function openGiftPicker(anchorEl, opts = {}) {
    const { currentGift, onSelect } = opts;
    if (typeof onSelect !== 'function') return;

    let fp = document.getElementById('ag-gift-picker');
    if (fp) fp.remove();

    fp = document.createElement('div');
    fp.id = 'ag-gift-picker';
    fp.style.cssText = 'position:fixed;z-index:100010;background:#0f1623;border:1px solid #28384e;border-radius:12px;padding:12px;width:320px;max-height:400px;display:flex;flex-direction:column;gap:8px;box-shadow:0 8px 32px rgba(0,0,0,.6);';

    const filterBox = document.createElement('input');
    filterBox.placeholder = t('agencies_gift_search', 'Buscar regalo...');
    filterBox.style.cssText = 'width:100%;padding:7px 10px;background:#162130;border:1px solid #253349;border-radius:8px;font-size:12px;color:#d0d8e4;outline:none;';

    const grid = document.createElement('div');
    grid.style.cssText = 'display:grid;grid-template-columns:repeat(auto-fill,minmax(70px,1fr));gap:6px;overflow-y:auto;max-height:300px;padding:4px 0;';

    let avail = [];

    function getGiftImage(gift) {
      let src = gift.image || gift.picture;
      if (!src && gift.pictureList && Array.isArray(gift.pictureList) && gift.pictureList.length) src = gift.pictureList[0];
      if (src && typeof src === 'object' && src.url_list && Array.isArray(src.url_list)) src = src.url_list[0];
      return (typeof src === 'string') ? src : '';
    }

    function render(list) {
      grid.innerHTML = '';
      if (!list.length) {
        grid.innerHTML = '<div style="grid-column:1/-1;text-align:center;padding:20px;color:#94a3b8;font-size:12px;">' + t('agencies_no_gifts_found', 'No se encontraron regalos') + '</div>';
        return;
      }
      list.forEach(gift => {
        const imgSrc = getGiftImage(gift);
        const diamondVal = gift.diamondValue || gift.diamond || gift.coin || 0;
        const isSelected = currentGift && String(gift.id) === String(currentGift.id || currentGift);
        const btn = document.createElement('button');
        btn.style.cssText = `border:1px solid ${isSelected ? '#4fa3ff' : '#253349'};background:${isSelected ? 'rgba(79,163,255,0.1)' : '#172131'};border-radius:8px;padding:6px 4px;display:flex;flex-direction:column;align-items:center;gap:3px;cursor:pointer;min-height:76px;transition:all .15s;`;
        btn.innerHTML = `
          ${imgSrc ? `<img src="${safeGiftImgUrl(imgSrc)}" style="width:36px;height:36px;object-fit:contain;" onerror="this.style.display='none'">` : `<div style="width:36px;height:36px;background:#333;border-radius:6px;display:flex;align-items:center;justify-content:center;">${ICO.gift}</div>`}
          <span style="font-size:9px;color:#dcddde;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-weight:500;">${gift.name || '?'}</span>
          <span style="font-size:8px;color:#ffd700;font-weight:600;">${diamondVal} ${ICO.diamond}</span>
        `;
        btn.addEventListener('click', () => {
          onSelect({ id: gift.id, name: gift.name || '?', image: imgSrc, diamond: diamondVal });
          closePicker();
        });
        btn.addEventListener('mouseenter', () => { btn.style.borderColor = '#4fa3ff'; });
        btn.addEventListener('mouseleave', () => { if (!isSelected) btn.style.borderColor = '#253349'; });
        grid.appendChild(btn);
      });
    }

    function applyFilter() {
      const q = (filterBox.value || '').trim().toLowerCase();
      render(q ? avail.filter(g => (g.name || '').toLowerCase().includes(q) || String(g.id).includes(q)) : avail);
    }

    filterBox.addEventListener('input', applyFilter);
    fp.appendChild(filterBox);
    fp.appendChild(grid);
    document.body.appendChild(fp);

    const rect = anchorEl.getBoundingClientRect();
    const left = Math.min(window.innerWidth - 340, Math.max(10, rect.left));
    const topBelow = rect.bottom + 6;
    const topAbove = rect.top - 410;
    fp.style.left = left + 'px';
    fp.style.top = (topBelow + 400 > window.innerHeight && topAbove > 0 ? topAbove : topBelow) + 'px';

    function closePicker() {
      try { fp.remove(); } catch (_) {}
      document.removeEventListener('mousedown', outsideClick);
      document.removeEventListener('keydown', escKey);
    }
    function outsideClick(e) { if (!fp.contains(e.target) && e.target !== anchorEl) closePicker(); }
    function escKey(e) { if (e.key === 'Escape') closePicker(); }
    document.addEventListener('mousedown', outsideClick);
    document.addEventListener('keydown', escKey);

    (async () => {
      grid.innerHTML = '<div style="grid-column:1/-1;text-align:center;padding:20px;color:#94a3b8;font-size:12px;">' + spinner(t('agencies_loading_gifts', 'Cargando regalos...')) + '</div>';
      avail = await getGiftsList();
      applyFilter();
      filterBox.focus();
    })();
  }
})();
